/* ============================================================
   LEVA PROFILE CORE  --  assets/leva-profile.js  --  prof-v273
   Loaded by sections/budget-central.liquid, after the markup and
   before the LAYER ZONE, so window.LevaProfile exists by the time
   layers register. All strings come from data-t-* attributes on
   the root element, so nothing user facing lives in here.
   ============================================================ */

/* ============================================================
   LEVA PROFILE CORE  --  prof-v273
   Do not edit this block when adding features. Add a layer
   instead, in the LAYER ZONE at the bottom of this file.
   ============================================================ */
(function () {
  var VERSION = 'prof-v281';   /* prof-v281 (2026-10-27): no change in this module -- the LevaThreads change sits in the bic module below (bic-v184) (2026-10-27): LevaThreads.list carries an answered request's figures (offerFigures) for the assistant's offers card */
  var DRAWER_ID = 'Leva-Profile-Drawer';

  var CORE_FIELDS = [
    'name', 'handle', 'country', 'followers',
    'photo_url', 'bio', 'instagram', 'youtube', 'tiktok',
    'facebook', 'pinterest', 'x', 'linkedin', 'web',
    'is_vendor', 'email', 'phone',
    'address', 'lat', 'lon', 'radius_km', 'price_visibility', 'paywall_url', 'currency',
    'patreon', 'bmac', 'gumroad', 'substack'
  ];

  var state = {
    version: VERSION,
    isAdmin: false,
    // Central exposes __centralCustomerIdFromLiquid, the product page
    // uses customerId. Take whichever the page happens to provide.
    cid: (window.__centralCustomerIdFromLiquid
      || window.customerId
      || window.BudgetSharingCustomerId
      || '').toString().trim(),
    view: null,
    viewStatus: 'none',
    viewMiss: false,
    demo: null,
    loggedIn: false,
    ready: false,
    mounted: false,
    open: false,
    profile: null,
    status: 'none'
  };

  var root = document.querySelector('[data-leva-prof]');
  var drawer = document.getElementById(DRAWER_ID);

  function viewedAuthor() {
    try {
      return (new URLSearchParams(window.location.search).get('author') || '').trim().toLowerCase();
    } catch (e) {
      return '';
    }
  }

  function isForeignPage() {
    if (state.demo) return true;
    var viewed = viewedAuthor();
    if (!viewed) return false;
    var mine = state.profile && state.profile.handle ? state.profile.handle.toLowerCase() : '';
    return viewed !== mine;
  }

  function shownProfile() {
    if (state.demo) return state.demo.profile || null;
    return isForeignPage() ? state.view : state.profile;
  }

  function shownStatus() {
    if (state.demo) return state.demo.status || 'published';
    return isForeignPage() ? state.viewStatus : state.status;
  }

  function loadForeign() {
    var handle = viewedAuthor();
    state.view = null;
    state.viewStatus = 'none';
    state.viewMiss = false;
    if (!handle || !window.db) return Promise.resolve();

    return window.db.collection('public_data')
      .where('profile.handle', '==', handle)
      .limit(1).get()
      .then(function (snap) {
        var hit = null;
        snap.forEach(function (doc) { hit = doc; });
        if (!hit) { state.viewMiss = true; return; }
        var data = hit.data() || {};
        var st = data.profile_status || 'none';
        if (st !== 'published' && !state.isAdmin) { state.viewMiss = true; return; }
        state.view = data.profile || null;
        state.viewStatus = st;
        state.viewId = hit.id;
      })
      .catch(function (err) {
        state.viewMiss = true;
        console.error(VERSION + ' foreign load failed', err);
      });
  }
  var extraFields = [];
  var listeners = { load: [], save: [], collect: [], open: [], close: [], paint: [] };
  var layers = [];
  var layersRan = false;

  state.isAdmin = !!(root && root.getAttribute('data-is-admin') === 'true');
  state.loggedIn = !!(root && state.cid);

  function el(sel) {
    if (!drawer) drawer = document.getElementById(DRAWER_ID);
    if (!root) root = document.querySelector('[data-leva-prof]');
    if (drawer) {
      var hit = drawer.querySelector(sel);
      if (hit) return hit;
    }
    return root ? root.querySelector(sel) : null;
  }

  function t(key) {
    if (!root) return '';
    return root.getAttribute('data-t-' + key) || '';
  }

  function log(msg, isError) {
    var box = el('[data-prof-log]');
    if (box) {
      box.textContent = msg;
      box.className = 'leva-prof-log' + (isError ? ' leva-prof-log--err' : '');
    }
    if (isError) console.error(VERSION + ': ' + msg);
    else console.log(VERSION + ': ' + msg);
  }

  function emit(name, payload) {
    var list = listeners[name] || [];
    for (var i = 0; i < list.length; i++) {
      try { list[i](payload, api); } catch (e) { console.error(VERSION + ' listener failed', e); }
    }
  }

  function allFields() {
    return CORE_FIELDS.concat(extraFields);
  }

  function field(key) {
    return el('[data-prof-f="' + key + '"]');
  }

  // Older products render this snippet twice, so a field can exist more
  // than once. Writing to the first copy only left the visible one empty.
  function fieldsAll(key) {
    return document.querySelectorAll('[data-prof-f="' + key + '"]');
  }

  // A select with nothing chosen still reports its first option as the
  // value, so "only fill the empty ones" silently skipped every dropdown
  // and left the currency on the first entry of the list. Whatever the
  // profile itself filled carries a mark and is never overwritten.
  function setAll(key, value, force) {
    if (!value) return;
    var all = fieldsAll(key);
    for (var i = 0; i < all.length; i++) {
      var f = all[i];
      if (f.getAttribute('data-prof-set') === '1') continue;
      var isSelect = f.tagName.toLowerCase() === 'select';
      if (!force && !isSelect && f.value) continue;
      try { f.value = value; } catch (e) {}
    }
  }

  function markFilled(key, value) {
    var all = fieldsAll(key);
    for (var i = 0; i < all.length; i++) {
      if (value) all[i].setAttribute('data-prof-set', '1');
      else all[i].removeAttribute('data-prof-set');
    }
  }

  function elAll(sel) {
    var out = [];
    var i;
    if (drawer) {
      var a = drawer.querySelectorAll(sel);
      for (i = 0; i < a.length; i++) out.push(a[i]);
    }
    if (root) {
      var b = root.querySelectorAll(sel);
      for (i = 0; i < b.length; i++) if (out.indexOf(b[i]) < 0) out.push(b[i]);
    }
    return out;
  }

  function cleanHandle(raw) {
    return (raw || '').toString().trim()
      .replace(/^@+/, '')
      .toLowerCase()
      .replace(/[^a-z0-9-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function collect() {
    var out = {};
    var keys = allFields();
    for (var i = 0; i < keys.length; i++) {
      var node = field(keys[i]);
      var val = node ? node.value.toString().trim() : '';
      out[keys[i]] = keys[i] === 'handle' ? cleanHandle(val) : val;
    }
    out.is_vendor = out.is_vendor === 'yes';
    emit('collect', out);
    return out;
  }

  function fill(profile) {
    var keys = allFields();
    for (var i = 0; i < keys.length; i++) {
      var node = field(keys[i]);
      if (node) node.value = (profile && profile[keys[i]]) ? profile[keys[i]] : '';
    }
    var curSel = field('currency');
    if (curSel) curSel.addEventListener('change', paintFlag);

    var visSel = field('price_visibility');
    if (visSel) {
      visSel.addEventListener('change', function () {
        paintPaywall();
        // the shared budget carries this, so it is written straight away
        if (typeof window.__levaSaveSharedBudget === 'function'
            && /\/products\//.test(window.location.pathname)) {
          try { window.__levaSaveSharedBudget(); } catch (e) {}
        }
        if (typeof window.__levaLoadProductBudgets === 'function') {
          setTimeout(function () {
            try { window.__levaLoadProductBudgets(); } catch (e) {}
          }, 900);
        }
      });
    }
    paintPaywall();
    setRole(field('is_vendor') ? field('is_vendor').value : '');
    if (vendorOnly()) simplifyForm();

    var roleOpts = document.querySelectorAll('[data-prof-role]');
    for (var r = 0; r < roleOpts.length; r++) {
      (function (btn) {
        if (btn.getAttribute('data-prof-wired') === '1') return;
        btn.setAttribute('data-prof-wired', '1');
        btn.addEventListener('click', function () {
          setRole(btn.getAttribute('data-prof-role'));
        });
      })(roleOpts[r]);
    }

    // The visible address box exists once per rendered form, and older
    // products render the form twice: writing to the first copy left the
    // one on screen blank, so a saved address looked lost. Every copy is
    // filled, and the hidden fields that carry it are marked as taken.
    var savedAddr = (profile && profile.address) ? profile.address : '';
    var addrBoxes = document.querySelectorAll('[data-prof-addr]');
    for (var ai = 0; ai < addrBoxes.length; ai++) addrBoxes[ai].value = savedAddr;
    if (savedAddr) {
      setAll('address', savedAddr, true);
      markFilled('address', savedAddr);
    }
    if (profile && profile.lat) setAll('lat', profile.lat, true);
    if (profile && profile.lon) setAll('lon', profile.lon, true);

    var radius = field('radius_km');
    if (radius && (!profile || !profile.radius_km)) radius.value = 50;

    paintPhoto(profile && profile.photo_url ? profile.photo_url : '');
    paintRadius();
    paintAddrDot();
    paintFlag();
    paintPaywall();
    markFilled('country', profile && profile.country);
    markFilled('currency', profile && profile.currency);
    markFilled('name', profile && profile.name);

    backfillFromSharedBudget().then(prefillFromProduct);
  }

  // The central budget is the vendor side of the product. Everyone who
  // fills in a profile here is offering prices, so the author / vendor
  // switch is gone and the whole form is always open. The author case
  // lives on the product page instead.
  // data-prof-mode on the root decides which side we are on.
  // "vendor" is the central budget: everyone here offers prices, so
  // the switch is gone and the vendor fields are always open.
  // "author" is a product page: the switch decides.
  function vendorOnly() {
    return !root || root.getAttribute('data-prof-mode') !== 'author';
  }

  function setRole(value) {
    var forced = vendorOnly();
    var v = forced ? 'yes' : (value || '');

    var hidden = field('is_vendor');
    if (hidden) hidden.value = v;

    // The role buttons are the drawer's own tabs now, so they sit outside
    // both the profile host and the drawer node. Search the document, and
    // toggle classes instead of overwriting them, so the tab styling from
    // the theme stays untouched.
    var opts = document.querySelectorAll('[data-prof-role]');
    for (var i = 0; i < opts.length; i++) {
      var on = opts[i].getAttribute('data-prof-role') === v;
      if (opts[i].classList) {
        opts[i].classList.toggle('is-active', on);
        opts[i].classList.toggle('tab-active', on);
      }
      opts[i].setAttribute('aria-selected', on ? 'true' : 'false');
    }

    // Authors give an approximate address too: the shared budgets that
    // publish automatically carry a map pin, so the block stays visible
    // for both roles and CSS hides the vendor-only rows for authors.
    var block = el('[data-prof-vendor-fields]');
    if (block) block.hidden = false;

    var seg = el('.leva-prof-seg');
    if (seg) seg.hidden = forced;

    applyOrder(v === 'yes');
  }

  function isVendorSelected() {
    var hidden = field('is_vendor');
    return !!(hidden && hidden.value === 'yes');
  }

  function paintRadius() {
    var radius = field('radius_km');
    var out = el('[data-prof-radius-out]');
    if (radius && out) out.textContent = radius.value + ' km';
  }

  function paint() {
    if (!root) return;
    var p = state.profile;
    var listed = !!(p && p.name);
    var foreign = isForeignPage();
    if (root) root.setAttribute('data-prof-view', foreign ? 'foreign' : 'mine');

    var tagline = root.querySelector('[data-prof-tagline]');
    if (tagline) {
      if (foreign && state.viewMiss && !state.demo) {
        tagline.hidden = false;
        tagline.textContent = t('not-found');
      } else {
        tagline.textContent = t('tagline');
        tagline.hidden = listed || foreign;
      }
    }

    var cta = root.querySelector('[data-prof-cta]');
    if (cta) {
      if (foreign) {
        cta.hidden = false;
        cta.textContent = t('cta-mine');
        cta.setAttribute('data-prof-cta-mode', 'mine');
      } else if (!listed) {
        cta.hidden = false;
        cta.textContent = t('cta');
        cta.setAttribute('data-prof-cta-mode', 'listing');
      } else {
        cta.hidden = true;
        cta.removeAttribute('data-prof-cta-mode');
      }
    }

    emit('paint', { profile: p, status: state.status, foreign: foreign, listed: listed });
  }

  function mount() {
    if (state.mounted) return;
    if (root) {
      var inner = document.querySelector('[data-budget-inner]');
      if (inner) {
        if (inner.firstChild) inner.insertBefore(root, inner.firstChild);
        else inner.appendChild(root);
      }
      root.hidden = false;
    }
    if (drawer && drawer.parentNode !== document.body) {
      document.body.appendChild(drawer);
    }
    state.mounted = true;
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('active');
    document.body.classList.add('open-cc');
    state.open = true;
    var first = field('name');
    if (first) { try { first.focus(); } catch (e) {} }
    emit('open', { profile: state.profile, status: state.status });
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('active');
    document.body.classList.remove('open-cc');
    state.open = false;
    emit('close', { profile: state.profile, status: state.status });
  }

  function docRef() {
    if (!window.db || !state.cid) return null;
    return window.db.collection('public_data').doc(state.cid);
  }

  function stamp() {
    try {
      return window.firebase.firestore.FieldValue.serverTimestamp();
    } catch (e) {
      return new Date().toISOString();
    }
  }

  var STORAGE_SDK = 'https://www.gstatic.com/firebasejs/11.6.0/firebase-storage-compat.js';
  // The page config points at leva-791c5, which has no Storage bucket.
  // Budget images already go to this one from the storefront, so it is
  // the bucket that is known to accept writes from a customer session.
  var STORAGE_BUCKET = 'gs://levadelivery001.firebasestorage.app';
  var UPLOAD_TIMEOUT = 25000;
  var MAX_EDGE = 640;
  var MAX_BYTES = 8 * 1024 * 1024;

  function ensureStorage() {
    return new Promise(function (resolve, reject) {
      if (window.firebase && typeof window.firebase.storage === 'function') { resolve(); return; }
      var existing = document.querySelector('script[data-leva-storage]');
      if (existing) {
        existing.addEventListener('load', function () { resolve(); });
        existing.addEventListener('error', function () { reject(new Error('storage sdk failed')); });
        return;
      }
      var tag = document.createElement('script');
      tag.src = STORAGE_SDK;
      tag.setAttribute('data-leva-storage', '1');
      tag.onload = function () { resolve(); };
      tag.onerror = function () { reject(new Error('storage sdk failed')); };
      document.head.appendChild(tag);
    });
  }

  function shrink(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onerror = function () { reject(new Error('read failed')); };
      reader.onload = function () {
        var img = new Image();
        img.onerror = function () { reject(new Error('decode failed')); };
        img.onload = function () {
          var w = img.naturalWidth || img.width;
          var h = img.naturalHeight || img.height;
          var scale = Math.min(1, MAX_EDGE / Math.max(w, h));
          var cw = Math.max(1, Math.round(w * scale));
          var ch = Math.max(1, Math.round(h * scale));
          var canvas = document.createElement('canvas');
          canvas.width = cw;
          canvas.height = ch;
          canvas.getContext('2d').drawImage(img, 0, 0, cw, ch);
          canvas.toBlob(function (blob) {
            if (blob) resolve(blob);
            else reject(new Error('encode failed'));
          }, 'image/jpeg', 0.85);
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    });
  }

  var UPLOAD_ICON = 'M12 3l5 5h-3v6h-4V8H7l5-5zM5 18h14v2H5v-2z';

  function paintPhoto(url) {
    var thumb = el('[data-prof-photo-thumb]');
    var remove = el('[data-prof-photo-remove]');
    var holder = field('photo_url');
    if (holder) holder.value = url || '';
    if (remove) remove.hidden = !url;
    if (!thumb) return;

    thumb.style.backgroundImage = url ? 'url(' + url + ')' : '';
    if (thumb.classList) thumb.classList.toggle('has-photo', !!url);
    thumb.innerHTML = '';
    if (!url) {
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('width', '26');
      svg.setAttribute('height', '26');
      svg.setAttribute('fill', 'currentColor');
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', UPLOAD_ICON);
      svg.appendChild(path);
      thumb.appendChild(svg);
    }
  }

  function photoNote(msg, isError) {
    var row = el('.leva-prof-photo__row');
    if (!row) return;
    var note = row.querySelector('[data-prof-photo-note]');
    if (!note) {
      note = document.createElement('div');
      note.setAttribute('data-prof-photo-note', '');
      row.appendChild(note);
    }
    note.textContent = msg || '';
    note.className = 'leva-prof-photo__note' + (isError ? ' is-error' : '');
    if (isError) console.error(VERSION + ' photo: ' + msg);
    else console.log(VERSION + ' photo: ' + msg);
  }

  function setPhotoBusy(on) {
    var thumb = el('[data-prof-photo-thumb]');
    if (thumb && thumb.classList) thumb.classList.toggle('is-busy', !!on);
  }

  function uploadPhoto(file) {
    if (!file) return;
    if (file.size > MAX_BYTES) { log(t('photo-too-big'), true); return; }
    if (!state.cid) { log(t('offline'), true); return; }

    setBusy(true);
    setPhotoBusy(true);
    photoNote('1/4 loading uploader');
    log(t('uploading'));

    ensureStorage().then(function () {
      photoNote('2/4 resizing');
      return shrink(file);
    }).then(function (blob) {
      photoNote('3/4 uploading ' + Math.round(blob.size / 1024) + ' kB');
      if (!window.firebase || typeof window.firebase.storage !== 'function') {
        throw new Error('storage sdk missing');
      }

      var storage;
      try {
        storage = window.firebase.app().storage(STORAGE_BUCKET);
      } catch (e) {
        storage = window.firebase.storage();
      }

      // The bucket rules only allow the root, the same place budget
      // images land, so profile photos follow their naming instead of
      // sitting in a folder of their own.
      var rand = Math.random().toString(36).slice(2, 10);
      var name = Date.now() + '-' + rand + '.jpg';
      var ref = storage.ref().child(name);
      var task = ref.put(blob, { contentType: 'image/jpeg' });

      return new Promise(function (resolve, reject) {
        var done = false;
        var timer = setTimeout(function () {
          if (done) return;
          done = true;
          try { task.cancel(); } catch (e) {}
          reject(new Error('no answer from storage in 25 s - check that the bucket exists and allows writes'));
        }, UPLOAD_TIMEOUT);

        task.on('state_changed', function (snap) {
          if (!snap || !snap.totalBytes) return;
          var pct = Math.round((snap.bytesTransferred / snap.totalBytes) * 100);
          photoNote('3/4 uploading ' + pct + ' percent');
        }, function (err) {
          if (done) return;
          done = true;
          clearTimeout(timer);
          reject(err);
        }, function () {
          if (done) return;
          done = true;
          clearTimeout(timer);
          photoNote('4/4 finishing');
          ref.getDownloadURL().then(resolve).catch(reject);
        });
      });
    }).then(function (url) {
      paintPhoto(url);
      setBusy(false);
      setPhotoBusy(false);
      photoNote(t('uploaded'));
      log(t('uploaded'));
    }).catch(function (err) {
      setBusy(false);
      setPhotoBusy(false);
      var msg = (err && err.code ? err.code + ' - ' : '') + describe(err);
      photoNote(msg, true);
      log('Photo upload failed: ' + msg, true);
    });
  }

  var addrTimer = null;
  var addrSeq = 0;
  var addrLast = 'not used yet';
  var addrTrace = [];
  var addrDelegated = false;

  function addrLog(msg) {
    var stamp = new Date().toISOString().substr(11, 8);
    addrTrace.push(stamp + ' ' + msg);
    if (addrTrace.length > 24) addrTrace.shift();
    console.log(VERSION + ' addr: ' + msg);
  }

  function addrReport() {
    var out = [];
    var inputs = document.querySelectorAll('[data-prof-addr]');
    var lists = document.querySelectorAll('[data-prof-addr-list]');
    out.push('state: ' + addrLast);
    out.push('delegate installed: ' + (addrDelegated ? 'yes' : 'no'));
    out.push('inputs in document: ' + inputs.length + '  lists in document: ' + lists.length);
    out.push('root found: ' + (root ? 'yes' : 'no') + '  drawer found: ' + (drawer ? 'yes' : 'no'));
    for (var i = 0; i < inputs.length; i++) {
      var n = inputs[i];
      var box = n.getBoundingClientRect();
      var hiddenBlock = n.closest ? !!n.closest('[hidden]') : false;
      out.push('  input ' + i + ': wired=' + (n.getAttribute('data-prof-addr-wired') || 'no')
        + ' value="' + (n.value || '') + '"'
        + ' disabled=' + (n.disabled ? 'yes' : 'no')
        + ' readonly=' + (n.readOnly ? 'yes' : 'no')
        + ' box=' + Math.round(box.width) + 'x' + Math.round(box.height)
        + ' insideHidden=' + (hiddenBlock ? 'yes' : 'no')
        + ' hasList=' + (n.parentNode && n.parentNode.querySelector('[data-prof-addr-list]') ? 'yes' : 'no'));
    }
    if (!addrTrace.length) out.push('trace: empty -- no input event ever reached the handler');
    else {
      out.push('trace:');
      for (var j = 0; j < addrTrace.length; j++) out.push('  ' + addrTrace[j]);
    }
    return out.join('\n');
  }

  window.__levaAddrLast = function () { return addrLast; };
  window.__levaAddrReport = addrReport;

  function pageLang() {
    var l = '';
    try {
      l = document.documentElement.getAttribute('lang') || '';
      if (!l && window.Shopify && window.Shopify.locale) l = window.Shopify.locale;
    } catch (e) {}
    l = String(l || 'en').split('-')[0].toLowerCase();
    return l || 'en';
  }

  function closeAddrList(input) {
    var list = (input && input.parentNode && input.parentNode.querySelector('[data-prof-addr-list]'))
      || el('[data-prof-addr-list]');
    if (list) {
      list.innerHTML = '';
      list.classList.remove('is-open');
    }
  }

  function pickAddress(item) {
    var input = el('[data-prof-addr]');
    var allAddr = document.querySelectorAll('[data-prof-addr]');
    for (var ax = 0; ax < allAddr.length; ax++) allAddr[ax].value = item.display_name;
    if (input) input.value = item.display_name;
    var a = field('address');
    var la = field('lat');
    var lo = field('lon');
    if (a) a.value = item.display_name;
    if (la) la.value = item.lat;
    if (lo) lo.value = item.lon;

    // the country is taken from the address rather than asked for
    var cc = '';
    if (item.address && item.address.country_code) cc = String(item.address.country_code).toUpperCase();
    if (!cc && item.display_name) {
      var parts = item.display_name.split(',');
      cc = parts.length > 1 ? parts[parts.length - 1].trim() : '';
    }
    if (cc) setAll('country', cc, true);

    closeAddrList();
    paintAddrDot();

    // hidden fields change without a keystroke, so the change is announced
    ['address', 'lat', 'lon', 'country'].forEach(function (k) {
      var f = field(k);
      if (f) f.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (typeof window.__levaSaveSharedBudget === 'function'
        && /\/products\//.test(window.location.pathname)) {
      try { window.__levaSaveSharedBudget(); } catch (e) {}
    }
    if (typeof window.__levaLoadProductBudgets === 'function') {
      setTimeout(function () {
        try { window.__levaLoadProductBudgets(); } catch (e) {}
      }, 900);
    }
  }

  function searchAddress(q, input) {
    var list = (input && input.parentNode && input.parentNode.querySelector('[data-prof-addr-list]'))
      || el('[data-prof-addr-list]');
    if (!list) {
      addrLast = 'no list element next to the input';
      addrLog(addrLast);
      return;
    }
    addrLog('searching "' + q + '"');
    var seq = ++addrSeq;
    var lang = 'en';
    try {
      lang = pageLang();
    } catch (e) {
      addrLog('pageLang failed: ' + (e && e.message ? e.message : e));
    }
    // Without a language the lookup follows the device, so a Czech phone
    // returned Czech country names inside an English storefront. The page
    // language decides instead.
    var url = 'https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&limit=5'
      + '&accept-language=' + encodeURIComponent(lang) + '&q='
      + encodeURIComponent(q);

    addrLast = 'sent q=' + q;
    addrLog('fetch sent');
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        addrLast = 'http ' + r.status + ' for q=' + q;
        addrLog(addrLast);
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      })
      .then(function (rows) {
        if (seq !== addrSeq) return;
        addrLast = 'http 200, ' + ((rows && rows.length) || 0) + ' rows for q=' + q;
        addrLog(addrLast);
        list.innerHTML = '';
        if (!rows || !rows.length) {
          closeAddrList(input);
          log(t('addr-none'), true);
          return;
        }
        for (var i = 0; i < rows.length; i++) {
          (function (item) {
            var opt = document.createElement('button');
            opt.type = 'button';
            opt.className = 'leva-prof-addr__opt';
            opt.textContent = item.display_name;
            opt.addEventListener('click', function () { pickAddress(item); });
            list.appendChild(opt);
          })(rows[i]);
        }
        list.classList.add('is-open');
      })
      .catch(function (err) {
        addrLast = 'failed: ' + (err && err.message ? err.message : String(err)) + ' for q=' + q;
        addrLog(addrLast);
        closeAddrList(input);
        log(t('addr-failed'), true);
        console.error(VERSION + ' address lookup: ' + addrLast);
      });
  }

  function wireAddress() {
    if (addrDelegated) return;
    addrDelegated = true;
    addrLast = 'delegate installed, nothing typed yet';
    addrLog(addrLast);

    document.addEventListener('input', function (e) {
      var input = e.target;
      if (!input || !input.getAttribute || input.getAttribute('data-prof-addr') === null) return;
      addrLog('input event, length ' + String(input.value || '').length);

      var a = field('address');
      var la = field('lat');
      var lo = field('lon');
      if (a) a.value = '';
      if (la) la.value = '';
      if (lo) lo.value = '';

      paintAddrDot();
      var q = String(input.value || '').trim();
      clearTimeout(addrTimer);
      if (q.length < 3) {
        addrLast = 'typed ' + q.length + ' characters, need 3';
        closeAddrList(input);
        return;
      }
      addrLast = 'waiting for the pause after "' + q + '"';
      addrTimer = setTimeout(function () { searchAddress(q, input); }, 900);
    }, true);

    document.addEventListener('click', function (e) {
      var inputs = document.querySelectorAll('[data-prof-addr]');
      for (var i = 0; i < inputs.length; i++) {
        var wrap = inputs[i].parentNode;
        if (wrap && !wrap.contains(e.target)) closeAddrList(inputs[i]);
      }
    }, true);
  }

  // Central budget form is the vendor form. Contacts and travel come
  // first, the social list is cut to the ones that matter, and the
  // group headings go away so it reads as one list.
  // What matters first differs by role. A vendor is judged on how to
  // reach him and how far he travels; an author on who he is.
  // A vendor is judged on how to reach him and where he works, so the
  // contact block sits right under the name and everything social
  // drops to the bottom. An influencer is the opposite: reach and
  // channels are the point, and paid content closes the form.
  // Agreed order. Every field gets a number: anything left unnumbered
  // stays at 0 and floats above the whole form, which is how Pinterest
  // once ended up on top.
  var ORDER_VENDOR = {
    name: 1, handle: 2,
    price_visibility: 8, paywall_url: 9, country: 10, currency: 11,
    web: 12, instagram: 13, facebook: 14, tiktok: 15, linkedin: 16,
    followers: 17, bio: 18,
    youtube: 30, pinterest: 31, x: 32,
    patreon: 40, bmac: 41, gumroad: 42, substack: 43
  };
  var HIDE_VENDOR = ['pinterest', 'x', 'youtube', 'patreon', 'bmac', 'gumroad', 'substack'];

  var ORDER_AUTHOR = {
    name: 1, handle: 2, followers: 3, bio: 4,
    instagram: 5, youtube: 6, tiktok: 7, web: 8,
    price_visibility: 12, paywall_url: 13, country: 10, currency: 11,
    patreon: 20, bmac: 21, gumroad: 22, substack: 23,
    facebook: 30, pinterest: 31, x: 32, linkedin: 33
  };
  var HIDE_AUTHOR = ['facebook', 'pinterest', 'x', 'linkedin'];
  var FORM_ORDER = ORDER_VENDOR;
  var FORM_HIDE = [
    'followers', 'tiktok', 'pinterest', 'x', 'linkedin',
    'patreon', 'bmac', 'gumroad', 'substack'
  ];

  function fieldWrap(key) {
    var node = field(key);
    if (!node) return null;
    var form = el('[data-prof-form]');
    var cur = node;
    while (cur && cur.parentNode && cur.parentNode !== form) cur = cur.parentNode;
    return (cur && cur.parentNode === form) ? cur : null;
  }

  function applyOrder(vendor) {
    var form = el('[data-prof-form]');
    if (!form) return;
    var map = vendor ? ORDER_VENDOR : ORDER_AUTHOR;

    var photo = el('.leva-prof-photo');
    if (photo) photo.style.order = '-10';

    var seg = el('.leva-prof-seg');
    if (seg) seg.style.order = '-20';

    var block = el('[data-prof-vendor-fields]');
    // author: address straight after the website; vendor: near the top
    if (block) block.style.order = vendor ? '3' : '9';

    var hide = vendor ? HIDE_VENDOR : HIDE_AUTHOR;
    var key, w;

    // Reset first so switching roles can bring a field back, but never
    // touch fields another rule owns: the paywall link is shown by the
    // visibility select, not by the role.
    var OWNED = { paywall_url: 1 };

    for (key in ORDER_AUTHOR) {
      if (!ORDER_AUTHOR.hasOwnProperty(key) || OWNED[key]) continue;
      w = fieldWrap(key);
      if (w) w.hidden = false;
    }
    for (key in ORDER_VENDOR) {
      if (!ORDER_VENDOR.hasOwnProperty(key) || OWNED[key]) continue;
      w = fieldWrap(key);
      if (w) w.hidden = false;
    }

    for (var h = 0; h < hide.length; h++) {
      w = fieldWrap(hide[h]);
      if (w) w.hidden = true;
    }

    // Belt and braces: the role also lands on the form, so CSS can hide
    // the same fields even if a wrapper is not where we expect it.
    if (form) form.setAttribute('data-prof-role-active', vendor ? 'vendor' : 'author');

    for (key in map) {
      if (!map.hasOwnProperty(key)) continue;
      w = fieldWrap(key);
      if (w) w.style.order = String(map[key]);
    }

    var groups = form.querySelectorAll('.leva-prof-group');
    for (var g = 0; g < groups.length; g++) groups[g].hidden = true;

    paintPaywall();

    var tail = [['.leva-prof-consent', 90], ['.leva-prof-actions', 91], ['[data-prof-log]', 92]];
    for (var i = 0; i < tail.length; i++) {
      var node = el(tail[i][0]);
      if (node) node.style.order = String(tail[i][1]);
    }
  }

  // Country is a plain input in the markup. The share drawer already
  // ships a country list, so turn it into the same select and start it
  // on whatever country the storefront is currently selling in.
  function upgradeCountry() {
    var all = fieldsAll('country');
    for (var i = 0; i < all.length; i++) upgradeOneCountry(all[i]);
  }

  function upgradeOneCountry(input) {
    if (!input || input.tagName.toLowerCase() === 'select') return;
    if (typeof window.levaFillCountrySelect !== 'function') return;

    var sel = document.createElement('select');
    sel.setAttribute('data-prof-f', 'country');
    sel.className = input.className;
    var first = document.createElement('option');
    first.value = '';
    first.textContent = '-';
    sel.appendChild(first);

    input.parentNode.replaceChild(sel, input);
    try { window.levaFillCountrySelect(sel); } catch (e) {}

    var want = (input.value || '').toString().trim();
    if (!want) {
      try {
        want = (window.Shopify && window.Shopify.country) ? window.Shopify.country : '';
      } catch (e) { want = ''; }
      if (!want && window.__levaShopifyPrefill) want = window.__levaShopifyPrefill.country || '';
    }
    if (want) { try { sel.value = want; } catch (e) {} }

    sel.addEventListener('change', paintFlag);
    paintFlag();
  }

  // The flag belongs to the country and now sits next to the currency as
  // well, so both read the same way on every copy of the form.
  // Country is not a field any more; the flag shown belongs to the
  // selected currency, so the two can never contradict each other.
  function paintFlag() {
    var sels = fieldsAll('currency');
    var url = '';
    for (var i = 0; i < sels.length; i++) {
      var s = sels[i];
      var opt = s.options ? s.options[s.selectedIndex] : null;
      var u = opt ? opt.getAttribute('data-flag-url') : '';
      if (u) { url = u; break; }
    }
    // both fields show the same flag, so they can never disagree
    var imgs = document.querySelectorAll('[data-prof-currency-flag], [data-prof-country-flag]');
    for (var j = 0; j < imgs.length; j++) {
      if (url) {
        imgs[j].src = url;
        imgs[j].hidden = false;
      } else {
        imgs[j].removeAttribute('src');
        imgs[j].hidden = true;
      }
    }
  }

  // Behind a paywall needs somewhere to pay, so the link only appears
  // once that option is picked.
  // The budget shared on this product is the customer's own, so its
  // record fills whatever the profile leaves empty: name, bio, photo,
  // socials, address. Profile values always win.
  function backfillFromSharedBudget() {
    var done = Promise.resolve();
    if (!window.db || !state.cid) return done;
    var m = /\/products\/([^\/?#]+)/.exec(window.location.pathname);
    if (!m) return done;
    var handle = m[1];

    var ids = [];
    if (window.currentVariantId) ids.push(state.cid + '__' + handle + '__' + window.currentVariantId);
    ids.push(state.cid + '__' + handle);

    function tryDoc(i) {
      if (i >= ids.length) return Promise.resolve(null);
      return window.db.collection('budget_details').doc(ids[i]).get()
        .then(function (doc) {
          if (doc.exists) return doc.data() || null;
          return tryDoc(i + 1);
        })
        .catch(function () { return null; });
    }

    function put(key, value) {
      if (!value) return;
      var f = field(key);
      if (f && !f.value) f.value = value;
    }

    return tryDoc(0).then(function (d) {
      if (!d) return;
      put('name', d.customerName);
      put('bio', d.description);
      put('photo_url', d.logoUrl);
      put('country', d.country);
      put('address', d.localisation || d.city);
      put('lat', d.latitude);
      put('lon', d.longitude);
      put('instagram', d.socialInstagram);
      put('youtube', d.socialYouTube);
      put('tiktok', d.socialTikTok);
      put('pinterest', d.socialPinterest);
      put('patreon', d.socialPatreon);
      put('bmac', d.socialKofi);
      put('paywall_url', d.behindPaywallUrl);
      var photo = field('photo_url');
      if (photo && photo.value) paintPhoto(photo.value);
      paintFlag();
      paintAddrDot();
      paintPaywall();
    });
  }

  // Empty fields start from what the storefront already knows: the
  // product and variant give the display name, Shopify gives the
  // currency. Country is prefilled by upgradeCountry the same way.
  // The storefront currency is written on every tick of the boot loop,
  // so a choice made before the profile loads would be overwritten a
  // fifth of a second later. Touching the select marks it as filled,
  // which is the same mark a loaded profile carries.
  function guardCurrencyChoice() {
    var all = fieldsAll('currency');
    for (var i = 0; i < all.length; i++) {
      var f = all[i];
      if (f.getAttribute('data-prof-guard') === '1') continue;
      f.setAttribute('data-prof-guard', '1');
      f.addEventListener('change', function () {
        this.setAttribute('data-prof-set', '1');
      });
    }
  }

  function prefillFromProduct() {
    var P = window.__levaShopifyPrefill || {};

    var name = field('name');
    if (name && !name.value && P.name) setAll('name', P.name);
    if (name && !name.value) {
      var title = '';
      try {
        if (window.shareProductContext && window.shareProductContext.title) {
          title = window.shareProductContext.title;
        }
      } catch (e) {}
      if (!title) {
        var og = document.querySelector('meta[property="og:title"]');
        if (og && og.content) title = og.content;
      }
      if (!title) {
        var h1 = document.querySelector('h1');
        if (h1) title = h1.textContent.trim();
      }
      var vbtn = document.querySelector('#variant-buttons .variant-tab[data-active="true"]');
      var vt = vbtn ? (vbtn.getAttribute('data-variant-title') || '').trim() : '';
      if (!vt) {
        try {
          var ctx = window.shareProductContext || {};
          vt = (ctx.variantTitle || '').trim();
          if (!vt && ctx.variantId && window.__LEVA_VARIANT_TITLES_BY_ID) {
            vt = (window.__LEVA_VARIANT_TITLES_BY_ID[ctx.variantId] || '').trim();
          }
        } catch (e) {}
      }
      if (vt && vt.toLowerCase() !== 'default title') title = title ? title + ' / ' + vt : vt;
      if (title) setAll('name', title);
    }

    var mail = field('email');
    if (mail && !mail.value) {
      try {
        if (window.customerEmail) mail.value = window.customerEmail;
      } catch (e) {}
    }

    var cur = field('currency');
    if (cur) {
      var c = '';
      try {
        if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
          c = window.Shopify.currency.active;
        }
      } catch (e) {}
      // The currency of this storefront is a fact about the page, not a
      // preference, so it is always written -- it must never sit on a
      // random entry of the list.
      setAll('currency', c || P.currency || '', true);
    }
    guardCurrencyChoice();
    wireAddress();

    if (P.country) setAll('country', P.country, true);
    paintFlag();
  }

  function paintPaywall() {
    var sel = field('price_visibility');
    var row = el('[data-prof-paywall]');
    if (row) row.hidden = !(sel && sel.value === 'paywall');
  }

  function paintAddrDot() {
    var wrap = el('.leva-prof-addr');
    if (!wrap) return;
    var dot = wrap.querySelector('.leva-prof-addr__dot');
    if (!dot) {
      dot = document.createElement('span');
      dot.className = 'leva-prof-addr__dot';
      wrap.appendChild(dot);
    }
    var la = field('lat');
    var lo = field('lon');
    var ok = !!(la && lo && la.value && lo.value);
    dot.className = 'leva-prof-addr__dot' + (ok ? ' is-set' : '');
  }

  function simplifyForm() {
    var form = el('[data-prof-form]');
    if (!form || form.getAttribute('data-prof-simple') === '1') return;

    var photo = el('.leva-prof-photo');
    if (photo) photo.style.order = '-10';

    var vendorBlock = el('[data-prof-vendor-fields]');
    if (vendorBlock) {
      vendorBlock.style.order = '-3';
      vendorBlock.style.border = '0';
      vendorBlock.style.background = 'none';
      vendorBlock.style.padding = '0';
    }

    var key;
    for (key in FORM_ORDER) {
      if (!FORM_ORDER.hasOwnProperty(key)) continue;
      var w = fieldWrap(key);
      if (w) w.style.order = String(FORM_ORDER[key]);
    }

    for (var i = 0; i < FORM_HIDE.length; i++) {
      var h = fieldWrap(FORM_HIDE[i]);
      if (h) h.hidden = true;
    }

    var groups = form.querySelectorAll('.leva-prof-group');
    for (var g = 0; g < groups.length; g++) groups[g].hidden = true;

    // Ordered items float above anything left on the default order,
    // so the consent and the buttons have to be pushed to the end.
    var tail = [
      ['.leva-prof-consent', 50],
      ['.leva-prof-actions', 51],
      ['[data-prof-log]', 52]
    ];
    for (var i2 = 0; i2 < tail.length; i2++) {
      var node = el(tail[i2][0]);
      if (node) node.style.order = String(tail[i2][1]);
    }

    form.setAttribute('data-prof-simple', '1');
  }

  function setBusy(on) {
    var a = el('[data-prof-save]');
    var b = el('[data-prof-submit]');
    if (a) a.disabled = !!on;
    if (b) b.disabled = !!on;
  }

  function describe(err) {
    if (!err) return 'unknown error';
    return err.message || err.code || err.toString();
  }

  function save(nextStatus) {
    var ref = docRef();
    if (!ref) { log(t('offline'), true); return; }

    var profile = collect();
    if (!profile.name) { log(t('need-name'), true); return; }
    /* A handle is for people who want to be findable, and sharing a budget
       asks for nothing of the sort -- so demanding one before anything can
       be saved stopped people who had no reason to have one. */
    if (profile.is_vendor === true || profile.is_vendor === 'yes') {
      if (!profile.email) { log(t('need-email'), true); return; }
      if (!profile.address || !profile.lat || !profile.lon) { log(t('need-address'), true); return; }
    }

    var handleNode = field('handle');
    if (handleNode) handleNode.value = profile.handle;

    setBusy(true);
    log(t('saving'));

    var payload = {
      profile: profile,
      profile_status: nextStatus,
      profile_updated_at: stamp()
    };

    return ref.set(payload, { merge: true }).then(function () {
      state.profile = profile;
      state.status = nextStatus;
      paint();
      setBusy(false);
      log(nextStatus === 'published' ? t('sent') : t('saved'));

      // On a product page the same data lives in the shared budget too,
      // so a profile save pushes the refreshed record there as well.
      if (typeof window.__levaSaveSharedBudget === 'function'
          && /\/products\//.test(window.location.pathname)) {
        try {
          // A budget counts as a vendor's only when the vendor role was on
          // at the moment of publishing, never from an automatic share.
          window.__levaPublishAsVendor = (nextStatus === 'published')
            && !!(field('is_vendor') && field('is_vendor').value === 'yes');
          window.__levaSaveSharedBudget();
        } catch (e) {}
      }
      if (typeof window.__levaLoadProductBudgets === 'function') {
        setTimeout(function () {
          try { window.__levaLoadProductBudgets(); } catch (e) {}
        }, 800);
      }
      emit('save', { profile: profile, status: nextStatus });
    }).catch(function (err) {
      setBusy(false);
      log(describe(err), true);
    });
  }

  function load() {
    var ref = docRef();
    if (!ref) {
      state.profile = null;
      state.status = 'none';
      paint();
      mount();
      log(t('offline'), true);
      finish();
      return;
    }
    return ref.get().then(function (doc) {
      var data = doc.exists ? (doc.data() || {}) : {};
      state.profile = data.profile || null;
      state.status = data.profile_status || 'none';
      fill(state.profile);
      mount();
      console.log(VERSION + ': loaded, status ' + state.status);
      loadForeign().then(function () {
        paint();
        finish();
      });
    }).catch(function (err) {
      state.profile = null;
      state.status = 'none';
      paint();
      mount();
      log(describe(err), true);
      finish();
    });
  }

  function finish() {
    state.ready = true;
    emit('load', { profile: state.profile, status: state.status });
    runLayers();
  }

  function runLayers() {
    if (layersRan) return;
    layersRan = true;
    for (var i = 0; i < layers.length; i++) {
      try { layers[i](api); } catch (e) { console.error(VERSION + ' layer failed', e); }
    }
  }

  function wire() {
    var cta = root ? root.querySelector('[data-prof-cta]') : null;
    if (cta) {
      cta.addEventListener('click', function () {
        if (cta.getAttribute('data-prof-cta-mode') === 'mine') {
          window.location.href = window.location.pathname;
          return;
        }
        openDrawer();
      });
    }

    var saveBtn = el('[data-prof-save]');
    var submitBtn = el('[data-prof-submit]');
    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        save(state.status === 'published' ? 'published' : 'draft');
      });
    }
    // Anyone can list themselves. Nothing waits for approval here.
    if (submitBtn) {
      submitBtn.addEventListener('click', function () { save('published'); });
    }

    setRole();

    var radius = field('radius_km');
    if (radius) radius.addEventListener('input', paintRadius);

    wireAddress();

    var thumb = el('[data-prof-photo-thumb]');
    var photoInput = el('[data-prof-photo-input]');
    if (thumb && photoInput) {
      thumb.title = 'Upload photo';
      thumb.setAttribute('role', 'button');
      thumb.setAttribute('tabindex', '0');
      thumb.addEventListener('click', function () {
        try {
          photoInput.click();
        } catch (e) {
          var pick = el('.leva-prof-photo__pick');
          if (pick && pick.click) pick.click();
        }
      });
      thumb.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); photoInput.click(); }
      });
    }
    if (photoInput) {
      photoInput.addEventListener('change', function (e) {
        var file = e.target.files && e.target.files[0];
        e.target.value = '';
        if (!file) { photoNote('no file picked', true); return; }
        photoNote('picked ' + Math.round(file.size / 1024) + ' kB');
        uploadPhoto(file);
      });
    }
    var photoRemove = el('[data-prof-photo-remove]');
    if (photoRemove) {
      photoRemove.addEventListener('click', function () { paintPhoto(''); });
    }

    if (drawer) {
      var closeEl = drawer.querySelector('.side-panel-close');
      if (closeEl) closeEl.addEventListener('click', function () { closeDrawer(); });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state.open) closeDrawer();
    });
  }

  var api = {
    version: VERSION,
    state: state,
    root: root,
    drawer: drawer,
    t: t,
    log: log,
    docRef: docRef,
    stamp: stamp,
    reload: load,
    save: save,
    paint: paint,
    mount: mount,
    open: openDrawer,
    close: closeDrawer,
    getProfile: function () { return state.profile; },
    getStatus: function () { return state.status; },
    isReady: function () { return state.ready; },
    isForeign: isForeignPage,
    viewedAuthor: viewedAuthor,
    getMyProfile: function () { return state.profile; },
    getShownProfile: shownProfile,
    getShownStatus: shownStatus,
    setDemo: function (obj) {
      state.demo = obj || null;
      if (root) root.setAttribute('data-prof-demo', state.demo ? 'on' : 'off');
      paint();
    },
    isDemo: function () { return !!state.demo; },
    layerSlot: function () { return el('[data-prof-layers]'); },
    addField: function (key) {
      if (key && extraFields.indexOf(key) < 0 && CORE_FIELDS.indexOf(key) < 0) {
        extraFields.push(key);
        var node = field(key);
        if (node && state.profile && state.profile[key]) node.value = state.profile[key];
      }
    },
    on: function (name, fn) {
      if (listeners[name] && typeof fn === 'function') listeners[name].push(fn);
    },
    register: function (fn) {
      if (typeof fn !== 'function') return;
      layers.push(fn);
      if (layersRan) { try { fn(api); } catch (e) { console.error(VERSION + ' layer failed', e); } }
    }
  };

  window.LevaProfile = api;

  if (!root) {
    state.ready = true;
    runLayers();
    return;
  }

  wire();

  // Opening the drawer is the moment the fields are looked at, so top up
  // anything still empty then.
  (function watchOpen() {
    var sd = document.getElementById('Share-Budget-Drawer');
    if (!sd) { setTimeout(watchOpen, 500); return; }
    new MutationObserver(function () {
      if (!sd.classList.contains('active')) return;
      try { upgradeCountry(); prefillFromProduct(); paintFlag(); } catch (e) {}
    }).observe(sd, { attributes: true, attributeFilter: ['class'] });
  })();

  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (!state.cid) {
      state.cid = (window.__centralCustomerIdFromLiquid
        || window.customerId
        || window.BudgetSharingCustomerId
        || '').toString().trim();
      if (state.cid) state.loggedIn = !!root;
    }
    if (window.db && window.firebase && state.cid) {
      clearInterval(timer);
      load();
    } else if (tries > 150) {
      clearInterval(timer);
      load();
    }
    // The storefront knows the country, currency and product name whether
    // or not the profile can be read, so fill those in regardless.
    try { upgradeCountry(); prefillFromProduct(); } catch (e) {}
  }, 200);
})();

/* ============================================================
   LEVA PROFILE CARD  --  prof-v155 (core)
   The public profile header, shown to every signed in customer.
   Desktop: identity in the left third, aligned right against the
   divider; bio above a single row of icons in the right two
   thirds, aligned left against the divider.
   Mobile: stacked and centered with a horizontal divider, and
   only the networks that are filled in are shown.
   ============================================================ */
(function () {
  if (!window.LevaProfile) return;

  var SVG = 'http://www.w3.org/2000/svg';

  var NETS = [
    ['instagram', '#E1306C', 'M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm0 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7zm5 3.5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm0 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM17.8 6a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4z'],
    ['youtube', '#FF0000', 'M21.6 7.2a2.5 2.5 0 0 0-1.8-1.8C18.2 5 12 5 12 5s-6.2 0-7.8.4A2.5 2.5 0 0 0 2.4 7.2 26 26 0 0 0 2 12a26 26 0 0 0 .4 4.8 2.5 2.5 0 0 0 1.8 1.8C5.8 19 12 19 12 19s6.2 0 7.8-.4a2.5 2.5 0 0 0 1.8-1.8A26 26 0 0 0 22 12a26 26 0 0 0-.4-4.8zM10 15.2V8.8L15.5 12 10 15.2z'],
    ['tiktok', '#111111', 'M14 3h2.6a5.6 5.6 0 0 0 4.4 4.3v2.7a8.3 8.3 0 0 1-4.4-1.4v6.2a5.9 5.9 0 1 1-5.9-5.9c.3 0 .6 0 .9.1v2.8a3.1 3.1 0 1 0 2.2 3V3z'],
    ['facebook', '#1877F2', 'M13.5 21v-8h2.7l.4-3h-3.1V8.2c0-.9.3-1.5 1.6-1.5h1.6V4c-.3 0-1.3-.1-2.4-.1-2.4 0-4.1 1.5-4.1 4.2V10H8v3h2.2v8h3.3z'],
    ['pinterest', '#E60023', 'M12 2a10 10 0 0 0-3.7 19.3c-.1-.8-.2-2 0-2.9l1.2-5.1s-.3-.6-.3-1.5c0-1.4.8-2.4 1.8-2.4.9 0 1.3.6 1.3 1.4 0 .9-.6 2.2-.9 3.4-.2 1 .5 1.8 1.5 1.8 1.8 0 3-1.9 3-4.6 0-2.4-1.7-4.1-4.1-4.1-2.9 0-4.6 2.1-4.6 4.3 0 .9.3 1.8.7 2.3.1.1.1.2.1.3l-.3 1c0 .2-.1.2-.3.1-1.2-.6-2-2.4-2-3.8 0-3.1 2.3-6 6.5-6 3.4 0 6.1 2.4 6.1 5.7 0 3.4-2.1 6.1-5.1 6.1-1 0-1.9-.5-2.2-1.1l-.6 2.3c-.2.8-.8 1.9-1.2 2.5A10 10 0 1 0 12 2z'],
    ['x', '#111111', 'M17.5 3h3.1l-6.8 7.8L21.8 21h-6.2l-4.9-6.4L5.1 21H2l7.3-8.3L2.3 3h6.3l4.4 5.8L17.5 3zm-1.1 16.1h1.7L7.7 4.8H5.9l10.5 14.3z'],
    ['linkedin', '#0A66C2', 'M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM3 9h4v12H3V9zm7 0h3.8v1.7h.1c.5-.9 1.8-1.9 3.6-1.9 3.9 0 4.5 2.4 4.5 5.6V21h-4v-5.6c0-1.3 0-3-1.9-3s-2.1 1.4-2.1 2.9V21h-4V9z'],
    ['patreon', '#FF424D', 'M3 3h3.4v18H3V3zm11.3 0a6.7 6.7 0 1 1 0 13.4 6.7 6.7 0 0 1 0-13.4z'],
    ['bmac', '#E0A800', 'M5 8h11v6.5A4.5 4.5 0 0 1 11.5 19h-2A4.5 4.5 0 0 1 5 14.5V8zm11 1.2h1.3a2.4 2.4 0 0 1 0 4.8H16V9.2zM6.5 3.2l.9 1.6-.9 1.6M9.9 3.2l.9 1.6-.9 1.6M13.3 3.2l.9 1.6-.9 1.6'],
    ['gumroad', '#D66FBE', 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm.5 5.2c-2.9 0-5 2.2-5 5.1 0 2.8 1.9 4.8 4.5 4.8 1.3 0 2.4-.5 3.1-1.4v1.1h2.4v-5.2h-5.3v2h2.6c-.3 1.1-1.3 1.8-2.6 1.8-1.6 0-2.7-1.3-2.7-3.1 0-1.9 1.2-3.2 2.9-3.2 1.1 0 2 .5 2.5 1.3l2.2-1.3c-1-1.4-2.6-2.2-4.6-2.2z'],
    ['substack', '#FF6719', 'M4 3h16v2.6H4V3zm0 4.6h16v2.6H4V7.6zM4 12.2 12 16l8-3.8V21l-8-3.8L4 21v-8.8z'],
    ['web', '#1a1c1d', 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm6.9 6h-2.6a15 15 0 0 0-1.4-3.5A8 8 0 0 1 18.9 8zM12 4.2c.7 1 1.3 2.3 1.6 3.8h-3.2c.3-1.5.9-2.8 1.6-3.8zM4.3 14a8 8 0 0 1 0-4h3a17 17 0 0 0 0 4h-3zm.8 2h2.6c.3 1.3.8 2.5 1.4 3.5A8 8 0 0 1 5.1 16zm2.6-8H5.1a8 8 0 0 1 4-3.5C8.5 5.5 8 6.7 7.7 8zM12 19.8c-.7-1-1.3-2.3-1.6-3.8h3.2c-.3 1.5-.9 2.8-1.6 3.8zm2-5.8h-4a15 15 0 0 1 0-4h4a15 15 0 0 1 0 4zm.9 5.5c.6-1 1.1-2.2 1.4-3.5h2.6a8 8 0 0 1-4 3.5zm2.1-5.5a17 17 0 0 0 0-4h3a8 8 0 0 1 0 4h-3z']
  ];

  function pageLang() {
    var l = '';
    try {
      l = document.documentElement.getAttribute('lang') || '';
      if (!l && window.Shopify && window.Shopify.locale) l = window.Shopify.locale;
    } catch (e) {}
    l = String(l || 'en').split('-')[0].toLowerCase();
    return l || 'en';
  }

  function readMoreLabel() {
    try {
      if (window.__levaReadMoreLabel) return window.__levaReadMoreLabel;
    } catch (e) {}
    return 'Read more';
  }

  var PENCIL = 'M3 17.25V21h3.75L17.8 9.94l-3.75-3.75L3 17.25zM20.7 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z';

  var PERSON = 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z';

  var CODES = {
    'united states': 'us', 'usa': 'us', 'united states of america': 'us',
    'united kingdom': 'gb', 'uk': 'gb', 'great britain': 'gb', 'england': 'gb',
    'czechia': 'cz', 'czech republic': 'cz', 'slovakia': 'sk',
    'germany': 'de', 'austria': 'at', 'poland': 'pl', 'france': 'fr',
    'spain': 'es', 'italy': 'it', 'portugal': 'pt', 'netherlands': 'nl',
    'belgium': 'be', 'switzerland': 'ch', 'sweden': 'se', 'norway': 'no',
    'denmark': 'dk', 'finland': 'fi', 'ireland': 'ie', 'canada': 'ca',
    'mexico': 'mx', 'brazil': 'br', 'australia': 'au', 'new zealand': 'nz',
    'japan': 'jp', 'south korea': 'kr', 'hungary': 'hu', 'romania': 'ro',
    'greece': 'gr', 'turkey': 'tr'
  };

  function flagCode(country) {
    var v = (country || '').toString().trim().toLowerCase();
    if (!v) return '';
    if (/^[a-z]{2}$/.test(v)) return v;
    return CODES[v] || '';
  }

  function icon(path, size, color) {
    var svg = document.createElementNS(SVG, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', size);
    svg.setAttribute('height', size);
    svg.setAttribute('fill', color);
    svg.setAttribute('aria-hidden', 'true');
    var p = document.createElementNS(SVG, 'path');
    p.setAttribute('d', path);
    svg.appendChild(p);
    return svg;
  }

  function style() {
    if (document.getElementById('prof-l01-style')) return;
    var css = ''
      /* ---- shared ---- */
      + '.prof-prev{position:relative;margin:24px 0 0 0;}'
      + '.prof-prev__edit{flex:0 0 auto;width:30px;height:30px;border-radius:50%;background:#fff;border:1px solid #d7dade;color:#1a1c1d;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;}'
      + '.prof-prev__photorow{display:flex;align-items:center;justify-content:center;gap:14px;margin-bottom:12px;}'
      + '.prof-prev__edit:hover{background:#f3f4f6;}'
      + '.prof-prev__grid{display:flex;flex-direction:column;align-items:center;gap:20px;text-align:center;}'
      + '.prof-prev__col{min-width:0;width:100%;}'
      + '.prof-prev__photo{position:relative;width:96px;height:96px;flex:0 0 auto;margin:0;}'
      + '.prof-prev__avatar{width:96px;height:96px;border-radius:50%;background:#e9eaec no-repeat center/cover;color:#b6bbc1;display:flex;align-items:center;justify-content:center;overflow:hidden;}'
      + '.prof-prev__flag{position:absolute;right:-2px;bottom:-2px;width:30px;height:30px;border-radius:50%;overflow:hidden;background:#fff;border:2px solid #fff;box-shadow:0 1px 3px rgba(0,0,0,.15);}'
      + '.prof-prev__flag img{width:100%;height:100%;object-fit:cover;display:block;}'
      + '.prof-prev__flag--ph{opacity:.5;}'
      + '.prof-prev__badge{display:inline-block;margin-top:8px;font-size:11px;letter-spacing:.06em;padding:4px 10px;border-radius:999px;background:#fdf0d5;color:#8a6100;}'
      + '.prof-prev__badge--live{background:#e6f4ea;color:#1c6b38;}'
      + '.prof-prev__empty{cursor:pointer;}'
      + '.prof-prev__country{font-size:11px;letter-spacing:.06em;color:#9aa0a6;margin-top:6px;}'
      + '.prof-prev__name{font-size:20px;font-weight:600;color:#1a1c1d;line-height:1.25;white-space:nowrap;overflow:hidden;}'
      + '.prof-prev__loc{display:inline-flex;align-items:center;gap:6px;font-size:12.5px;color:#6B7280;margin-top:2px;}'
      + '.prof-prev__loc svg{display:block;flex:0 0 auto;}'
      + '.prof-prev__bio--clamp{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}'
      + '.prof-prev__more{border:0;background:none;padding:0;margin-top:2px;font-family:inherit;'
      + 'font-size:12px;font-weight:600;color:#1A1C1D;cursor:pointer;text-decoration:underline;}'
      + '.prof-prev__handle{font-size:14px;color:#9aa0a6;margin-bottom:4px;}'
      + '.prof-prev__followers{font-size:16px;font-weight:600;color:#1a1c1d;margin:0 0 12px 0;}'
      + '.prof-prev__followers span{display:block;font-size:11px;font-weight:400;letter-spacing:.04em;color:#9aa0a6;margin-top:2px;}'
      + '@media (min-width:860px){.prof-prev__followers span{display:inline;margin:0 0 0 14px;}}'
      + '.prof-prev__bio{font-size:13px;line-height:1.6;color:#6b7280;}'
      + '.prof-prev__socials{display:flex;flex-wrap:wrap;justify-content:center;gap:10px;margin-top:16px;}'
      + '.prof-prev__socials a,.prof-prev__socials span{width:38px;height:38px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:#fff;border:1px solid #e6e7e9;}'
      + '.prof-prev__socials span{opacity:.45;filter:grayscale(1);}'
      + '.prof-prev__ph{color:#c2c7cc;}'
      /* ---- mobile divider ---- */
      + '.prof-prev__col--content{border-top:1px solid #a9aeb4;padding-top:20px;}'
      /* ---- desktop ---- */
      + '@media (min-width:860px){'
      + '.prof-prev__grid{flex-direction:row;align-items:stretch;gap:0;text-align:left;}'
      + '.prof-prev__col--ident{flex:0 0 24%;max-width:24%;padding-right:28px;text-align:right;}'
      + '.prof-prev__col--content{flex:1 1 auto;border-top:0;padding-top:0;padding-left:28px;border-left:1px solid #a9aeb4;display:flex;flex-direction:column;justify-content:center;text-align:left;}'
      + '.prof-prev__photorow{justify-content:flex-end;}'
      + '.prof-prev__socials{flex-wrap:nowrap;justify-content:flex-start;gap:8px;}'
      + '.prof-prev__socials a,.prof-prev__socials span{width:34px;height:34px;flex:0 0 auto;}'
      + '}';
    var tag = document.createElement('style');
    tag.id = 'prof-l01-style';
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  function build(api, target, overrideProfile, overrideStatus) {
    style();
    var embedded = !!target;
    var p = (overrideProfile !== undefined && overrideProfile !== null)
      ? overrideProfile
      : (api.getShownProfile() || {});
    var wide = window.matchMedia('(min-width:860px)').matches;

    var domId = embedded ? 'prof-card-embed' : 'prof-l01';
    var old = document.getElementById(domId);
    if (old && old.parentNode) old.parentNode.removeChild(old);

    var box = document.createElement('div');
    box.className = 'prof-prev';
    box.id = domId;

    var grid = document.createElement('div');
    grid.className = 'prof-prev__grid';

    /* ---- left third: photo, flag, name, handle, followers ---- */
    var c1 = document.createElement('div');
    c1.className = 'prof-prev__col prof-prev__col--ident';

    var photo = document.createElement('div');
    photo.className = 'prof-prev__photo';
    var avatar = document.createElement('div');
    avatar.className = 'prof-prev__avatar';
    if (p.photo_url) avatar.style.backgroundImage = 'url(' + p.photo_url + ')';
    else avatar.appendChild(icon(PERSON, 46, 'currentColor'));
    photo.appendChild(avatar);

    var code = flagCode(p.country);
    var flag = document.createElement('div');
    flag.className = 'prof-prev__flag' + (code ? '' : ' prof-prev__flag--ph');
    var fimg = document.createElement('img');
    fimg.src = 'https://flagcdn.com/w80/' + (code || 'us') + '.png';
    fimg.alt = (code || 'us').toUpperCase();
    fimg.loading = 'lazy';
    flag.appendChild(fimg);
    photo.appendChild(flag);

    var photorow = document.createElement('div');
    photorow.className = 'prof-prev__photorow';

    var edit = document.createElement('button');
    edit.type = 'button';
    edit.className = 'prof-prev__edit';
    edit.title = 'Edit';
    edit.setAttribute('aria-label', 'Edit');
    edit.appendChild(icon(PENCIL, 14, 'currentColor'));
    edit.addEventListener('click', function () { api.open(); });

    if (!embedded && !api.isForeign()) photorow.appendChild(edit);
    photorow.appendChild(photo);
    c1.appendChild(photorow);

    var name = document.createElement('div');
    name.className = 'prof-prev__name';
    name.textContent = p.name || 'Your name here';
    if (!p.name) name.classList.add('prof-prev__ph');
    c1.appendChild(name);

    if (p.address) {
      var locEl = document.createElement('div');
      locEl.className = 'prof-prev__loc';
      var pin = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      pin.setAttribute('viewBox', '0 0 24 24');
      pin.setAttribute('width', '13');
      pin.setAttribute('height', '13');
      var pp2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      pp2.setAttribute('d', 'M12 2a7 7 0 0 0-7 7c0 5.2 7 13 7 13s7-7.8 7-13a7 7 0 0 0-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z');
      pp2.setAttribute('fill', '#D8232A');
      pin.appendChild(pp2);
      locEl.appendChild(pin);
      var locTx = document.createElement('span');
      locTx.textContent = String(p.address).split(',')[0];
      locEl.appendChild(locTx);
      c1.appendChild(locEl);
    }

    var st = (overrideStatus !== undefined && overrideStatus !== null) ? overrideStatus : api.getShownStatus();
    if (st === 'pending') {
      var badge = document.createElement('div');
      badge.className = 'prof-prev__badge';
      badge.textContent = api.t('review');
      c1.appendChild(badge);
    }

    if (!code && p.country) {
      var ctry = document.createElement('div');
      ctry.className = 'prof-prev__country';
      ctry.textContent = p.country;
      c1.appendChild(ctry);
    }

    grid.appendChild(c1);

    /* ---- right two thirds: bio, then one row of icons ---- */
    var c2 = document.createElement('div');
    c2.className = 'prof-prev__col prof-prev__col--content';

    var handle = document.createElement('div');
    handle.className = 'prof-prev__handle';
    handle.textContent = '@' + (p.handle || 'yourhandle');
    c2.appendChild(handle);

    var fol = document.createElement('div');
    fol.className = 'prof-prev__followers';
    fol.textContent = p.followers || '0';
    var folLabel = document.createElement('span');
    folLabel.textContent = 'followers and subscribers';
    fol.appendChild(folLabel);
    c2.appendChild(fol);

    var bio = document.createElement('div');
    bio.className = 'prof-prev__bio';
    bio.textContent = p.bio || 'A short line about what you build, where you work and what you are known for.';
    if (!p.bio) bio.classList.add('prof-prev__ph');
    c2.appendChild(bio);

    if (p.bio && p.bio.length > 140) {
      bio.classList.add('prof-prev__bio--clamp');
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'prof-prev__more';
      more.textContent = readMoreLabel();
      more.addEventListener('click', function () {
        var clamped = bio.classList.toggle('prof-prev__bio--clamp');
        more.hidden = !clamped;
      });
      c2.appendChild(more);
    }

    var filled = 0;
    for (var k = 0; k < NETS.length; k++) { if (p[NETS[k][0]]) filled++; }

    var socials = document.createElement('div');
    socials.className = 'prof-prev__socials';
    var ordered = [];
    for (var f = 0; f < NETS.length; f++) { if (p[NETS[f][0]]) ordered.push(NETS[f]); }
    for (var e = 0; e < NETS.length; e++) { if (!p[NETS[e][0]]) ordered.push(NETS[e]); }
    var shown = wide ? ordered : ordered.slice(0, 5);
    for (var i = 0; i < shown.length; i++) {
      var key = shown[i][0];
      var color = shown[i][1];
      var path = shown[i][2];
      var url = p[key];
      var node;
      if (url) {
        node = document.createElement('a');
        node.href = url;
        node.target = '_blank';
        node.rel = 'noopener';
        node.title = key;
        node.appendChild(icon(path, wide ? 17 : 19, color));
      } else {
        node = document.createElement('span');
        node.title = key;
        node.appendChild(icon(path, wide ? 17 : 19, '#8b9096'));
      }
      socials.appendChild(node);
    }
    c2.appendChild(socials);
    grid.appendChild(c2);

    box.appendChild(grid);

    if (!embedded && !p.name && !api.isForeign()) {
      box.classList.add('prof-prev__empty');
      box.setAttribute('role', 'button');
      box.setAttribute('tabindex', '0');
      box.addEventListener('click', function () { api.open(); });
      box.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); api.open(); }
      });
    }

    if (embedded) {
      target.appendChild(box);
    } else if (api.root) {
      var tagline = api.root.querySelector('[data-prof-tagline]');
      if (tagline && tagline.nextSibling) api.root.insertBefore(box, tagline.nextSibling);
      else if (tagline) api.root.appendChild(box);
      else api.root.insertBefore(box, api.root.firstChild);
    }

    requestAnimationFrame(function () { fitName(name); });
  }

  function fitName(node) {
    if (!node || !node.parentNode) return;
    var size = 20;
    node.style.fontSize = size + 'px';
    var guard = 0;
    while (node.scrollWidth > node.clientWidth + 1 && size > 12 && guard < 24) {
      size -= 1;
      node.style.fontSize = size + 'px';
      guard++;
    }
  }

  window.LevaProfile.register(function (api) {
    var timer = null;
    api.renderCard = function (container, profile, status) {
      if (!container) return;
      build(api, container, profile || {}, status || 'none');
    };
    build(api);
    api.on('save', function () { build(api); });
    api.on('paint', function () { build(api); });
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { build(api); }, 200);
    });
  });
})();

/* ============================================================================
   SHARED BUDGETS  --  the vendor drawer, the profile card it shows, the
   implement icons and the price requests. It used to live inside
   budget-core.liquid, which was at ninety percent of the 256 kB a Liquid
   file may hold. It sits here rather than in a file of its own: this asset
   is always loaded with it, and one more place to edit helps nobody.
   Strings arrive from the page as window.__levaSharedT.
   ============================================================================ */

(function () {
  var VERSION = 'bic-v190';   /* bic-v190 (2026-10-31): the admin's LOG button on the quote sheets is gone (isLogAllowed false); bic-v189 (2026-10-28 23:49, Marek: udelat jeste upravy UI a workflow, aby to odpovidalo tomu, co je v reel -- the supplier's offer in a few clicks): LevaQuotes.quotePreview(k, r) -- the request priced from the supplier's own budget (his LEVA price list, times and rates) by the quote sheet's own arithmetic (qsPickedTotals / qsCardLines), what he offers set as the sheet sets it when the sheet was never opened; LevaQuotes.sendQuote({ coef, rateCoef, name, phone }) -- the sheet's SEND QUOTE from the AI drawer's card (the same record, the same coefficients, the same remembered prefs); bic-v188 (2026-10-27 15:25, Marek: Proc by ji mel videt jako cekajici? Kdyz ji zodpovi jsi registrovany vendor?): A SHARED REQUEST SEEN BY ONE SUPPLIER IS HIS OWN -- quotesForMe lays the supplier's own answer (offers qa_<request>_<him>) over the shared request, so his lists, the bar and the assistant show it answered (and his figures); his NO / bin on a shared request marks only him (declinedBy.<him> on the request) instead of declining or deleting it for everyone, and a request he declined stays away from him; bic-v187 (2026-10-27 15:06, Marek: jeden email z uzivatelova emailu, adresaty do skryte kopie; vsichni stejny odkaz, roztrideni podle toho, kdo nabidku vyplni - musi se registrovat): ONE REQUEST TO SEVERAL SUPPLIERS -- sendTracked opens one mail from the sender's own client, the sender in To and the suppliers in Bcc, all with the same link; a request with more than one address keeps every supplier's answer apart: writeQuote writes it as an offers record of its own (qa_<request>_<supplier>, requestId, toEmails the requester) instead of over the request, and LevaThreads.list reads those answers back as the requester's priced offers; bic-v186 (2026-10-27 14:37, Marek: "Muzes tedy vsechno z reel zakomponovat? I pro poptavajiciho i pro dodavatele?"): LevaQuotes.me / setMe / labels / preview / sendTracked -- the AI drawer's request card sends a TRACKED request (the same quotes record and mail as the request form, so the offer comes back to compare); LevaQuotes.current / priceIt for the supplier's card in the drawer; events leva:quote-request (a ?leva_quote page found its pending request) and leva:quote-sent (SEND QUOTE went through, with the card's figures); bic-v185 (2026-10-27, AI reel step 3): the quote sheet's card (paintCard / qsCardLines), SEND as its red button; bic-v184 (deployed under the label prof-v281): LevaThreads rows carry offerFigures(q) for the assistant's COMPARE OFFERS */

  var T = window.__levaSharedT || {};

  var IMG = {
    share: 'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/share.png?v=1763914930',
    open: 'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Download.png?v=1772623164'
  };

  /* A plain envelope: a rounded rectangle with the flap folding into it.
     Drawn in line rather than loaded, so there is nothing to upload and
     nothing to go missing. */
  var QUOTE_ICON = [
    { d: 'M4 5.5h16a2.5 2.5 0 0 1 2.5 2.5v8a2.5 2.5 0 0 1-2.5 2.5H4A2.5 2.5 0 0 1 1.5 16V8A2.5 2.5 0 0 1 4 5.5z', fill: 'none' },
    { d: 'M2.4 7.2l7.8 5.9a3 3 0 0 0 3.6 0l7.8-5.9', fill: 'none' }
  ];

  function style() {
    if (document.getElementById('bic-style')) return;
    var css = ''
      + '.bic{display:flex;align-items:center;gap:12px;margin:14px 0 4px 0;}'
      + '.bic--head{margin:0 auto 0 50px;}'
      + '.budget-drawer__header{align-items:center;}'
      /* On a phone the title and three icons do not fit on one line, so
         the title broke in half. The icons take a row of their own. */
      + '@media (max-width:749px){'
      + '.budget-drawer__header{flex-wrap:wrap;}'
      + '.budget-drawer__title{flex:1 1 100%;white-space:nowrap;}'
      + '.bic--head{flex:1 1 100%;margin:10px 0 2px 0;justify-content:flex-start;order:3;}'
      + '.budget-drawer__header .budget-drawer__close,'
      + '.budget-drawer__header .side-panel-close{order:2;margin-left:auto;}'
      + '.budget-drawer__title{order:1;flex:0 1 auto;}'
      + '.bic--head .bic__b{width:38px;height:38px;}'
      + '.bic--head .bic__b img,.bic--head .bic__b svg{width:18px;height:18px;}'
      + '}'
      + '.bic__b{width:45px;height:45px;border-radius:50%;border:0;padding:0;cursor:pointer;'
      + 'display:inline-flex;align-items:center;justify-content:center;box-shadow:0 6px 22px rgba(0,0,0,.18);}'
      + '.bic__b--share{background:#262626;}'
      + '.bic__b--open{background:#7B5FC9;}'
      + '.bic__b--quote{background:#D8232A;}'
      + '.bic__b img{width:22px;height:22px;display:block;filter:brightness(0) invert(1);}'
      + '.bic__b--sm{width:32px;height:32px;box-shadow:0 3px 12px rgba(0,0,0,.14);}'
      + '.bic__b--sm img{width:15px;height:15px;}'
      + '.bic-sec{display:inline-flex;align-items:center;gap:8px;margin-left:10px;vertical-align:middle;}'
      + '.bic--block{margin:0 0 16px 0;justify-content:center;}'
      + '.bic--block .bic__b{width:36px;height:36px;box-shadow:0 4px 14px rgba(0,0,0,.16);}'
      + '.bic--block .bic__b img{width:18px;height:18px;}'
      + '.bic-d__msg{font-size:13px;color:#6B7280;padding:16px 0;}'
      + '.rq-state{margin-top:6px;font-size:10px;font-weight:700;'
      + 'letter-spacing:.05em;text-transform:uppercase;border-radius:999px;padding:2px 8px;'
      + 'background:#F3F4F6;color:#6B7280;}'
      + '.rq-state--waiting{background:#FFF7EC;color:#8a6100;}'
      + '.rq-state--approved{background:#EDF6EF;color:#2E7D46;}'
      + '.rq-state--soon{background:#FFF7EC;color:#B45309;}'
      + '.rq-state--expired{background:#FDECEC;color:#D8232A;}'
      + '.rq-state--declined{background:#F3F4F6;color:#9CA3AF;}'
      // the hidden figure sits where a real one would
      + '.rq-locked{color:#C7CACD;letter-spacing:0;}'
      + '.vdr-cfgnote{background:#FFF7EC;border:1px solid #E8D6B8;border-radius:12px;'
      + 'padding:10px 12px;margin:0 0 12px;width:100%;}'
      + '.vdr-cfgnote__t{font-size:12px;line-height:1.35;color:#8a6100;}'
      + '.vdr-cfgnote__s{font-size:18px;font-weight:700;color:#1A1C1D;margin-top:4px;}'
      + '.qs-log{border:1px solid #D2A878;background:#fff;color:#8a6100;border-radius:999px;'
      + 'padding:3px 10px;font-size:11px;font-family:inherit;cursor:pointer;position:relative;z-index:6;'
      + 'margin:6px 8px 6px 0;flex:0 0 auto;align-self:flex-start;}'
      + '#Leva-Shared-Drawer .side-panel-content--inner{padding-top:0;}'
      + '#Leva-Shared-Drawer .share-drawer-panel{padding-top:0 !important;}'
      + '#Leva-Shared-Drawer .share-recommended-filters{margin-top:6px;margin-bottom:6px;}'
      + '.share-budget-drawer.is-data-mode .side-panel-content--inner{padding-top:0;}'
      + '.share-budget-drawer.is-data-mode #ddDrawerScroll{padding-top:8px !important;}'
      + '.share-budget-drawer.is-data-mode #ddDrawerScroll > .dd-section-sep:first-child{display:none;}'
      + '.share-budget-drawer.is-data-mode .dd-purchase-notice + .dd-section-sep{display:none;}'
      + '.share-budget-drawer.is-data-mode #share-panel-data{margin-top:0;padding-top:0;border-top:0;}'
      + '.share-budget-drawer.is-data-mode #share-panel-data > :first-child'
      + '{border-top:0 !important;margin-top:0 !important;}';
    var tag = document.createElement('style');
    tag.id = 'bic-style';
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  function button(kind, title, small, onClick) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'bic__b bic__b--' + kind + (small ? ' bic__b--sm' : '');
    b.title = title;
    b.setAttribute('aria-label', title);
    if (IMG[kind]) {
      var img = document.createElement('img');
      img.src = IMG[kind];
      img.alt = '';
      b.appendChild(img);
    } else {
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('width', small ? '15' : '22');
      svg.setAttribute('height', small ? '15' : '22');
      svg.setAttribute('fill', 'none');
      for (var q = 0; q < QUOTE_ICON.length; q++) {
        var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        p.setAttribute('d', QUOTE_ICON[q].d);
        if (QUOTE_ICON[q].fill === 'solid') {
          p.setAttribute('fill', '#fff');
        } else {
          p.setAttribute('fill', 'none');
          p.setAttribute('stroke', '#fff');
          p.setAttribute('stroke-width', '1.9');
          p.setAttribute('stroke-linecap', 'round');
          p.setAttribute('stroke-linejoin', 'round');
        }
        svg.appendChild(p);
      }
      b.appendChild(svg);
    }
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      onClick();
    });
    return b;
  }

  /* ---- drawer handle ---- */
  function drawer() {
    return document.getElementById('Leva-Shared-Drawer');
  }

  function lift(d) {
    if (!d || d.getAttribute('data-bic-lifted') === '1') return;
    d.setAttribute('data-bic-lifted', '1');
    document.body.appendChild(d);
  }

  /* ---- moving the shared budget panel in and out ---- */
  var PANELS = [];
  var moved = [];

  function panelIds() {
    if (PANELS.length) return PANELS;
    PANELS = document.getElementById('share-panel-recommended-product')
      ? ['#share-panel-recommended-product']
      : ['#share-panel-recommended'];
    return PANELS;
  }

  function takePanels(host) {
    var ids = panelIds();
    if (moved.length) {
      for (var m = 0; m < moved.length; m++) {
        moved[m].node.hidden = false;
        moved[m].node.classList.add('tab-active');
        if (moved[m].node.parentNode !== host) host.appendChild(moved[m].node);
      }
      askForList();
      return;
    }
    for (var i = 0; i < ids.length; i++) {
      var node = document.querySelector(ids[i]);
      if (!node || !node.parentNode) continue;
      var mark = document.createComment('bic-slot');
      node.parentNode.insertBefore(mark, node);
      moved.push({
        node: node,
        mark: mark,
        wasHidden: node.hidden,
        wasActive: node.classList.contains('tab-active')
      });
      // share drawer panels render only with tab-active on them. Moving
      // the panel without it left their cards drawn into an invisible
      // box, which is why this list once looked empty.
      node.hidden = false;
      node.classList.add('tab-active');
      host.appendChild(node);
    }
    askForList();
  }

  function returnPanels() {
    for (var i = moved.length - 1; i >= 0; i--) {
      var m = moved[i];
      m.node.hidden = m.wasHidden;
      if (!m.wasActive) m.node.classList.remove('tab-active');
      if (m.mark && m.mark.parentNode) {
        m.mark.parentNode.insertBefore(m.node, m.mark);
        m.mark.parentNode.removeChild(m.mark);
      }
    }
    moved = [];
  }

  // Call their loader directly and keep at it. The load is slow because
  // it waits for their location lookup, so it is prefetched at page load
  // and retried until cards actually land. Every failure is kept for the
  // LOG report.
  var listTries = 0;
  var lastErr = '';

  function listEl() {
    return document.getElementById('share-recommended-product-list');
  }

  // Country and the variant filter stopped meaning anything here: the
  // list shows everything for the product, nearest first. The controls
  // are unticked and hidden, not removed, so their code keeps reading
  // them without noticing.
  function tunePanel() {
    var f = document.getElementById('share-recommended-product-variant-filter');
    if (f) {
      if (f.checked) f.checked = false;
      var row = f.closest ? (f.closest('label') || f.parentElement) : f.parentElement;
      if (row) row.style.display = 'none';
    }
    var sel = document.getElementById('share-recommended-product-country');
    if (sel) {
      var wrap = sel.closest ? (sel.closest('.share-country-select-wrap') || sel.parentElement) : sel.parentElement;
      (wrap || sel).style.display = 'none';
    }
    var flag = document.querySelector('[data-share-recommended-product-country-flag]');
    if (flag) flag.style.display = 'none';
  }

  function callLoader() {
    tunePanel();
    if (typeof window.__levaLoadProductBudgets === 'function') {
      try {
        window.__levaLoadProductBudgets();
        return true;
      } catch (e) {
        lastErr = (e && e.message) ? e.message : String(e);
        console.error('bic list load failed', e);
      }
    } else {
      lastErr = 'loader not exposed';
    }
    var sel = document.getElementById('share-recommended-product-country');
    if (sel) sel.dispatchEvent(new Event('change', { bubbles: true }));
    var sort = document.querySelector('[data-share-sort="nearest"]');
    if (sort) sort.click();
    return false;
  }

  function askForList() {
    listTries = 0;
    setTimeout(retryList, 80);
  }

  function retryList() {
    var el = listEl();
    if (el && el.children.length > 0) return;
    if (listTries >= 4) return;
    listTries++;
    callLoader();
    setTimeout(retryList, 2500);
  }

  // warm it up long before anyone opens the drawer: the loader renders
  // into the panel wherever it currently sits
  var prefetched = false;
  function prefetchList() {
    if (prefetched) return;
    prefetched = true;
    setTimeout(function () {
      var el = listEl();
      if (el && el.children.length === 0) callLoader();
    }, 1200);
  }

  /* ---- tabs ---- */
  function setTab(key) {
    var d = drawer();
    if (!d) return;
    var all = d.querySelectorAll('[data-bic-tab]');
    for (var i = 0; i < all.length; i++) {
      var on = all[i].getAttribute('data-bic-tab') === key;
      all[i].classList.toggle('tab-active', on);
      all[i].setAttribute('aria-selected', on ? 'true' : 'false');
      all[i].setAttribute('tabindex', on ? '0' : '-1');
    }
    var lists = d.querySelector('[data-bic-lists]');
    var note = d.querySelector('[data-bic-note]');
    var isAuthors = key === 'authors';
    if (lists) lists.hidden = !isAuthors;
    if (note) {
      note.hidden = isAuthors;
      if (key === 'vendors') note.textContent = T.noVendors;
    }
  }

  /* ---- open and close ---- */
  function closeShareDrawer() {
    var sd = document.getElementById('Share-Budget-Drawer');
    if (!sd || !sd.classList.contains('active')) return;
    var sc = sd.querySelector('side-panel-close');
    if (sc) sc.click();
    else sd.classList.remove('active');
  }

  function open() {
    var d = drawer();
    if (!d) return;
    closeShareDrawer();
    raise(d);
    closeQuotes();
    closeBudget();
    /* Nothing to mark as read: the number is a count of what is available,
       so opening the drawer does not make the budgets go away. */
    takePanels(d.querySelector('[data-bic-lists]'));
    setTab('authors');
    d.classList.add('active');
    document.body.classList.add('open-cc');
  }

  function close() {
    var d = drawer();
    returnPanels();
    if (!d) return;
    d.classList.remove('active');
    // open-cc on body is shared by every side panel. Strip it only when
    // no panel is left open, otherwise closing this drawer while the
    // share drawer slides in kills the share drawer too.
    if (!document.querySelector('.side-panel.active')) {
      document.body.classList.remove('open-cc');
    }
  }

  /* The three drawers behave as one set: whichever is asked for comes to
     the front. The share drawer takes its stacking from the theme, so on
     a configurator page it slid in underneath the budget drawer; it is
     lifted to the body and raised like the other two. */
  function raise(el) {
    if (!el) return;
    lift(el);
    el.style.zIndex = '100002';
  }

  function shareProfile() {
    close();
    closeQuotes();
    var sd = document.getElementById('Share-Budget-Drawer');
    raise(sd);
    if (typeof window.openShareBudgetDrawer === 'function') {
      window.openShareBudgetDrawer('settings');
    }
    closeBudget();
  }

  function closeBudget() {
    var m = document.getElementById('Budget-Drawer');
    if (m) m.classList.remove('active');
  }

  function closeQuotes() {
    var q = document.getElementById('Leva-Quotes-Drawer');
    if (!q || !q.classList.contains('active')) return;
    q.classList.remove('active');
    if (!document.querySelector('.side-panel.active')) {
      document.body.classList.remove('open-cc');
    }
  }

  /* ---- icons on the budget ---- */
  // Both mount points are retired: share, shared budgets and quotes are
  // reached from the floating bar, which is the only place they live now.
  // style() still has to run -- the same tag carries the drawer rules.

  // No icon on subcategory rows: the drawer they opened is the complete
  // list of budgets for the product, so going through one subcategory
  // never narrowed anything down.

  /* ---- the old tabs those lists lived under ---- */
  function hideOldTabs() {
    // share-tab-data included: Your Data is its own drawer now, opened
    // from the block section only, never a tab inside Share Data.
    var ids = ['share-tab-recommended', 'share-tab-recommended-product', 'share-tab-data'];
    for (var i = 0; i < ids.length; i++) {
      var t = document.getElementById(ids[i]);
      if (t) t.hidden = true;
    }
  }

  /* ---- wiring ---- */
  function wire() {
    var d = drawer();
    if (!d || d.getAttribute('data-bic-wired') === '1') return;
    d.setAttribute('data-bic-wired', '1');

    var tabs = d.querySelectorAll('[data-bic-tab]');
    for (var i = 0; i < tabs.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          setTab(btn.getAttribute('data-bic-tab'));
        });
      })(tabs[i]);
    }

    // whoever removes the active class, the panels must go home
    new MutationObserver(function () {
      if (moved.length && !d.classList.contains('active')) close();
    }).observe(d, { attributes: true, attributeFilter: ['class'] });

  }

  /* ---- debug: one tap copies what is really in the drawer ---- */
  /* A budget shared on demand cannot be opened, only asked for, so its
     card carries the envelope on the right edge, halfway down -- the
     same place the download sits on the ones that are free to take. */
  /* ============================================================
     A CARD SHOULD SAY WHERE YOU STAND
     A budget shared on request looked the same whether you had never
     asked, were waiting, had been let in, or had run out -- one envelope
     for all four, and the answer arrived only after clicking. The state
     goes on the card, and with it the price: the total was sitting there
     in plain view, which is the very number the owner is holding back.
     Some vendors want that control absolutely, so nothing of the figure
     shows until they say yes.
     ============================================================ */
  function askedState(token, cb) {
    var me = myMail();
    if (!window.db || !token || !me) { cb('none'); return; }
    qOne('requests', 'fromEmail', '==', me).then(function (rows) {
      var state = 'none';
      var best = 0;
      var days = null;
      rows.forEach(function (doc) {
        var r = doc.q;
        if (String(r.budgetToken || '') !== String(token)) return;
        var at = toMillis(r.createdAt);
        if (at < best) return;
        best = at;
        days = null;
        if (r.status === 'approved') {
          var until = toMillis(r.grantUntil);
          if (until && until > Date.now()) {
            state = 'approved';
            days = Math.ceil((until - Date.now()) / 86400000);
          } else state = 'expired';
        } else if (r.status === 'declined') state = 'declined';
        else state = 'waiting';
      });
      cb(state, days);
    }).catch(function () { cb('none'); });
  }

  function paintCardState(row, state, days) {
    var side = row.querySelector('.share-recommended-item-side');
    var total = row.querySelector('.share-recommended-item-pill--total');

    if (total && state !== 'approved') {
      total.classList.add('rq-locked');
      total.textContent = '???';
    }

    var old = row.querySelector('.rq-state');
    if (old && old.parentNode) old.parentNode.removeChild(old);

    var words = {
      none: (T.rq && T.rq.stNone) || 'Not requested',
      waiting: (T.rq && T.rq.stPending) || 'Requested',
      approved: (T.rq && T.rq.stApproved) || 'Approved',
      expired: (T.rq && T.rq.qExpired) || 'expired',
      declined: (T.rq && T.rq.stDeclined) || 'Declined'
    };
    /* ACCESS THAT IS ABOUT TO GO SAYS SO. It used to drop overnight and
       both sides found out by the budget refusing to open -- too late to
       ask again without a gap. Inside a week the tag counts down and
       turns, which is enough warning to ask before it lapses. */
    var label = words[state] || words.none;
    var cls = state;
    if (state === 'approved' && days != null) {
      if (days <= 7) {
        cls = 'soon';
        label = ((T.rq && T.rq.stSoon) || 'ends in %d days').split('%d').join(String(days));
      } else {
        label = words.approved + '  ' + days + 'd';
      }
    }

    /* WEAR THE CARD'S OWN CLOTHES. A free budget lines up on the right
       because nothing is added to it; this tag arrived with a width and a
       padding of its own and pushed the column off the margin. It is now
       one of the card's pills, so the theme decides where the edge is. */
    var tag = document.createElement('span');
    tag.className = 'share-recommended-item-pill rq-state rq-state--' + cls;
    tag.textContent = label;
    if (side) side.appendChild(tag); else row.appendChild(tag);
  }

  /* ============================================================
     WHAT EACH CARD COVERS
     The card counts materials and execution but says nothing about which
     parts of the build they belong to, so a roof budget and a full-house
     budget look alike until one is opened. The trades saved with the
     budget go on the card as a line of their own -- and, because they are
     already on the record by then, the filter that follows reads the same
     value without opening anything.
     ============================================================ */
  /* ============================================================
     FILTER BY WHAT A BUDGET COVERS
     A buyer on a tiny house wants the three budgets that price the roof,
     not the thirty that exist. The trades are already on every card from
     the previous step, so the filter is a comparison against an attribute
     -- no reading, no waiting.
     It is the same tree the vendor ticked, collapsed to a single row so it
     costs nothing when unused, and it is held in one place so switching
     between Authors and Vendors keeps the choice rather than resetting it.
     ============================================================ */
  var covFilter = {};

  /* WHAT THE PROJECT HAS, NOT WHAT THE CARDS ADMIT TO. Building the list
     from the cards meant no card could be filtered until some card already
     carried the answer -- and until every budget has been republished,
     that is none of them. The project on screen knows its own trades. */
  /* CATEGORIES, NOT SUBCATEGORIES. Thirty-two lines is a list to read; a
     dozen categories is a choice to make, and a buyer looking for a roofer
     thinks in the coarser word anyway. */
  function covCatMap() {
    var m = window.productDataMap || {};
    var subToCat = {};
    var order = [];
    var seen = {};
    for (var head in m) {
      if (!Object.prototype.hasOwnProperty.call(m, head)) continue;
      var list = m[head];
      if (Object.prototype.toString.call(list) !== '[object Array]') continue;
      for (var i = 0; i < list.length; i++) {
        var r = list[i];
        if (!r || !r[2]) continue;
        var rawCat = String(r[1] || head);
        var key = rawCat.toLowerCase();
        subToCat[String(r[2]).toLowerCase()] = key;
        if (!seen[key]) {
          seen[key] = true;
          order.push({
            key: key,
            label: window.__levaRowCat ? window.__levaRowCat(r, head) : rawCat
          });
        }
      }
    }
    return { subToCat: subToCat, cats: order };
  }

  function covFilterList() {
    return covCatMap().cats;
  }

  var covMode = 'and';

  function applyCovFilter() {
    var keys = [];
    for (var k in covFilter) {
      if (Object.prototype.hasOwnProperty.call(covFilter, k)) keys.push(k);
    }

    var map = covCatMap().subToCat;
    var rows = document.querySelectorAll('.share-recommended-item');
    var shown = 0;
    var silent = 0;

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var ok = true;
      var raw = row.getAttribute('data-trades');

      if (keys.length && raw) {
        /* A card lists subcategories; the filter asks in categories, so
           each of its trades is translated up one level first. */
        var have = raw.split('|');
        var cats = {};
        for (var h = 0; h < have.length; h++) {
          var c = map[String(have[h]).trim().toLowerCase()];
          if (c) cats[c] = true;
        }
        row.setAttribute('data-cats', Object.keys(cats).join('|'));

        if (covMode === 'or') {
          ok = false;
          for (var q = 0; q < keys.length; q++) {
            if (cats[keys[q]]) { ok = true; break; }
          }
        } else {
          for (var q2 = 0; q2 < keys.length; q2++) {
            if (!cats[keys[q2]]) { ok = false; break; }
          }
        }
      } else if (keys.length && !raw) {
        /* Published before any of this existed, so it never had the chance
           to answer -- silence passes rather than emptying the drawer. */
        silent++;
      }

      row.style.display = ok ? '' : 'none';
      if (ok) shown++;
    }

    window.__levaCovDiag = {
      picked: keys.join(', ') || '-',
      mode: covMode,
      rows: rows.length,
      shown: shown,
      noTrades: silent
    };

    var bar = document.querySelector('[data-leva-covbar]');
    if (bar) {
      var n = bar.querySelector('.leva-cf__n');
      if (n) n.textContent = keys.length ? String(keys.length) : '';
      bar.classList.toggle('is-on', !!keys.length);
    }
    return shown;
  }

  /* ABOVE THE TABS, NOT INSIDE THEM. Drawn into every filter row it found,
     the bar was built into panels that are not on screen -- so the log
     could report it as present while the reader saw nothing -- and a
     choice made under Authors meant nothing under Vendors. One bar, over
     both, filtering whatever list is showing. */
  function covFilterHost() {
    var d = document.getElementById('Leva-Shared-Drawer');
    if (!d || !d.classList.contains('active')) return null;

    var slot = d.querySelector('[data-leva-covslot]');
    if (slot) return slot;

    slot = document.createElement('div');
    slot.setAttribute('data-leva-covslot', '1');
    slot.className = 'leva-cfslot';

    /* BESIDE THE SORT, WHERE THE OTHER CONTROLS ARE. Filtering and sorting
       are the same kind of act -- narrow the list, order the list -- and
       putting one under the tabs and the other beside the cards made them
       look unrelated. It goes to the right of Nearest and Cheapest. */
    /* ABOVE THE SORT, ALIGNED WITH IT. Beside them the row had no space to
       open into and the list became a floating card over the drawer, which
       is one more surface to dismiss. On its own line it can simply push
       the cards down, in the drawer, where everything else lives. */
    var sortBtn = d.querySelector('[data-share-sort]');
    var row = sortBtn ? sortBtn.parentNode : null;
    while (row && row !== d && !/controls/.test(row.className || '')) row = row.parentNode;
    if (!row || row === d) row = sortBtn ? sortBtn.parentNode : null;

    /* UNDER THE SORT BUTTONS. Above them it shared their line and looked
       like a third button; opening it also pushed the pair down, so the
       controls moved every time somebody glanced at the list. Below, the
       cards move and the controls stay put. */
    if (row && row.parentNode) {
      slot.classList.add('leva-cfslot--above');
      try { row.parentNode.style.flexWrap = 'wrap'; } catch (e) {}
      if (row.nextSibling) row.parentNode.insertBefore(slot, row.nextSibling);
      else row.parentNode.appendChild(slot);
      return slot;
    }

    var tabs = d.querySelector('.share-drawer-tabs');
    var anchor = tabs
      || d.querySelector('.side-panel-content--has-tabs')
      || d.querySelector('.side-panel-content');
    if (!anchor) return null;

    if (tabs && tabs.parentNode) tabs.parentNode.insertBefore(slot, tabs.nextSibling);
    else anchor.insertBefore(slot, anchor.firstChild);
    return slot;
  }

  /* The sort buttons are written into the markup in English. Nobody can
     translate a string that never asks for a translation, and both keys
     have been sitting in the locale file all along. */
  function localiseSort() {
    var d = document.getElementById('Leva-Shared-Drawer');
    if (!d) return;
    var pairs = [
      ['[data-share-sort="nearest"]', (T && T.rq && T.rq.sortNearest) || ''],
      ['[data-share-sort="cheapest"]', (T && T.rq && T.rq.sortCheapest) || '']
    ];
    for (var i = 0; i < pairs.length; i++) {
      if (!pairs[i][1]) continue;
      var nodes = d.querySelectorAll(pairs[i][0]);
      for (var n = 0; n < nodes.length; n++) {
        if (nodes[n].getAttribute('data-leva-t') === '1') continue;
        nodes[n].setAttribute('data-leva-t', '1');
        nodes[n].textContent = pairs[i][1];
      }
    }
  }

  /* THE BILL OF QUANTITIES ARRIVES LATE. Mounting was attempted the moment
     the list was drawn, which is before the catalogue has loaded -- no
     categories, nothing built, and nothing to try again. So the attempt
     repeats until both the drawer is open and the categories exist. */
  var covWatch = null;

  function watchCovFilter() {
    if (covWatch) return;
    var tries = 0;
    covWatch = setInterval(function () {
      tries++;
      var d = document.getElementById('Leva-Shared-Drawer');
      var open = d && d.classList.contains('active');
      if (open && covFilterList().length) {
        mountCovFilter();
        if (d.querySelector('[data-leva-covbar]')) {
          clearInterval(covWatch);
          covWatch = null;
          applyCovFilter();
          return;
        }
      }
      if (tries > 600) { clearInterval(covWatch); covWatch = null; }
    }, 100);
  }

  function mountCovFilter() {
    var panels = [covFilterHost()];
    for (var p = 0; p < panels.length; p++) {
      (function (host) {
        if (!host) return;
        if (host.querySelector('[data-leva-covbar]')) return;
        var list = covFilterList();
        if (!list.length) return;

        var wrap = document.createElement('div');
        wrap.className = 'leva-cf';

        var bar = document.createElement('button');
        bar.type = 'button';
        bar.className = 'leva-cf__bar';
        bar.setAttribute('data-leva-covbar', '1');
        bar.appendChild(document.createTextNode(
          (T && T.rq && T.rq.filterBtn) || 'Filter'));

        var n = document.createElement('span');
        n.className = 'leva-cf__n';
        bar.appendChild(n);

        var car = document.createElement('span');
        car.className = 'leva-cf__car';
        car.textContent = '>';
        bar.appendChild(car);

        var body = document.createElement('div');
        body.className = 'leva-cf__body';

        bar.addEventListener('click', function () {
          wrap.classList.toggle('is-open');
        });

        /* ALL / ANY, with all as the start. Asking for roof and gutters and
           being shown a budget with only one of them is how a filter stops
           being trusted -- but one vendor rarely covers everything, so the
           other reading has to be one tap away. */
        var modeRow = document.createElement('div');
        modeRow.className = 'leva-cf__mode';
        var mk = function (val, text) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'leva-cf__m' + (covMode === val ? ' is-on' : '');
          b.textContent = text;
          b.addEventListener('click', function () {
            covMode = val;
            var all = modeRow.querySelectorAll('.leva-cf__m');
            for (var z = 0; z < all.length; z++) all[z].classList.remove('is-on');
            b.classList.add('is-on');
            applyCovFilter();
          });
          modeRow.appendChild(b);
          return b;
        };
        mk('and', ((T && T.rq && T.rq.all) || 'All').toUpperCase());
        mk('or', ((T && T.rq && T.rq.any) || 'Any').toUpperCase());
        body.appendChild(modeRow);

        for (var ci2 = 0; ci2 < list.length; ci2++) {
          (function (entry) {
            var l = document.createElement('label');
            l.className = 'leva-cf__c';
            var cb = document.createElement('input');
            cb.type = 'checkbox';
            cb.checked = !!covFilter[entry.key];
            cb.addEventListener('change', function () {
              if (cb.checked) covFilter[entry.key] = entry.label;
              else delete covFilter[entry.key];
              applyCovFilter();
            });
            l.appendChild(cb);
            l.appendChild(document.createTextNode(entry.label.toUpperCase()));
            body.appendChild(l);
          })(list[ci2]);
        }

        var clear = document.createElement('button');
        clear.type = 'button';
        clear.className = 'leva-cf__clear';
        clear.textContent = (T && T.rq && T.rq.clear) || 'Clear';
        clear.addEventListener('click', function () {
          for (var k in covFilter) {
            if (Object.prototype.hasOwnProperty.call(covFilter, k)) delete covFilter[k];
          }
          var boxes = body.querySelectorAll('input[type=checkbox]');
          for (var b = 0; b < boxes.length; b++) {
            boxes[b].checked = false;
            boxes[b].indeterminate = false;
          }
          applyCovFilter();
        });
        body.appendChild(clear);

        wrap.appendChild(bar);
        wrap.appendChild(body);
        host.appendChild(wrap);
        cfStyle();
        ttStyle();
        localiseSort();
        applyCovFilter();
      })(panels[p]);
    }
  }

  function cfStyle() {
    if (document.getElementById('leva-cf-style')) return;
    var css = ''
      + '.leva-cfslot{width:100%;padding:0 30px;box-sizing:border-box;}'
      /* Its own line above the sort buttons, ranged right with them; the
         list opens underneath and moves the cards down. */
      /* ITS OWN LINE, UNDER THE SORT. The controls row is a flex row, so a
         child of it stood beside the buttons however it was ordered --
         this one is told to take the whole width and start a new line. */
      + '.leva-cfslot--above{width:100% !important;flex:0 0 100% !important;'
      + 'padding:0;clear:both;order:99;}'
      + '.leva-cfslot--above .leva-cf__bar{justify-content:flex-end;border-top:0;'
      + 'border-bottom:0;padding:4px 0 6px;font-size:13px;letter-spacing:.03em;}'
      + '.leva-cfslot--above .leva-cf__car{font-size:13px;}'
      + '.leva-cfslot--above .leva-cf__car{margin-left:6px;}'
      + '.leva-cfslot--above .leva-cf__body{border-top:1px solid #EFEFEF;}'
      + '.leva-cf{width:100%;}'
      + '.leva-cf__bar{display:flex;align-items:center;gap:8px;width:100%;background:none;'
      + 'border:0;border-top:1px solid #EFEFEF;border-bottom:1px solid #EFEFEF;padding:9px 0;'
      + 'font-family:inherit;font-size:11px;font-weight:700;letter-spacing:.05em;'
      + 'text-transform:uppercase;color:#1A1C1D;cursor:pointer;}'
      + '.leva-cf__bar.is-on{color:#8a6100;}'
      + '.leva-cf__n{min-width:17px;height:17px;padding:0 5px;border-radius:999px;'
      + 'background:#D2A878;color:#fff;font-size:10px;line-height:17px;text-align:center;}'
      + '.leva-cf__n:empty{display:none;}'
      + '.leva-cf__car{margin-left:auto;color:#D2A878;transition:transform 140ms;}'
      + '.leva-cf.is-open .leva-cf__car{transform:rotate(90deg);}'
      + '.leva-cf__body{display:none;padding:2px 0 8px;}'
      + '.leva-cf.is-open .leva-cf__body{display:block;}'
      + '.leva-cf__clear{margin-top:8px;background:none;border:0;padding:0;font-family:inherit;'
      + 'font-size:11px;color:#8a6100;text-decoration:underline;cursor:pointer;}'
      + '.leva-cf__mode{display:flex;gap:6px;margin:6px 0 8px;}'
      + '.leva-cf__m{border:1px solid #EFEFEF;background:#fff;border-radius:999px;'
      + 'padding:3px 12px;font-family:inherit;font-size:10px;font-weight:700;'
      + 'letter-spacing:.06em;color:#9CA3AF;cursor:pointer;}'
      + '.leva-cf__m.is-on{background:#D2A878;border-color:#D2A878;color:#fff;}'
      + '.leva-cf__c{display:flex;align-items:center;gap:8px;width:100%;'
      + 'padding:7px 0;border-top:1px solid #F5F5F5;font-size:11px;font-weight:700;'
      + 'letter-spacing:.05em;color:#1A1C1D;cursor:pointer;}'
      + '.leva-cf__c input[type=checkbox]{appearance:none;-webkit-appearance:none;'
      + 'width:18px;height:18px;flex:0 0 auto;margin:0;border:1px solid #D2A878;'
      + 'border-radius:5px;background:#fff;position:relative;cursor:pointer;}'
      + '.leva-cf__c input[type=checkbox]:checked{background:#D2A878;border-color:#D2A878;}'
      + '.leva-cf__c input[type=checkbox]:checked::after{content:"";position:absolute;'
      + 'left:6px;top:2px;width:4px;height:9px;border:solid #fff;border-width:0 2px 2px 0;'
      + 'transform:rotate(45deg);}';
    var tag = document.createElement('style');
    tag.id = 'leva-cf-style';
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  var tradeCache = {};

  function tradesFor(token, cb) {
    if (!token) { cb(null); return; }
    if (Object.prototype.hasOwnProperty.call(tradeCache, token)) { cb(tradeCache[token]); return; }
    if (!window.db) { cb(null); return; }
    window.db.collection('budget_details').doc(String(token)).get().then(function (doc) {
      var d = doc.exists ? (doc.data() || {}) : {};
      var t = (d.trades && d.trades.length) ? d.trades : null;
      tradeCache[token] = t;
      cb(t);
    }).catch(function () { tradeCache[token] = null; cb(null); });
  }

  /* NOBODY NEEDS TO IMPORT THEIR OWN PRICES. A budget the reader published
     sat in the list of budgets to take, complete with a button to ask
     themselves for access. The token carries the owner, so it is dropped
     before anything else looks at the card. */
  function hideMyOwnCards() {
    var mine = String(window.customerId || '').trim();
    if (!mine) return;
    var rows = document.querySelectorAll('.share-recommended-item');
    for (var i = 0; i < rows.length; i++) {
      var token = rows[i].getAttribute('data-token') || '';
      if (token.indexOf(mine + '__') !== 0 && token !== mine) continue;
      rows[i].setAttribute('data-leva-own', '1');
      if (rows[i].parentNode) rows[i].parentNode.removeChild(rows[i]);
    }
  }

  function markCardTrades() {
    try { watchCovFilter(); } catch (e) {}
    hideMyOwnCards();
    var rows = document.querySelectorAll('.share-recommended-item');
    for (var i = 0; i < rows.length; i++) {
      (function (row) {
        if (row.getAttribute('data-leva-cov') === '1') return;
        row.setAttribute('data-leva-cov', '1');
        var token = row.getAttribute('data-token') || '';
        try { watchCovFilter(); } catch (e) {}
        tradesFor(token, function (t) {
          /* The list is read by the filter, not by the reader: on the card
             it squeezed the name and the town into nothing. It stays as an
             attribute and shows on screen nowhere. */
          if (t) row.setAttribute('data-trades', t.join('|').toLowerCase());
          /* The list arrives a card at a time, so the filter is rebuilt as
             the options appear and re-applied to whatever is on screen --
             which is also what keeps a choice alive across a tab switch,
             since the choice itself lives outside the drawer. */
          try { watchCovFilter(); applyCovFilter(); } catch (e) {}
        });
      })(rows[i]);
    }
  }


  function markOnDemandCards() {
    hideMyOwnCards();
    markCardTrades();
    var rows = document.querySelectorAll('.share-recommended-item');
    for (var i = 0; i < rows.length; i++) {
      (function (row) {
        /* NO BUTTON OF ITS OWN ANY MORE. The envelope was there when a
           locked card led nowhere; the gate has answered that since -- a
           click on the card opens the form. Two ways to do one thing is
           one more than the card has room for. */
        if (row.getAttribute('data-leva-state') === '1') return;
        var act = row.querySelector('.share-recommended-action');
        if (!act) return;
        if (act.getAttribute('data-action') !== 'question') return;
        row.setAttribute('data-leva-state', '1');

        var token = row.getAttribute('data-token') || '';
        paintCardState(row, 'none');
        askedState(token, function (state, days) { paintCardState(row, state, days); });
      })(rows[i]);
    }
  }

  /* Asking for a budget shared on demand happens where the budget is:
     the form unfolds under its own card, already addressed to the owner,
     and the answer comes back in Approvals. */
  function toggleAskForm(row) {
    var open = row.nextSibling && row.nextSibling.classList
      && row.nextSibling.classList.contains('rq-ask-form') ? row.nextSibling : null;
    if (open) { open.parentNode.removeChild(open); return; }

    var box = document.createElement('div');
    box.className = 'rq-ask-form rq-slot__form';
    if (row.parentNode) row.parentNode.insertBefore(box, row.nextSibling);

    var token = row.getAttribute('data-token') || '';
    ownerEmailOf(token, function (mail) {
      buildRequestForm(box, mail || '', '', 'requests');
      var mark = document.createElement('input');
      mark.type = 'hidden';
      mark.setAttribute('data-rq-token', String(token));
      var f = box.querySelector('.rq-form');
      (f || box).appendChild(mark);
      box.scrollIntoView({ block: 'nearest' });
    });
  }

  // the address of whoever shared it, taken from the record itself
  function ownerEmailOf(token, cb) {
    if (!token || !window.db) { cb(''); return; }
    window.db.collection('budget_details').doc(String(token)).get()
      .then(function (doc) {
        var d = doc.exists ? (doc.data() || {}) : {};
        cb(String(d.email || '').trim());
      })
      .catch(function () { cb(''); });
  }

  var badgesPainted = false;
  function paintBadgesOnce() {
    if (badgesPainted) return;
    badgesPainted = true;
    setTimeout(paintBadges, 1500);
  }

  /* ---- one LOG pill per drawer ---- */
  var LOG_DRAWERS = [
    { id: 'Budget-Drawer', kind: 'budget' },
    { id: 'Share-Budget-Drawer', kind: 'share' },
    { id: 'Leva-Shared-Drawer', kind: 'shared' },
    { id: 'Leva-Quotes-Drawer', kind: 'quotes' },
    { id: 'Leva-Vendor-Drawer', kind: 'vendor' }
  ];

  function logHost(d) {
    return d.querySelector('.vdr-who__main')
      || d.querySelector('.vdr-who')
      || d.querySelector('.budget-drawer__header')
      || d.querySelector('.side-panel-header')
      || d.querySelector('.side-panel-content--inner')
      || d;
  }

  /* A DIAGNOSTIC BELONGS TO WHOEVER DIAGNOSES. The button dumps prices,
     rates and row ids for the page it sits on -- useful while building,
     and noise on a customer's screen. The admin tag is set on the root
     element by Liquid, from the customer's tags, so a signed-out visitor
     never gets it. */
  function isLogAllowed() {
    /* bic-v190 (2026-10-31, Marek: admin logs buttons uz nepotrebujeme): no LOG
       button for anyone any more; mountLogs takes away one already drawn */
    if (true) return false;
    var root = document.querySelector('[data-leva-prof]');
    if (root && root.getAttribute('data-is-admin') === 'true') return true;
    try {
      if (window.LevaProfile && window.LevaProfile.state
        && window.LevaProfile.state.isAdmin) return true;
    } catch (e) {}
    return false;
  }

  function addLogButton(d, kind) {
    if (!isLogAllowed()) return;
    if (!d || d.querySelector('.qs-log')) return;
    var host = logHost(d);
    if (!host) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'qs-log qs-log--' + kind;
    b.textContent = 'LOG';
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var text;
      try {
        text = buildLog(kind);
      } catch (err) {
        text = 'log failed: ' + (err && err.message ? err.message : err);
      }
      console.log(text);
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () {
          b.textContent = 'COPIED';
          setTimeout(function () { b.textContent = 'LOG'; }, 2000);
        });
      }
    });
    host.insertBefore(b, host.firstChild);
  }

  function mountLogs() {
    style();
    if (!isLogAllowed()) {
      var gone = document.querySelectorAll('.qs-log');
      for (var g = 0; g < gone.length; g++) {
        if (gone[g].parentNode) gone[g].parentNode.removeChild(gone[g]);
      }
      return;
    }
    for (var i = 0; i < LOG_DRAWERS.length; i++) {
      var d = document.getElementById(LOG_DRAWERS[i].id);
      if (d) addLogButton(d, LOG_DRAWERS[i].kind);
    }
  }

  function step(name, fn) {
    try {
      fn();
    } catch (e) {
      console.error(VERSION + ' mount step ' + name + ' failed', e);
    }
  }

  /* ============================================================
     THE DOWNLOAD DRAWER IS NOT THE SHARING DRAWER
     A variant button on an older product opens this same panel to hand
     over the files that were bought -- one job, nothing to choose. It
     arrived wearing the sharing header and the Author / Vendor tabs,
     which belong to a different task entirely and invite the reader to
     wander off into settings they did not ask for.
     budget-core already sidesteps this, but only in drawer mode; on the
     older pages the sharing snippet is rendered directly, so nothing
     caught it. Opening on the data tab now strips the panel back to what
     it is: Your Data.
     ============================================================ */
  /* ============================================================
     WHAT THIS BUDGET COVERS, ON THIS PRODUCT
     A shared budget says what somebody charges but never what they do, so
     a buyer looking for a roofer opens thirty of them to find three, and a
     joiner is judged on prices for work they would never take.
     The answer is per product, not per person -- the same vendor covers
     different parts of a tiny house and of a shed -- so it is the picker
     from the quote sheet, in the sharing panel, saved with the budget it
     describes. What it offers is what this vendor has actually priced
     here: their own rate on a subcategory, or their own price on a line.
     ============================================================ */
  function shareTradeList() {
    var prices = window.user_prices || {};
    var rates = window.hourlyRatesMap || {};
    var m = window.productDataMap || {};
    var seen = {};
    var order = [];

    var ownRate = function (sub) {
      var v = rates[sub];
      if (v === undefined) v = rates[String(sub).toLowerCase()];
      var n = parseFloat(v);
      return isFinite(n) && n > 0;
    };
    var ownPrice = function (id) {
      var v = prices[id];
      if (v === undefined || v === null || v === '') return false;
      var n = parseFloat(String(v).replace(',', '.'));
      return isFinite(n) && n > 0;
    };

    for (var head in m) {
      if (!Object.prototype.hasOwnProperty.call(m, head)) continue;
      var rows = m[head];
      if (Object.prototype.toString.call(rows) !== '[object Array]') continue;
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        if (!row || !row[0] || !row[2]) continue;
        var sub = String(row[2]);
        var key = sub.toLowerCase();
        if (!seen[key]) {
          seen[key] = { cat: String(row[1] || head), sub: sub, rate: false, n: 0 };
          order.push(seen[key]);
        }
        if (ownRate(sub)) seen[key].rate = true;
        if (ownPrice(row[0])) seen[key].n++;
      }
    }

    var out = [];
    for (var j = 0; j < order.length; j++) {
      if (order[j].rate || order[j].n) out.push(order[j]);
    }
    return out;
  }

  /* One tree, used by the sharing panel now and by the filter later. */
  function tradeTree(host, list, picked, onChange, labelFor) {
    var byCat = {};
    var cats = [];
    for (var i = 0; i < list.length; i++) {
      var c = list[i].cat || '-';
      if (!byCat[c]) { byCat[c] = []; cats.push(c); }
      byCat[c].push(list[i]);
    }

    for (var ci = 0; ci < cats.length; ci++) {
      (function (cat) {
        var g = document.createElement('div');
        g.className = 'leva-tt__g';

        var hd = document.createElement('div');
        hd.className = 'leva-tt__cat';
        var all = document.createElement('input');
        all.type = 'checkbox';
        all.addEventListener('click', function (ev) { ev.stopPropagation(); });
        hd.appendChild(all);
        hd.appendChild(document.createTextNode(cat === '-' ? '' : cat.toUpperCase()));

        var cnt = document.createElement('span');
        cnt.className = 'leva-tt__n';
        cnt.textContent = byCat[cat].length + ' x';
        hd.appendChild(cnt);

        var car = document.createElement('span');
        car.className = 'leva-tt__car';
        car.textContent = '>';
        hd.appendChild(car);
        hd.addEventListener('click', function () { g.classList.toggle('is-open'); });
        g.appendChild(hd);

        var body = document.createElement('div');
        body.className = 'leva-tt__body';
        var kids = [];

        for (var si = 0; si < byCat[cat].length; si++) {
          (function (entry) {
            var key = entry.sub.toLowerCase();
            var l = document.createElement('label');
            l.className = 'leva-tt__s';
            var cb = document.createElement('input');
            cb.type = 'checkbox';
            cb.checked = !!picked[key];
            cb.addEventListener('change', function () {
              if (cb.checked) picked[key] = entry.sub;
              else delete picked[key];
              var on = 0;
              for (var q = 0; q < kids.length; q++) if (kids[q].checked) on++;
              all.checked = (on === kids.length);
              all.indeterminate = (on > 0 && on < kids.length);
              if (onChange) onChange(picked);
            });
            kids.push(cb);
            l.appendChild(cb);
            l.appendChild(document.createTextNode(entry.label || entry.sub));

            var tag = labelFor && labelFor(entry);
            if (tag) {
              var t = document.createElement('span');
              t.className = 'leva-tt__tag';
              t.textContent = tag;
              l.appendChild(t);
            }
            body.appendChild(l);
          })(byCat[cat][si]);
        }

        /* Closed to start with: a vendor scans the categories and opens
           the one they want to argue with. */
        var on0 = 0;
        for (var q0 = 0; q0 < kids.length; q0++) if (kids[q0].checked) on0++;
        all.checked = (kids.length > 0 && on0 === kids.length);
        all.indeterminate = (on0 > 0 && on0 < kids.length);

        all.addEventListener('change', function () {
          for (var q = 0; q < kids.length; q++) {
            kids[q].checked = all.checked;
            var k2 = byCat[cat][q].sub.toLowerCase();
            if (all.checked) picked[k2] = byCat[cat][q].sub;
            else delete picked[k2];
          }
          all.indeterminate = false;
          if (onChange) onChange(picked);
        });

        g.appendChild(body);
        host.appendChild(g);
      })(cats[ci]);
    }
  }

  var shareTrades = null;

  /* What was saved for this product last time, so the panel and the quote
     sheet both start from the vendor's own answer. */
  function loadSavedTrades(cb) {
    var h = (window.shareProductContext && window.shareProductContext.handle) || '';
    if (!window.db || !window.customerId || !h) { if (cb) cb(null); return; }
    window.db.collection('budget_details')
      .where('customerId', '==', String(window.customerId))
      .get()
      .then(function (snap) {
        var found = null;
        snap.forEach(function (doc) {
          var d = doc.data() || {};
          if (d.productHandle !== h) return;
          if (d.trades && d.trades.length) found = d.trades;
        });
        window.__levaSavedTrades = found;
        if (cb) cb(found);
      })
      .catch(function () { if (cb) cb(null); });
  }

  window.__levaLoadTrades = loadSavedTrades;

  function mountShareTrades() {
    var diag = window.__levaTradeDiag || (window.__levaTradeDiag = { tries: 0 });
    diag.tries++;
    diag.when = new Date().toTimeString().slice(0, 8);

    /* OUT OF THE FORM ALTOGETHER. The vendor block and the form around it
       both lay their children out their own way, and every rule I added to
       argue with them was answered by another one -- the tree kept coming
       out with the tick above the name and the tag on a third line. The
       panel that holds the form is an ordinary block, so the tree goes
       there, underneath, and nothing is fighting anything. */
    var pick = ['#share-panel-settings', '#share-panel-recommended-product',
      '#share-panel-recommended', '[data-prof-form]'];
    var panel = null;
    for (var pi = 0; pi < pick.length; pi++) {
      var cand = document.querySelector(pick[pi]);
      if (!cand || cand.hidden) continue;
      if (!cand.getBoundingClientRect().height) continue;
      panel = cand;
      diag.host = pick[pi];
      break;
    }
    if (!panel) { diag.host = 'NONE'; return; }
    if (panel.querySelector('[data-leva-tt]')) { diag.already = true; return; }
    diag.already = false;

    /* THE SAME LIST THE QUOTE SHEET OFFERS. Anything else was a second
       implementation of the same idea, and it drifted. */
    var offered = qsOffered();
    diag.list = offered.length;

    if (!offered.length) {
      shareTrades = null;
      if (!diag.waiting) {
        diag.waiting = true;
        var tries = 0;
        var iv = setInterval(function () {
          tries++;
          if (qsOffered().length) {
            clearInterval(iv);
            diag.waiting = false;
            mountShareTrades();
          } else if (tries > 400) { clearInterval(iv); diag.waiting = false; }
        }, 16);
      }
      return;
    }

    ttStyle();

    /* THE TREE'S OWN STYLES. Dropped in an earlier round, which is why the
       lines between categories were missing here and present in the quote
       sheet -- that stylesheet draws them. */
    try { rqStyle(); } catch (e) {}

    var wrap = document.createElement('div');
    wrap.className = 'leva-tt';
    wrap.setAttribute('data-leva-tt', '1');

    var bar = document.createElement('div');
    bar.className = 'leva-tt__bar';
    bar.appendChild(document.createTextNode(
      (T && T.rq && T.rq.whatYouDo) || 'Items filled'));
    var cnt = document.createElement('span');
    cnt.className = 'leva-tt__bn';
    bar.appendChild(cnt);
    wrap.appendChild(bar);

    var picked = {};
    var pickedIds = {};
    var saved = window.__levaSavedTrades;
    if (saved && saved.length) {
      var have = {};
      for (var s = 0; s < saved.length; s++) have[String(saved[s]).toLowerCase()] = true;
      for (var o = 0; o < offered.length; o++) {
        picked[offered[o].sub] = !!have[offered[o].sub.toLowerCase()];
      }
    }

    var say = function () {
      var n = 0;
      shareTrades = {};
      for (var k in picked) {
        if (!Object.prototype.hasOwnProperty.call(picked, k)) continue;
        if (!picked[k]) continue;
        n++;
        shareTrades[k.toLowerCase()] = k;
      }
      cnt.textContent = n + ' / ' + offered.length;
    };

    wrap.appendChild(buildPickTree(offered, picked, say, pickedIds));
    window.__levaShareIds = pickedIds;
    say();

    /* NEAR THE TOP, WHERE IT IS PART OF THE DECISION. Appended to the end
       of the panel it sat below the publish buttons, so a vendor scrolled
       past the thing they were about to publish to find what it contains.
       It goes above the form -- outside it, so nothing lays it out but
       these rules. */
    /* AFTER THE BASICS, BEFORE THE BUTTONS. At the end of the panel it sat
       below publish; at the very top it came before the vendor had said
       who they are. The form orders its children by a number, so the tree
       takes the number just after the address block and lands there. */
    /* JUST ABOVE COUNTRY, for a vendor and for an author alike: the name,
       the links and the description come first, and the list of what is
       covered reads as part of the same answer rather than an afterthought
       below the publish buttons. The form orders its children by number,
       so it takes the one immediately before country's. */
    /* PUT IT WHERE COUNTRY IS, NOT WHERE A NUMBER SAYS. The form orders
       its children with the order property, but only for the fields it
       knows about -- a stranger with a fractional order still landed
       wherever the DOM had it, which was under the profile picture. So the
       node is moved in front of the country field itself. */
    var form = panel.querySelector('[data-prof-form]');
    if (!form) { panel.insertBefore(wrap, panel.firstChild); return; }

    /* ORDER DECIDES, NOT DOM POSITION. The form is a grid and lays its
       children out by the order property; a node without one sits at zero,
       which is why this kept appearing under the profile picture however
       carefully it was inserted. Country is 10 for an author and for a
       vendor alike, so 9.5 puts the list directly above it -- and it is
       set again a moment later, because the form renumbers its fields
       after the role is applied. */
    /* MATCH COUNTRY'S NUMBER, SIT IN FRONT OF IT. Guessing at a fraction
       assumed the field carried an inline order; where it does not, the
       computed value is the only truth, and a node with no number at all
       lands at zero -- under the profile picture, which is exactly what
       kept happening. Taking the same number and standing before it in
       the document works whether the form is a grid or not: equal orders
       fall back to document order.
       Re-read afterwards because the form renumbers itself once the role
       is applied. */
    var country = form.querySelector('[data-prof-f="country"]');
    var holder = country ? (country.closest ? country.closest('label') : null) : null;
    if (!holder && country) holder = country.parentNode;
    if (holder && holder.parentNode !== form) {
      var up = holder;
      while (up && up.parentNode !== form) up = up.parentNode;
      if (up) holder = up;
    }

    var diag2 = window.__levaTradeDiag || {};
    var place = function () {
      if (!holder) { wrap.style.order = '9'; diag2.order = 'no country'; return; }
      var ord = '';
      try { ord = window.getComputedStyle(holder).order; } catch (e) {}
      if (!ord || ord === 'auto') ord = holder.style.order || '';
      wrap.style.order = ord || '9';
      diag2.order = 'country=' + (ord || '-') + ' wrap=' + wrap.style.order;
      // in front of it, so an equal number still puts the list first
      if (holder.parentNode && wrap.nextSibling !== holder) {
        holder.parentNode.insertBefore(wrap, holder);
      }
    };

    if (holder && holder.parentNode) holder.parentNode.insertBefore(wrap, holder);
    else form.appendChild(wrap);
    place();

    setTimeout(place, 150);
    setTimeout(place, 600);
    setTimeout(place, 1500);
  }

  /* The list rides along with whatever the sharing panel is already
     saving, so publishing stays one action. */
  function wrapSaveDetails() {
    var install = function () {
      var original = window.saveBudgetDetails;
      if (typeof original !== 'function' || original.__levaTrades) return false;
    /* AN ADDRESS SOMEBODY TYPED IS NOT A GUESS TO BE IMPROVED. The budget
       republishes itself while its owner works, and that path builds its
       own payload -- with no form on screen, the address is simply absent
       from it, so the guard "fill it only if it is empty" is satisfied and
       a city from IP geolocation goes in. Merged over the record, that
       replaces what the owner wrote.
       So: what the owner typed is read back off the record, and any
       address the automatic save invented is dropped before it is written.
       Nothing here touches a save the owner made themselves, where the
       field is on screen and carries their words. */
    var typedAddress = function () {
      var f = document.querySelector('[data-prof-f="address"]');
      return (f && f.value) ? String(f.value).trim() : '';
    };

    /* A PERSON'S NAME IS NOT A LABEL FOR A BUDGET. Publishing on its own
       is something the owner did not ask for at that moment, and putting
       their name on it -- visible to everyone browsing shared budgets --
       is a disclosure nobody agreed to. The product does the job better
       anyway: what the budget is for, in the language of the page.
       A name the owner typed into the sharing form stands, because that
       one they chose. */
    var typedName = function () {
      var f = document.querySelector('[data-prof-f="name"]');
      return (f && f.value) ? String(f.value).trim() : '';
    };

    var productLabel = function () {
      var ctx = window.shareProductContext || null;
      var t = ctx && ctx.title ? String(ctx.title).trim() : '';
      if (!t) return '';
      var v = ctx && ctx.variantTitle ? String(ctx.variantTitle).trim() : '';
      if (v && v.toLowerCase() !== 'default title') return t + ' / ' + v;
      return t;
    };

    var keepNamePrivate = function (data) {
      if (!data || typeof data !== 'object') return;
      if (typedName()) return;

      var label = productLabel();
      if (label) {
        data.customerName = label;
        window.__levaNameLabel = label;
      } else if (data.customerName) {
        // no product to name it after: better nameless than named
        delete data.customerName;
        window.__levaNameLabel = 'removed';
      }
    };

    var keepTypedPlace = function (customerId, data) {
      if (!data || typeof data !== 'object') return Promise.resolve();
      if (typedAddress()) return Promise.resolve();

      var handle = (window.shareProductContext && window.shareProductContext.handle) || '';
      var ids = [];
      if (window.currentVariantId) ids.push(customerId + '__' + handle + '__' + window.currentVariantId);
      ids.push(customerId + '__' + handle);

      var step = function (i) {
        if (i >= ids.length || !window.db) return Promise.resolve(null);
        return window.db.collection('budget_details').doc(ids[i]).get()
          .then(function (doc) { return doc.exists ? (doc.data() || null) : step(i + 1); })
          .catch(function () { return null; });
      };

      return step(0).then(function (old) {
        if (!old) return;
        var had = String(old.localisation || old.city || '').trim();
        if (!had) return;

        var now = String(data.localisation || data.city || '').trim();
        if (now && now.toLowerCase() === had.toLowerCase()) return;

        // leave every one of them out, so the merge keeps what is stored
        delete data.localisation;
        delete data.city;
        delete data.latitude;
        delete data.longitude;
        window.__levaKeptPlace = had;
      });
    };

      var wrapped = function (customerId, data, productContext) {
        /* THE AUTOMATIC SHARE GOES THROUGH HERE TOO. A budget republishes
           itself once its owner has made enough changes, and that call
           looks exactly like this one -- so anything written here rides
           along with it. An empty list is therefore never written: it
           would tell the world this budget covers nothing, and every
           filter would drop it. Only a real selection travels, and only
           when the picker is actually on screen. */
        try {
          if (shareTrades && document.querySelector('[data-leva-tt]')) {
            var out = [];
            for (var k in shareTrades) {
              if (Object.prototype.hasOwnProperty.call(shareTrades, k)) out.push(shareTrades[k]);
            }
            if (out.length && data && typeof data === 'object') {
              data.trades = out;
              /* The lines themselves, so a filter can tell a roof
                 insulation vendor from a floor one. */
              var ids = window.__levaShareIds || null;
              if (ids) {
                var keep = [];
                for (var z in ids) {
                  if (Object.prototype.hasOwnProperty.call(ids, z) && ids[z]) keep.push(z);
                }
                if (keep.length) data.tradeItems = keep;
              }
            }
          }
        } catch (e) {}
        try { keepNamePrivate(data); } catch (e) {}

        var self = this;
        var args = arguments;
        return keepTypedPlace(customerId, data)
          .catch(function () {})
          .then(function () { return original.apply(self, args); });
      };
      wrapped.__levaTrades = true;
      window.saveBudgetDetails = wrapped;
      return true;
    };
    if (install()) return;
    var tries = 0;
    var iv = setInterval(function () {
      if (install() || ++tries > 40) clearInterval(iv);
    }, 250);
  }

  /* EVERY RULE THE TREE NEEDS, CARRIED HERE. Leaning on the quotes
     stylesheet meant the groups only collapsed if that drawer had been
     opened first -- otherwise all nineteen unfolded at once, two thousand
     pixels of it. These are the same rules, spelled out under .leva-tt so
     nothing outside can decide otherwise. */
  function ttStyle() {
    if (document.getElementById('leva-tt-style')) return;
    var css = ''
      + '.leva-tt{display:block !important;grid-column:1/-1;width:100%;'
      + 'margin:18px 0 6px;padding:0;}'
      + '.leva-tt *{box-sizing:border-box;}'
      + '.leva-tt__bar{display:flex !important;align-items:center;gap:8px;width:100%;'
      + 'padding:10px 0;font-size:11px;font-weight:700;letter-spacing:.05em;'
      + 'text-transform:uppercase;color:#1A1C1D;text-align:left;'
      + 'border-bottom:1px solid #EFEFEF;}'
      + '.leva-tt__bn{font-size:11px;font-weight:600;letter-spacing:0;color:#9CA3AF;}'

      + '.leva-tt .qs-pick{display:block !important;width:100%;margin:0;}'
      + '.leva-tt .qs-pick__none{font-size:12px;color:#6B7280;line-height:1.4;padding:8px 0;}'
      /* THE THEME PAINTS ITS OWN TICK. Inside a form it swaps the box for
         a background image of its own -- green, nothing to do with us --
         which is why these boxes looked like a different feature from the
         identical ones in the quote sheet. Everything it sets is undone. */
      + '.leva-tt .qs-pick input[type=checkbox]{appearance:none !important;'
      + '-webkit-appearance:none !important;-moz-appearance:none !important;'
      + 'width:18px !important;height:18px !important;min-width:18px !important;'
      + 'flex:0 0 auto !important;margin:0 !important;padding:0 !important;'
      + 'border:1px solid #D2A878 !important;border-radius:5px !important;'
      + 'background:#fff !important;background-image:none !important;'
      + 'box-shadow:none !important;position:relative !important;cursor:pointer;'
      + 'accent-color:#D2A878;}'
      + '.leva-tt .qs-pick input[type=checkbox]:checked,'
      + '.leva-tt .qs-pick input[type=checkbox]:indeterminate'
      + '{background:#D2A878 !important;background-image:none !important;'
      + 'border-color:#D2A878 !important;}'
      + '.leva-tt .qs-pick input[type=checkbox]::before{content:none !important;}'
      + '.leva-tt .qs-pick input[type=checkbox]:checked::after{content:"" !important;'
      + 'position:absolute;left:6px;top:2px;width:4px;height:9px;border:solid #fff;'
      + 'border-width:0 2px 2px 0;transform:rotate(45deg);background:none;}'
      + '.leva-tt .qs-pick input[type=checkbox]:indeterminate::after{content:"" !important;'
      + 'position:absolute;left:3px;top:7px;width:10px;height:2px;background:#fff;'
      + 'border-radius:1px;border:0;transform:none;}'
      /* Layout only: the lines between groups come from the tree's own
         rules, so both places draw exactly the same ones. */
      + '.leva-tt .qs-pick__g{display:block !important;width:100%;}'
      + '.leva-tt .qs-pick__cat{display:flex !important;flex-direction:row !important;'
      + 'align-items:center !important;flex-wrap:nowrap !important;gap:8px;'
      + 'width:100% !important;font-size:11px;font-weight:700;letter-spacing:.05em;'
      + 'color:#1A1C1D;padding:9px 0;margin:0 !important;cursor:pointer;'
      + 'text-align:left !important;}'
      + '.leva-tt .qs-pick__n{font-size:11px;color:#9CA3AF;font-weight:600;letter-spacing:0;}'
      + '.leva-tt .qs-pick__car{margin-left:auto;color:#D2A878;font-size:11px;'
      + 'transition:transform 140ms;}'
      + '.leva-tt .qs-pick__g.is-open .qs-pick__car{transform:rotate(90deg);}'

      /* closed unless its own header says otherwise */
      + '.leva-tt .qs-pick__body{display:none !important;padding:0 0 8px;}'
      + '.leva-tt .qs-pick__g.is-open .qs-pick__body{display:block !important;}'

      + '.leva-tt .qs-pick__s{display:flex !important;flex-direction:row !important;'
      + 'align-items:center !important;justify-content:flex-start !important;'
      + 'flex-wrap:nowrap !important;gap:8px;width:100% !important;'
      + 'font-size:13px;color:#374151;padding:6px 0 6px 20px;margin:0 !important;'
      + 'border-top:1px solid #F5F5F5;text-transform:none;letter-spacing:0;'
      + 'font-weight:400;text-align:left !important;}'
      /* the theme dresses labels inside a form: undone for these */
      + '.leva-tt .qs-pick__s > *{margin:0 !important;float:none !important;}'
      + '.leva-tt .qs-pick__pair{display:block !important;width:100% !important;}'
      + '.leva-tt .qs-pick__i{padding-left:44px !important;}'
      + '.leva-tt .qs-pick__pair.is-open .qs-pick__i{display:block !important;}'
      + '.leva-tt .qs-pick__it{display:flex !important;flex-direction:row !important;'
      + 'align-items:center !important;flex-wrap:nowrap !important;width:100% !important;'
      + 'margin:0 !important;text-align:left !important;}'
      + '.leva-tt .qs-pick__it > *{margin:0 !important;float:none !important;}'

      + '.leva-tt .qs-pick__tag{font-size:11px;color:#9CA3AF;margin-left:auto;'
      + 'white-space:nowrap;}'
;
    var tag = document.createElement('style');
    tag.id = 'leva-tt-style';
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  function watchShareDrawer() {
    var install = function () {
      var original = window.openShareBudgetDrawer;
      if (typeof original !== 'function' || original.__levaDataOnly) return false;

      var wrapped = function (initialTab, options) {
        var r = original.apply(this, arguments);
        if (initialTab === 'data') dataOnlyShare();
        else { undataOnlyShare(); loadSavedTrades(function () { try { mountShareTrades(); } catch (e) {} }); }
        return r;
      };
      wrapped.__levaDataOnly = true;
      try { wrapped.toString = function () { return original.toString(); }; } catch (e) {}
      window.openShareBudgetDrawer = wrapped;
      return true;
    };

    wrapSaveDetails();
    /* Read once at boot: the quote sheet may be opened without the sharing
       panel ever being touched, and it needs the same answer. */
    try { loadSavedTrades(null); } catch (e) {}

    /* AND WATCH THE PANEL ITSELF. Hanging the picker off the opener meant
       it appeared only for the doors that go through that function -- the
       floating icon calls its own, so the panel opened without it and the
       feature looked missing. What matters is that the panel is on screen,
       not how it got there. */
    var host = document.getElementById('Share-Budget-Drawer');
    if (host) {
      var seen = false;
      new MutationObserver(function () {
        var on = host.classList.contains('active');
        if (!on) { seen = false; return; }
        if (seen) return;
        seen = true;
        if (host.classList.contains('is-data-mode')) return;
        /* Draw first, ask afterwards. Waiting for the saved list before
           building meant a visible delay against the quote sheet, which
           has everything to hand; the ticks are corrected the moment the
           answer arrives, which is quicker than anyone can read. */
        try { mountShareTrades(); } catch (e) {}
        loadSavedTrades(function (saved) {
          if (!saved || !saved.length) return;
          var node = document.querySelector('[data-leva-tt]');
          if (node && node.parentNode) node.parentNode.removeChild(node);
          try { mountShareTrades(); } catch (e) {}
        });
      }).observe(host, { attributes: true, attributeFilter: ['class'] });
    }

    if (install()) return;
    // the sharing snippet may boot after this one
    var tries = 0;
    var iv = setInterval(function () {
      if (install() || ++tries > 40) clearInterval(iv);
    }, 250);
  }

  function shareDrawerEl() {
    return document.getElementById('Share-Budget-Drawer');
  }

  /* The sharing snippet styles is-data-mode itself, but only the parts it
     knew about; these close the band the hidden tabs left and drop the
     rule that used to sit under them, so the panel starts straight below
     the header. Injected here because this block runs on pages where the
     quotes stylesheet never loads. */
  function dataOnlyStyle() {
    if (document.getElementById('leva-dataonly-style')) return;
    var css = ''
      + '.share-budget-drawer.is-data-mode .side-panel-content--has-tabs{padding-top:0 !important;}'
      + '.share-budget-drawer.is-data-mode .side-panel-content--inner{padding-top:0 !important;}'
      + '.share-budget-drawer.is-data-mode .share-drawer-tabs{display:none !important;}'
      + '.share-budget-drawer.is-data-mode #share-panel-data{padding-top:0 !important;'
      + 'margin-top:0 !important;border-top:0 !important;}'
      + '.share-budget-drawer.is-data-mode #share-panel-data > :first-child'
      + '{border-top:0 !important;margin-top:0 !important;}'
      + '.share-budget-drawer.is-data-mode #ddDrawerScroll{padding-top:6px !important;}'
      + '.share-budget-drawer.is-data-mode #ddDrawerScroll > .dd-section-sep:first-child'
      + '{display:none !important;}';
    var tag = document.createElement('style');
    tag.id = 'leva-dataonly-style';
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  function dataOnlyShare() {
    var d = shareDrawerEl();
    if (!d) return;
    d.classList.add('leva-share--data-only');

    /* The label is already on the tab that is being replaced, so it comes
       from there rather than from a key of its own. */
    var tab = document.getElementById('share-tab-data');
    var label = (tab && tab.textContent.trim()) || 'Your Data';

    var title = d.querySelector('.side-panel-header .h6');
    if (title) {
      if (!title.getAttribute('data-leva-was')) {
        title.setAttribute('data-leva-was', title.textContent || '');
      }
      title.textContent = label;
    }

    /* HIDDEN ON THE ELEMENT, NOT THROUGH A STYLESHEET. The rules for this
       live in rqStyle, which is only injected when the quotes drawer is
       first opened -- and on an older product page it never is, so the
       tabs stayed exactly where they were. */
    var tabs = d.querySelector('.share-drawer-tabs');
    if (tabs) {
      if (!tabs.getAttribute('data-leva-was')) {
        tabs.setAttribute('data-leva-was', tabs.style.display || 'x');
      }
      tabs.style.display = 'none';
    }

    /* The row of tabs carried the padding above it and the rule below it.
       Hiding it leaves the padding standing on its own -- a band of empty
       between the header line and the first banner -- and the sharing
       snippet already has the switch for exactly this case. */
    dataOnlyStyle();
    d.classList.add('is-data-mode');

    // the data panel is the only one with anything to say here
    var panels = d.querySelectorAll('.share-drawer-panel');
    for (var i = 0; i < panels.length; i++) {
      var p = panels[i];
      p.hidden = (p.id !== 'share-panel-data');
    }
  }

  function undataOnlyShare() {
    var d = shareDrawerEl();
    if (!d) return;
    d.classList.remove('leva-share--data-only');

    var title = d.querySelector('.side-panel-header .h6');
    var was = title && title.getAttribute('data-leva-was');
    if (title && was) title.textContent = was;

    d.classList.remove('is-data-mode');

    var tabs = d.querySelector('.share-drawer-tabs');
    var wasT = tabs && tabs.getAttribute('data-leva-was');
    if (tabs && wasT) tabs.style.display = (wasT === 'x') ? '' : wasT;
  }

  function paintShareMode() {}

  function itemDrawer() {
    var ids = ['Custom-Drawer', 'Custom-drawer', 'custom-drawer'];
    for (var i = 0; i < ids.length; i++) {
      var el = document.getElementById(ids[i]);
      if (el) return el;
    }
    return document.querySelector('.side-panel[id*="ustom-"]');
  }

  function watchItemDrawer() {
    var el = itemDrawer();
    if (!el) return;
    lift(el);
    if (el.style.zIndex !== '100006') el.style.zIndex = '100006';
  }

  function mount() {
    step('style', style);
    step('oldTabs', hideOldTabs);
    step('wire', wire);
    step('shareDrawer', watchShareDrawer);
    step('itemDrawer', watchItemDrawer);
    step('shareMode', paintShareMode);
    step('prefetch', prefetchList);
    step('onDemand', markOnDemandCards);
    step('badges', paintBadgesOnce);
    step('logs', mountLogs);
  }

  /* ============================================================
     ONE SHARED BUDGET, DRAWN BY THE BUDGET ITSELF
     Clicking a card used to open a small import dialogue. It now opens
     the budget: the owner's prices and times are swapped into the page
     globals, the ordinary renderer draws them, and the rendered sections
     are borrowed into this drawer. Everything is put back on close, so
     the visitor's own budget is never touched.
     ============================================================ */
  var vd = {
    open: false,
    token: '',
    owner: '',
    name: '',
    prices: null,
    exec: null,
    slot: null,
    node: null
  };

  function vendorDrawer() {
    var d = document.getElementById('Leva-Vendor-Drawer');
    if (!d || d.getAttribute('data-vdr-wired') === '1') return d;
    d.setAttribute('data-vdr-wired', '1');
    lift(d);
    d.querySelector('[data-vd-all]').addEventListener('click', function () {
      confirmImp(function (mode) {
        withWrites(function () {
          if (typeof window.importFull === 'function' && vd.data) {
            window.importFull(dataFor(mode), vd.name, true,
              (vd.data && vd.data.hourlyRatesByCategory) || {}, {
                token: vd.token, ownerId: vd.owner, visibility: 'public'
              });
          }
        });
        closeVendor();
      });
    });
    // the theme close element strips the active class; the cleanup rides on it
    new MutationObserver(function () {
      if (vd.open && !d.classList.contains('active')) closeVendor();
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
    return d;
  }

  function vendorStyle() {
    if (document.getElementById('vdr-style-v41')) return;
    var css = ''
      /* Same footprint as the user budget drawer: it covers it fully. */
      + '#Leva-Vendor-Drawer{width:1100px !important;max-width:95vw !important;z-index:100002;background:#f5f5f5;}'
      + '@media (max-width:1200px){#Leva-Vendor-Drawer{width:95vw;max-width:95vw;}}'
      + '@media (max-width:760px){#Leva-Vendor-Drawer{width:100vw;max-width:100vw;}}'
      + '#Leva-Vendor-Drawer .side-panel-content--inner{max-width:none;}'
      /* Author profile, the central budget way: photo and flag with the
         name and a located dot on the left, a divider, social icons on
         the right in their own colours. */
      + '.vdr-who{display:flex;align-items:flex-start;gap:16px;padding:6px 0 14px;border-bottom:1px solid #E6E7E9;}'
      + '.vdr-p{flex:1 1 auto;min-width:0;}'
      + '.vdr-p .prof-prev{margin:0;}'
      + '#Leva-Vendor-Drawer .prof-prev__photo,'
      + '#Leva-Vendor-Drawer .prof-prev__avatar{width:76px;height:76px;}'
      + '#Leva-Vendor-Drawer .prof-prev__flag{width:24px;height:24px;}'
      + '#Leva-Vendor-Drawer .prof-prev__name{font-size:17px;}'
      + '#vdr-confirm{position:fixed;inset:0;background:rgba(20,21,23,.45);z-index:100010;'
      + 'display:flex;align-items:center;justify-content:center;}'
      + '.vdr-c__box{background:#fff;border-radius:14px;padding:26px 30px;min-width:260px;'
      + 'box-shadow:0 18px 60px rgba(0,0,0,.25);text-align:center;}'
      + '.vdr-c__title{font-size:16px;font-weight:600;color:#1A1C1D;margin-bottom:18px;}'
      + '.vdr-c__col{display:flex;flex-direction:column;gap:10px;align-items:stretch;min-width:200px;}'
      + '.vdr-c__btn{border:1px solid #D7D9DC;background:#fff;color:#1A1C1D;border-radius:999px;'
      + 'font-family:inherit;font-size:13px;padding:9px 22px;cursor:pointer;}'
      + '.vdr-c__btn--ok{background:#D2A878;border-color:#D2A878;color:#1A1C1D;}'
      /* the borrowed budget keeps its own layout inside the drawer */
      + '#Leva-Vendor-Drawer .budget-section__inner{display:block;width:100%;}'
      + '#Leva-Vendor-Drawer .budget-sections,'
      + '#Leva-Vendor-Drawer .budget-cards{width:100%;min-width:0;}'
      /* the two overview cards sit side by side on a desktop; a phone
         has room for one, so they stack instead of overflowing */
      + '@media (max-width:749px){'
      + '#Leva-Vendor-Drawer .budget-cards{display:flex;flex-direction:column;gap:12px;}'
      + '#Leva-Vendor-Drawer .budget-card{width:100%;min-width:0;max-width:100%;}'
      + '#Leva-Vendor-Drawer .budget-section__inner{padding-left:0;padding-right:0;}'
      + '}'
      + '#Leva-Vendor-Drawer .budget-section-header__title{writing-mode:horizontal-tb;white-space:normal;width:auto;min-width:0;}'
      + '.vdr-top{display:flex;justify-content:flex-end;padding:12px 0;}'
      + '.vdr-imp-icon{width:45px;height:45px;border-radius:50%;border:0;padding:0;cursor:pointer;'
      + 'background:#7B5FC9;display:inline-flex;align-items:center;justify-content:center;'
      + 'box-shadow:0 6px 22px rgba(0,0,0,.18);flex:0 0 auto;}'
      + '.vdr-imp-icon img{width:22px;height:22px;display:block;filter:brightness(0) invert(1);}'
      + '.vdr-imp-icon--sec{width:32px;height:32px;margin-left:10px;box-shadow:0 3px 12px rgba(0,0,0,.14);}'
      + '.vdr-imp-icon--sec img{width:15px;height:15px;}'
      + '.vdr-imp-icon--item{width:26px;height:26px;box-shadow:0 2px 8px rgba(0,0,0,.14);'
      + 'position:absolute;right:10px;top:10px;z-index:2;}'
      + '.vdr-imp-icon--item img{width:12px;height:12px;}'
      + '#Leva-Vendor-Drawer .budget-item{position:relative;}'
      + '.vdr-close{position:static !important;margin-left:16px;align-self:flex-start;flex:0 0 auto;}'
      + '.vdr-imp-icon--all{align-self:flex-start;margin-left:16px;}'
      + '.vdr-who__main{display:flex;align-items:stretch;gap:0;flex:1 1 auto;min-width:0;}'
      + '.vdr-msg{font-size:13px;color:#6B7280;padding:8px 0;}'
      + '#Leva-Vendor-Drawer .budget-section-header__title{display:flex;align-items:center;flex-wrap:wrap;}';
    var tag = document.createElement('style');
    tag.id = 'vdr-style-v41';
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  // Who shared this: the avatar, name and place come straight from the
  // card that was clicked, so an anonymous author still shows a flag and
  // a location and the rest simply stays empty.
  /* The card merges three sources, later wins: what the clicked card
     showed, what the budget record carries (old shares keep photo and
     socials there), and the owner's public profile when it exists. */
  var pv = { seed: null, budget: null, profile: null };

  function classifySocial(url) {
    var u = String(url || '').toLowerCase();
    if (u.indexOf('instagram') > -1) return 'instagram';
    if (u.indexOf('tiktok') > -1) return 'tiktok';
    if (u.indexOf('youtu') > -1) return 'youtube';
    if (u.indexOf('pinterest') > -1) return 'pinterest';
    if (u.indexOf('facebook') > -1 || u.indexOf('fb.com') > -1) return 'facebook';
    if (u.indexOf('linkedin') > -1) return 'linkedin';
    if (u.indexOf('x.com') > -1 || u.indexOf('twitter') > -1) return 'x';
    if (u.indexOf('patreon') > -1) return 'patreon';
    return 'web';
  }

  function seedFromCard(card) {
    var s = {};
    if (!card) return s;
    var nameEl = card.querySelector('.share-recommended-item-name');
    if (nameEl) s.name = nameEl.textContent.trim();
    var cityEl = card.querySelector('.share-recommended-item-city');
    if (cityEl && cityEl.textContent.trim()) s.address = cityEl.textContent.trim();

    var imgs = card.querySelectorAll('.share-recommended-avatar img');
    for (var i = 0; i < imgs.length; i++) {
      var src = imgs[i].src || '';
      if (src.indexOf('flagcdn.com') > -1) {
        var m = /flagcdn\.com\/w\d+\/([a-z]{2})/.exec(src);
        if (m) s.country = m[1].toUpperCase();
      } else if (src) {
        s.photo_url = src;
      }
    }

    var links = card.querySelectorAll('a[href]');
    for (var j = 0; j < links.length; j++) {
      var href = links[j].href || '';
      var key = classifySocial(href);
      if (key === 'web') continue;
      if (!s[key]) s[key] = href;
    }
    return s;
  }

  function profileFromBudget(d) {
    if (!d) return null;
    var p = {};
    if (d.customerName) p.name = d.customerName;
    if (!p.name) {
      var t = (d.productTitle || '').trim();
      var v = (d.productVariantTitle || '').trim();
      if (t) p.name = v ? (t + ' / ' + v) : t;
    }
    if (d.logoUrl) p.photo_url = d.logoUrl;
    if (d.description) p.bio = d.description;
    if (d.country) p.country = d.country;
    if (d.localisation || d.city) p.address = d.localisation || d.city;
    if (d.followers) p.followers = d.followers;
    if (d.socialInstagram) p.instagram = d.socialInstagram;
    if (d.socialYouTube) p.youtube = d.socialYouTube;
    if (d.socialTikTok) p.tiktok = d.socialTikTok;
    if (d.socialPinterest) p.pinterest = d.socialPinterest;
    if (d.socialPatreon) p.patreon = d.socialPatreon;
    if (d.behindPaywallUrl) p.web = d.behindPaywallUrl;
    return p;
  }

  function nameFromParts() {
    var parts = [pv.seed, pv.budget, pv.profile];
    for (var i = parts.length - 1; i >= 0; i--) {
      if (parts[i] && parts[i].name) return parts[i].name;
    }
    return '';
  }

  function mergedProfile() {
    var out = {};
    var parts = [pv.seed, pv.budget, pv.profile];
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      if (!p) continue;
      for (var k in p) {
        if (Object.prototype.hasOwnProperty.call(p, k) && p[k]) out[k] = p[k];
      }
    }
    return out;
  }

  function drawWho() {
    var d = document.getElementById('Leva-Vendor-Drawer');
    if (!d) return;
    var who = d.querySelector('[data-vd-who]');
    if (!who) return;
    // opened from the strip there is no card, so the name arrives with
    // the budget record and is kept for the import that may follow
    if (!vd.name) vd.name = nameFromParts();
    if (window.LevaProfile && typeof window.LevaProfile.renderCard === 'function') {
      window.LevaProfile.renderCard(who, mergedProfile(), 'none');
    }
  }

  function mergeBudgetPart(part) {
    if (!part) return;
    if (!pv.budget) { pv.budget = part; return; }
    for (var k in part) {
      if (Object.prototype.hasOwnProperty.call(part, k) && part[k] && !pv.budget[k]) {
        pv.budget[k] = part[k];
      }
    }
  }

  function paintWho(d, card) {
    pv.seed = seedFromCard(card);
    if (vd.name && !pv.seed.name) pv.seed.name = vd.name;
    pv.budget = null;
    pv.profile = null;
    drawWho();

    // logo, socials, followers and description live on the shared budget
    // record. It is read back through the same exposed query the list
    // itself uses, so whatever that query may show, the card shows too.
    if (typeof window.getPublicProductBudgets === 'function' && vd.token) {
      var handle = String(vd.token).split('__')[1] || '';
      if (!handle) {
        var m = /\/products\/([^\/?#]+)/.exec(window.location.pathname);
        handle = m ? m[1] : '';
      }
      if (handle) {
        window.getPublicProductBudgets(false, handle, '', null).then(function (list) {
          if (!list) return;
          for (var i = 0; i < list.length; i++) {
            if (String(list[i].id) === String(vd.token)) {
              mergeBudgetPart(profileFromBudget(list[i]));
              drawWho();
              return;
            }
          }
        }).catch(function () {});
      }
    }

    if (window.db && vd.owner) {
      window.db.collection('public_data').doc(vd.owner).get().then(function (doc) {
        if (!doc.exists) return;
        pv.profile = (doc.data() || {}).profile || null;
        drawWho();
      }).catch(function () {});
    }
  }

  function ownerFromToken(token) {
    var t = String(token || '');
    var i = t.indexOf('__');
    return i > 0 ? t.slice(0, i) : t;
  }

  /* Whatever opens this drawer -- the list, an answered quote, an offer --
     goes through here first. Skipping it left the panel narrow and the
     implement icons unstyled, because the styles arrive with it. */
  /* The budget reads hourly rates from a global; while a foreign budget
     is on screen that global holds the foreign rates, and the visitor's
     own are put back when the drawer closes. */
  var rateBackup = null;

  /* While a foreign budget is on screen the page globals hold someone
     else's numbers. Anything that saves in that moment -- the autosave
     after a change, the stats refresh, the shared budget publish --
     would store them as the visitor's own. So saving is held shut for
     as long as the drawer is open, and the implement buttons lift it
     for the one write they make. */
  var writeLock = { on: false, saved: null };

  function lockWrites() {
    if (writeLock.on) return;
    writeLock.on = true;
    writeLock.saved = {
      central: window.saveUserCentralizedData,
      shared: window.__levaSaveSharedBudget,
      bump: window.bumpUserBudgetChangeCounter,
      // hourly rates have their own writer, and it was the one that got
      // through: a foreign rate on screen was saved as the reader's own
      rate: window.saveHourlyRateFor,
      rates: window.applyImportedHourlyRates,
      refresh: window.refreshBudgetDetailsStats
    };
    var noop = function () { return Promise.resolve(); };
    try { window.saveUserCentralizedData = noop; } catch (e) {}
    try { window.__levaSaveSharedBudget = function () {}; } catch (e) {}
    try { window.bumpUserBudgetChangeCounter = function () {}; } catch (e) {}
    try { window.saveHourlyRateFor = noop; } catch (e) {}
    try { window.applyImportedHourlyRates = noop; } catch (e) {}
    try { window.refreshBudgetDetailsStats = noop; } catch (e) {}
  }

  function unlockWrites() {
    if (!writeLock.on) return;
    var s = writeLock.saved || {};
    try { if (s.central) window.saveUserCentralizedData = s.central; } catch (e) {}
    try { if (s.shared) window.__levaSaveSharedBudget = s.shared; } catch (e) {}
    try { if (s.bump) window.bumpUserBudgetChangeCounter = s.bump; } catch (e) {}
    try { if (s.rate) window.saveHourlyRateFor = s.rate; } catch (e) {}
    try { if (s.rates) window.applyImportedHourlyRates = s.rates; } catch (e) {}
    try { if (s.refresh) window.refreshBudgetDetailsStats = s.refresh; } catch (e) {}
    writeLock.on = false;
    writeLock.saved = null;
  }

  // an import is the one write that is meant to happen
  function withWrites(fn) {
    var was = writeLock.on;
    if (was) unlockWrites();
    try { fn(); } finally { if (was) setTimeout(lockWrites, 1500); }
  }

  /* The budget reads its hourly rate from window.hourlyRatesMap, keyed by
     category slug -- not from hourlyRatesByCategory, which is only the
     shape rates are stored and imported in. Feeding the wrong one was why
     a foreign offer kept showing the reader's own rates. */
  /* A saved rate looks like this: { vendor: 47.01, vendor_local_value: 980,
     vendor_local_currency: 'CZK', vendor_rate_used: 29.19 }. The figure the
     budget wants is 'vendor', held in USD; the local value is only what the
     vendor typed. Looking for a key called rate or value found nothing, so
     the map stayed empty and the reader kept their own rates. */
  function ratesToMap(rates) {
    var map = {};
    var active = '';
    var fx = 1;
    try {
      if (window.Shopify && window.Shopify.currency) {
        active = String(window.Shopify.currency.active || '').toUpperCase();
        fx = Number(window.Shopify.currency.rate) || 1;
      }
    } catch (e) {}

    for (var cat in rates) {
      if (!Object.prototype.hasOwnProperty.call(rates, cat)) continue;
      if (cat === '__default') continue;
      var v = rates[cat];
      var n = null;

      if (v && typeof v === 'object') {
        var local = Number(v.vendor_local_value);
        var localCur = String(v.vendor_local_currency || '').toUpperCase();
        var usd = Number(v.vendor != null ? v.vendor : (v.rate != null ? v.rate : v.value));

        // the page shows one currency: take the value already in it,
        // otherwise convert the USD one the same way the budget does
        if (active && localCur === active && isFinite(local) && local > 0) n = local;
        else if (isFinite(usd) && usd > 0) n = (active && active !== 'USD') ? usd * fx : usd;
      } else {
        n = Number(v);
      }

      if (isFinite(n) && n > 0) map[String(cat).toLowerCase()] = n;
    }
    return map;
  }

  /* A category the offer does not mention used to fall through to the
     reader's own rate, which is how an offer built on house rates came
     out thousands higher than the vendor ever saw. While a foreign
     budget is on screen the fallback shows the vendor's rate instead,
     and the reader's own is put back on close. */
  function applyForeignRates(rates) {
    if (!rates) return;
    var map = ratesToMap(rates);
    var pv = document.getElementById('preferred-vendor');
    if (rateBackup === null) {
      // a copy, so nothing that writes into the live object can reach it
      var mine = window.hourlyRatesMap || null;
      rateBackup = {
        map: mine ? JSON.parse(JSON.stringify(mine)) : null,
        cats: window.hourlyRatesByCategory || null,
        pv: pv ? pv.textContent : null
      };
    }
    window.hourlyRatesByCategory = rates;
    if (Object.keys(map).length) window.hourlyRatesMap = map;

    var fallback = Number(rates.__default);
    if (pv && isFinite(fallback) && fallback > 0) {
      pv.textContent = String(Math.round(fallback * 100) / 100);
    }
  }

  function restoreRates() {
    if (rateBackup === null) return;
    window.hourlyRatesMap = rateBackup.map;
    window.hourlyRatesByCategory = rateBackup.cats;
    var pv = document.getElementById('preferred-vendor');
    if (pv && rateBackup.pv !== null && rateBackup.pv !== undefined) {
      pv.textContent = rateBackup.pv;
    }
    rateBackup = null;
  }

  function pageLang() {
    var l = '';
    try {
      l = document.documentElement.getAttribute('lang') || '';
      if (!l && window.Shopify && window.Shopify.locale) l = window.Shopify.locale;
    } catch (e) {}
    l = String(l || 'en').split('-')[0].toLowerCase();
    return l || 'en';
  }

  function lgAmt(v) {
    if (v === null || v === undefined || v === '') return 0;
    if (typeof v === 'number') return isFinite(v) ? v : 0;
    var n = parseFloat(String(v).replace(',', '.'));
    return isFinite(n) ? n : 0;
  }

  function lgCur() {
    var out = { code: 'USD', fx: 1 };
    try {
      if (window.Shopify && window.Shopify.currency) {
        out.code = String(window.Shopify.currency.active || 'USD').toUpperCase();
        out.fx = Number(window.Shopify.currency.rate) || 1;
      }
    } catch (e) {}
    return out;
  }

  function lgUnit() {
    var el = document.getElementById('unitSelector');
    return (el && el.getAttribute('data-current-unit')) || 'metric';
  }

  function lgScreen(sel) {
    var el = document.querySelector(sel);
    return el ? (el.textContent || '').trim() : '-';
  }

  function lgRows() {
    if (Object.prototype.toString.call(window.productData) === '[object Array]' && window.productData.length) {
      return { rows: window.productData.slice(), src: 'productData' };
    }
    var out = [];
    var m = window.productDataMap || {};
    for (var k in m) {
      if (!Object.prototype.hasOwnProperty.call(m, k)) continue;
      if (Object.prototype.toString.call(m[k]) === '[object Array]') out = out.concat(m[k]);
    }
    return { rows: out, src: 'productDataMap' };
  }

  function lgRate(sub) {
    var map = window.hourlyRatesMap || {};
    var key = String(sub || '');
    var v = map[key];
    if (v === undefined) v = map[key.toLowerCase()];
    if (v && typeof v === 'object') return { rate: 0, src: 'OBJECT-IN-MAP' };
    var n = parseFloat(v);
    if (isFinite(n) && n > 0) return { rate: n, src: 'offer' };
    var pv = document.getElementById('preferred-vendor');
    if (pv) {
      var p = parseFloat((pv.textContent || '').replace(/[^0-9.,-]/g, '').replace(',', '.'));
      if (isFinite(p) && p > 0) return { rate: p, src: 'PV-FALLBACK' };
    }
    return { rate: 10 * lgCur().fx, src: 'DEFAULT-FALLBACK' };
  }

  function lgUnitPrice(row, unit) {
    var p = window.user_prices || {};
    var id = row[0];
    var c = lgCur();
    var base;
    if (c.code === 'USD') {
      base = lgAmt(p[id]);
    } else {
      var loc = p[id + '_' + c.code];
      base = loc ? lgAmt(loc) : lgAmt(p[id]) * c.fx;
    }
    var mu = lgAmt(row[10]);
    var iu = lgAmt(row[11]);
    if (unit !== 'metric' && mu > 0 && iu > 0) base = (base * mu) / iu;
    return base;
  }

  function lgMinutes(row, unit) {
    var e = window.execution_data || {};
    var id = row[0];
    var base = lgAmt(e[id + '_duration']) || lgAmt(row[23]);
    var w = lgAmt(e[id + '_workers']) || lgAmt(row[26]) || 1;
    var mins = base * w;
    var mu = lgAmt(row[10]);
    var iu = lgAmt(row[11]);
    var units = unit === 'metric' ? mu : iu;
    if (unit !== 'metric' && mu > 0 && iu > 0) mins = (mins * mu) / iu;
    return mins * units;
  }

  function lgCfg() {
    try { return new URL(window.location.href).searchParams.get('cfg') || '-'; }
    catch (e) { return '-'; }
  }

  function lgOpenDrawers() {
    var out = [];
    for (var i = 0; i < LOG_DRAWERS.length; i++) {
      var d = document.getElementById(LOG_DRAWERS[i].id);
      if (d && d.classList.contains('active')) out.push(LOG_DRAWERS[i].kind);
    }
    return out.join(',') || 'none';
  }

  function lgProfileFields() {
    var keys = ['name', 'country', 'currency', 'email', 'phone', 'address', 'radius_km'];
    var out = [];
    for (var i = 0; i < keys.length; i++) {
      var f = document.querySelector('[data-prof-f="' + keys[i] + '"]');
      if (!f) continue;
      out.push(keys[i] + '=' + (f.value || '') + (f.getAttribute('data-prof-set') === '1' ? '*' : ''));
    }
    return out.join('  ') || '-';
  }

  function lgListRows() {
    var el = document.querySelector('[data-bic-lists]');
    if (!el) return '-';
    return el.querySelectorAll('.share-recommended-item').length;
  }

  function lgRound(n) {
    return Math.round((Number(n) || 0) * 100) / 100;
  }

  function buildLog(kind) {
    kind = kind || 'vendor';
    var L = [];
    var c = lgCur();
    var unit = lgUnit();
    var got = lgRows();
    var rows = got.rows;
    var offer = (vd.data || {});
    var oMat = offer.materials || {};
    var oExe = offer.execution || {};
    var oRates = offer.hourlyRatesByCategory || {};

    L.push('LEVA log -- ' + kind + ' drawer');

    /* PUJCENE UZLY.

       Zasuvka si nevykresluje vlastni kopii rozpoctu - vytahne si k sobe
       SKUTECNE uzly hlavniho rozpoctu, prilepi na ne ikony prevzeti a pri
       zavreni je vrati. Ikony ale zustavaji nalepene na tychz uzlech, takze
       se vrati s nimi a spini hlavni rozpocet.

       Tohle je jedine misto, kde se to da videt cerne na bilem: co je prave
       pujcene, kolik ikon na tom visi a kolik jich zustalo po zavreni. */
    (function () {
      var b = (vd && vd.borrowed) || [];
      L.push('BORROW: ' + b.length + ' uzlu, drawer ' + (vd && vd.open ? 'otevren' : 'zavren'));
      for (var i = 0; i < b.length; i++) {
        var n = b[i].node;
        if (!n) { L.push('  [' + i + '] uzel chybi'); continue; }
        var slotOk = !!(b[i].slot && b[i].slot.parentNode);
        var host = n.parentNode;
        var where = host ? (host.id ? '#' + host.id : (host.className || host.tagName)) : '(mimo stranku)';
        L.push('  [' + i + '] ' + (n.getAttribute && (n.getAttribute('data-budget-sections') !== null ? '[data-budget-sections]' : (n.id ? '#' + n.id : n.className)) || n.tagName)
          + ' | ted v: ' + String(where).slice(0, 60)
          + ' | slot ' + (slotOk ? 'ceka' : 'PRYC')
          + ' | ikon uvnitr: sec ' + n.querySelectorAll('.vdr-imp-icon--sec').length
          + ', item ' + n.querySelectorAll('.vdr-imp-icon--item').length);
      }

      /* A totez z druhe strany: kolik ikon prevzeti je prave ted VE STRANCE
         mimo zasuvku. Cokoliv jineho nez nula je ta chyba. */
      var drawer = document.getElementById('Leva-Vendor-Drawer');
      var all = document.querySelectorAll('.vdr-imp-icon');
      var outside = 0;
      for (var k = 0; k < all.length; k++) {
        if (!drawer || !drawer.contains(all[k])) outside++;
      }
      L.push('IKONY PREVZETI: celkem ' + all.length + ', mimo zasuvku ' + outside
        + (outside ? '  <-- tyhle zustaly v hlavnim rozpoctu' : ''));
      L.push('  sekce v strance: ' + document.querySelectorAll('[data-section-heading]').length
        + ' | z toho v zasuvce: ' + (drawer ? drawer.querySelectorAll('[data-section-heading]').length : 0));
    })();

    L.push('file: ' + ((window.LevaProfile && window.LevaProfile.version) || '?') + '  block: ' + VERSION);
    L.push('product: ' + (badgeHandle() || '-') + '  cfg: ' + lgCfg());
    L.push('customer: ' + (window.customerId || '-') + '  mail: ' + (myMail() || '-'));
    L.push('currency: ' + c.code + '  fx: ' + c.fx + '  units: ' + unit);
    L.push('rows: ' + rows.length + ' from ' + got.src);
    L.push('open drawers: ' + lgOpenDrawers());
    if (kind === 'vendor') {
      L.push('token: ' + (vd.token || '-') + '  owner: ' + (vd.owner || '-') + '  name: ' + (vd.name || '-'));
      L.push('offer keys: materials ' + Object.keys(oMat).length + ', execution ' + Object.keys(oExe).length + ', rate cats ' + Object.keys(oRates).length);
      L.push('rate cats in offer: ' + (Object.keys(oRates).join(',') || '-'));
    }
    if (kind === 'share') L.push('profile fields: ' + lgProfileFields());
    if (kind === 'share' && typeof window.__levaAddrReport === 'function') {
      L.push('ADDRESS LOOKUP');
      L.push(window.__levaAddrReport());
      L.push('');
    }
    if (kind === 'quotes') L.push('place suggest: '
      + (typeof window.__levaPlaceLast === 'function' ? window.__levaPlaceLast() : '-'));
    if (kind === 'quotes') L.push('quotes tab: ' + qTab
      + '  last delete: ' + (typeof window.__levaLastDelete === 'function' ? window.__levaLastDelete() : '-'));
    if (kind === 'shared') {
      L.push('list rows: ' + lgListRows() + '  last error: ' + (lastErr || '-'));

      L.push('COVERAGE FILTER');
      var cf = window.__levaCovDiag || null;
      var d3 = document.getElementById('Leva-Shared-Drawer');
      var bar2 = d3 ? d3.querySelector('[data-leva-covbar]') : null;
      var box3 = bar2 ? bar2.getBoundingClientRect() : null;
      L.push('  watcher: ' + (covWatch ? 'still trying' : 'idle'));
      L.push('  bar in drawer: ' + (bar2 ? 'yes' : 'NO')
        + '  size: ' + (box3 ? (Math.round(box3.width) + 'x' + Math.round(box3.height)) : '-')
        + '  categories offered: ' + covFilterList().length);
      if (cf) {
        L.push('  picked: ' + cf.picked + '  mode: ' + cf.mode);
        L.push('  own removed: ' + document.querySelectorAll('[data-leva-own]').length);
      L.push('  rows: ' + cf.rows + '  shown: ' + cf.shown
          + '  without trades: ' + cf.noTrades);
      } else {
        L.push('  not applied yet');
      }

      var cards = document.querySelectorAll('.share-recommended-item');
      for (var ci3 = 0; ci3 < cards.length && ci3 < 8; ci3++) {
        var nm2 = cards[ci3].querySelector('.share-recommended-item-name');
        L.push('  card ' + (nm2 ? nm2.textContent.trim() : '?')
          + '  trades: ' + ((cards[ci3].getAttribute('data-trades') || '-').split('|').length)
          + '  cats: ' + (cards[ci3].getAttribute('data-cats') || '-')
          + '  ' + (cards[ci3].style.display === 'none' ? 'HIDDEN' : 'shown'));
      }

      /* WHERE THE RIGHT EDGE ACTUALLY FALLS. Two cards, the same list, and
         one of them stands off the margin -- measuring both says which
         element is wider rather than which rule looks suspicious. */
      L.push('RIGHT EDGE');
      for (var ce = 0; ce < cards.length && ce < 4; ce++) {
        var card = cards[ce];
        var nmE = card.querySelector('.share-recommended-item-name');
        var sideE = card.querySelector('.share-recommended-item-side');
        var cardBox = card.getBoundingClientRect();
        L.push('  ' + (nmE ? nmE.textContent.trim() : '?')
          + '  card right: ' + Math.round(cardBox.right)
          + '  pad: ' + (function () {
              try { return window.getComputedStyle(card).paddingRight; } catch (e) { return '?'; }
            })());

        if (!sideE) { L.push('    no side column'); continue; }
        var sb = sideE.getBoundingClientRect();
        L.push('    side right: ' + Math.round(sb.right)
          + '  width: ' + Math.round(sb.width)
          + '  align: ' + (function () {
              try { return window.getComputedStyle(sideE).alignItems; } catch (e) { return '?'; }
            })());

        var kids = sideE.children;
        for (var ke = 0; ke < kids.length; ke++) {
          var kb = kids[ke].getBoundingClientRect();
          var st = {};
          try { st = window.getComputedStyle(kids[ke]); } catch (e) {}
          L.push('    ' + (kids[ke].className || kids[ke].tagName)
            + '  right: ' + Math.round(kb.right)
            + '  w: ' + Math.round(kb.width)
            + '  pad: ' + (st.paddingLeft || '?') + '/' + (st.paddingRight || '?')
            + '  margin: ' + (st.marginRight || '?')
            + '  text: ' + (kids[ke].textContent || '').trim().slice(0, 18));
        }
      }
    }

    if (kind === 'share') {
      L.push('ITEM PICKER');
      var pk = window.__levaTradeDiag || {};
      L.push('  mount attempts: ' + (pk.tries || 0) + '  last: ' + (pk.when || '-'));
      L.push('  host chosen: ' + (pk.host || 'NONE') + '  host hidden: ' + (pk.hidden ? 'yes' : 'no'));
      L.push('  already mounted: ' + (pk.already ? 'yes' : 'no'));
      L.push('  entries offered: ' + (pk.list === undefined ? '-' : pk.list));
      L.push('  in document now: '
        + document.querySelectorAll('[data-leva-tt]').length
        + '  visible: '
        + (function () {
            var n = document.querySelector('[data-leva-tt]');
            if (!n) return 'no node';
            var b = n.getBoundingClientRect();
            return b.width + 'x' + b.height;
          })());
      L.push('  candidates: '
        + ['[data-prof-vendor-fields]', '[data-prof-form]',
           '#share-panel-recommended-product', '#share-panel-recommended',
           '#share-panel-settings'].map(function (sel) {
             var n = document.querySelector(sel);
             if (!n) return sel + '=absent';
             var b = n.getBoundingClientRect();
             return sel + '=' + (n.hidden ? 'hidden' : (b.width + 'x' + b.height));
           }).join('  '));
      L.push('  placement: ' + (pk.order || '-'));

      /* Where the node really sits, and what every child of the form is
         numbered, so the reason is in the log instead of in a guess. */
      var w = document.querySelector('[data-leva-tt]');
      L.push('  wrap parent: ' + (w && w.parentNode
        ? (w.parentNode.className || w.parentNode.tagName) : 'none'));
      L.push('  wrap order: ' + (w ? (w.style.order || '-') : '-')
        + '  computed: ' + (w ? (function () {
            try { return window.getComputedStyle(w).order; } catch (e) { return '?'; }
          })() : '-'));

      var f = document.querySelector('[data-prof-form]');
      if (f) {
        var disp = '';
        try { disp = window.getComputedStyle(f).display; } catch (e) {}
        L.push('  form display: ' + disp + '  children: ' + f.children.length);

        var line = [];
        for (var ci = 0; ci < f.children.length; ci++) {
          var c = f.children[ci];
          var o = '';
          try { o = window.getComputedStyle(c).order; } catch (e) {}
          var who = c.getAttribute('data-leva-tt') ? 'ITEMS'
            : (c.querySelector && c.querySelector('[data-prof-f]')
                ? c.querySelector('[data-prof-f]').getAttribute('data-prof-f')
                : (c.className || c.tagName));
          var box = c.getBoundingClientRect();
          line.push(who + '=' + (o || '-')
            + (c.hidden ? ':hidden' : '')
            + (box.height ? '' : ':flat')
            + '@' + Math.round(box.top));
        }
        L.push('  form children: ' + line.join('  '));
      }

      L.push('  address kept: ' + (window.__levaKeptPlace || '-'));
      L.push('  auto name: ' + (window.__levaNameLabel || '-'));
      L.push('  saved trades: '
        + ((window.__levaSavedTrades && window.__levaSavedTrades.length)
            ? window.__levaSavedTrades.join(', ') : '-'));
    }
    if (kind === 'vendor' && vd.token) L.push('grant token: ' + vd.token);
    L.push('hourlyRatesMap: ' + JSON.stringify(window.hourlyRatesMap || {}));
    L.push('preferred-vendor: ' + lgScreen('#preferred-vendor')
      + (rateBackup && rateBackup.pv !== null && rateBackup.pv !== undefined
        ? '  (vendor fallback, mine is ' + rateBackup.pv + ')' : ''));
    /* An offer on screen is the point of the whole exercise, so its
       figures belong in every log taken while it is open, not only in
       the one taken from its own drawer. */
    if (vd.open || kind === 'vendor') {
      L.push('OFFER ON SCREEN');
      L.push('  token: ' + (vd.token || '-') + '  from: ' + (vd.name || vd.owner || '-'));
      L.push('  keys: materials ' + Object.keys(oMat).length
        + ', execution ' + Object.keys(oExe).length
        + ', rate cats ' + Object.keys(oRates).length);
      L.push('  __default: ' + (oRates.__default || '-'));
      L.push('  cfg: ' + (offer.cfg || '-') + '  page cfg: ' + lgCfg()
        + (offer.cfg && offer.cfg !== lgCfg() ? '  MISMATCH -- priced on another model' : ''));
      var vt = offer.vendorTotals || null;
      if (!vt) {
        L.push('  vendor totals sent: none -- offer predates prof-v183');
      } else {
        L.push('  vendor totals sent: material ' + Math.round(vt.material)
          + ', execution ' + Math.round(vt.execution) + ', time ' + vt.time
          + (vt.coefficient != null
            ? ('   (raw ' + vt.rawMaterial + ' x ' + vt.coefficient
               + ', ' + vt.rawExecution + ' x ' + vt.rateCoefficient + ')')
            : '   (raw, no coefficient recorded)'));
      }
    }
    L.push('');

    var subs = {};
    var order = [];
    var i;
    for (i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (!row || !row[0]) continue;
      var sub = String(row[2] || '');
      if (!subs[sub]) {
        var r = lgRate(sub);
        subs[sub] = { rate: r.rate, src: r.src, mins: 0, exec: 0, mat: 0, n: 0, vd: 0, vp: 0, minsMap: 0, minsDef: 0 };
        order.push(sub);
      }
      var s = subs[sub];
      var mins = lgMinutes(row, unit);
      var units = unit === 'metric' ? lgAmt(row[10]) : lgAmt(row[11]);
      s.mins += mins;
      s.exec += (s.rate / 60) * mins;
      s.mat += lgUnitPrice(row, unit) * units;
      s.n += 1;
      var liveExe = window.execution_data || {};
      var livePri = window.user_prices || {};
      var dv = liveExe[row[0] + '_duration'];
      var pv2 = livePri[row[0]];
      if (dv !== undefined && dv !== '') { s.vd += 1; s.minsMap += mins; }
      else { s.minsDef += mins; }
      if (pv2 !== undefined && pv2 !== '') s.vp += 1;
    }

    order.sort(function (a, b) { return subs[b].exec - subs[a].exec; });

    var tMins = 0;
    var tExec = 0;
    var tMat = 0;
    var fallback = [];
    var wide = true;
    L.push('SUBCATEGORY | rate | source | hours | execution | material | rows | dur/price in map');
    for (i = 0; i < order.length; i++) {
      var k = order[i];
      var o = subs[k];
      tMins += o.mins;
      tExec += o.exec;
      tMat += o.mat;
      if (o.src !== 'offer') fallback.push(k + ' (' + o.src + ')');
      if (wide) L.push((k || '-') + ' | ' + lgRound(o.rate) + ' | ' + o.src + ' | '
        + lgRound(o.mins / 60) + ' | ' + Math.round(o.exec) + ' | ' + Math.round(o.mat)
        + ' | ' + o.n + ' | ' + o.vd + '/' + o.vp);
    }
    L.push('');

    var minsMap = 0;
    var minsDef = 0;
    var rowsNoDur = 0;
    for (i = 0; i < order.length; i++) {
      minsMap += subs[order[i]].minsMap;
      minsDef += subs[order[i]].minsDef;
    }
    for (i = 0; i < rows.length; i++) {
      if (!rows[i] || !rows[i][0]) continue;
      if (lgMinutes(rows[i], unit) === 0) rowsNoDur++;
    }
    L.push('ROW SET: ' + rows.length + ' rows, ' + order.length + ' subcategories, '
      + rowsNoDur + ' with no duration at all');
    L.push('MINUTES from execution map: ' + Math.round(minsMap)
      + '  from catalog defaults: ' + Math.round(minsDef));
    L.push('productData: ' + ((window.productData && window.productData.length) || 0)
      + '  productDataMap sections: ' + Object.keys(window.productDataMap || {}).length);
    L.push('execution_data keys: ' + Object.keys(window.execution_data || {}).length
      + '  user_prices keys: ' + Object.keys(window.user_prices || {}).length);

    var ids = [];
    for (i = 0; i < rows.length; i++) {
      if (rows[i] && rows[i][0]) ids.push(String(rows[i][0]));
    }
    ids.sort();
    L.push('ROW IDS (' + ids.length + '): ' + ids.join(','));
    L.push('');
    L.push('COMPUTED total material: ' + Math.round(tMat));
    L.push('COMPUTED total execution: ' + Math.round(tExec));
    L.push('COMPUTED total hours: ' + lgRound(tMins / 60));

    var vtc = (vd.open || kind === 'vendor') ? (offer.vendorTotals || null) : null;
    if (vtc) {
      var dM = (vtc.material == null) ? null : Math.round(tMat) - Math.round(vtc.material);
      var dE = (vtc.execution == null) ? null : Math.round(tExec) - Math.round(vtc.execution);
      var dT = (vtc.time == null) ? null : lgRound(tMins / 60) - Number(vtc.time);
      L.push('CHECK against the vendor: material ' + (dM === null ? '-' : dM)
        + ', execution ' + (dE === null ? '-' : dE)
        + ', hours ' + (dT === null ? '-' : lgRound(dT))
        + ((dM || dE || dT) ? '  OFF -- the two sides do not agree' : '  exact'));
    }
    L.push('rows priced by vendor rate: ' + (order.length - fallback.length) + ' of ' + order.length + ' subcategories');
    L.push('FALLBACK subcategories: ' + (fallback.length ? fallback.join(', ') : 'none'));
    L.push('');

    L.push('ON SCREEN cost: ' + lgScreen('[data-budget-total-cost]'));
    L.push('ON SCREEN material: ' + lgScreen('[data-budget-total-material]'));
    L.push('ON SCREEN execution: ' + lgScreen('[data-budget-total-execution]'));
    L.push('ON SCREEN time: ' + lgScreen('[data-budget-total-time]'));
    L.push('PUBLISHED __bcMaterialsTotal: ' + (window.__bcMaterialsTotal !== undefined ? window.__bcMaterialsTotal : '-'));
    L.push('PUBLISHED __bcExecutionTotal: ' + (window.__bcExecutionTotal !== undefined ? window.__bcExecutionTotal : '-'));
    L.push('PUBLISHED lastDurationTotal: ' + (window.lastDurationTotal !== undefined ? window.lastDurationTotal : '-'));

    return L.join('\n');
  }

  function redrawBudget() {
    if (typeof window.__budgetRenderItems === 'function') window.__budgetRenderItems();
    else if (typeof window.__levaBudgetRefresh === 'function') window.__levaBudgetRefresh();
    if (typeof window.updateTotal === 'function') {
      try { window.updateTotal(); } catch (e) {}
    }
  }

  function prepVendor() {
    vendorStyle();
    var d = vendorDrawer();
    if (!d) return null;
    d.style.width = 'min(1100px, 95vw)';
    d.style.maxWidth = '95vw';
    // above the list of shared budgets, which is itself raised
    d.style.zIndex = '100004';
    d.style.background = '#f5f5f5';
    d.setAttribute('data-vdr', VERSION);
    return d;
  }

  function openVendor(token, name, card) {
    if (vd.open) closeVendor();
    var d = prepVendor();
    if (!d) return;
    vd.token = token;
    vd.owner = ownerFromToken(token);
    vd.name = name || '';

    paintWho(d, card);
    d.querySelector('[data-vd-msg]').textContent = T.loading;
    d.classList.add('active');
    document.body.classList.add('open-cc');

    if (typeof window.getExternalBudgetData !== 'function') return;
    window.getExternalBudgetData(vd.owner, true).then(function (data) {
      vd.data = data;
      showVendorBudget(data);
    }).catch(function (err) {
      console.error('vendor budget failed', err);
      d.querySelector('[data-vd-msg]').textContent = T.loadFailed;
    });
  }

  /* AN OFFER IS TWO THINGS AT ONCE. The unit prices, times and rates are a
     price list: they hold whatever the model becomes, which is the whole
     point of being able to keep shaping it. The TOTAL is a promise about
     one building. So the model is left alone -- moving it under the reader
     would take away the thing they came for -- and the sum simply says
     which building it was for. */
  function noteOtherModel(d, q) {
    var old = d.querySelector('.vdr-cfgnote');
    if (old && old.parentNode) old.parentNode.removeChild(old);

    var was = q.cfg || q.configId || '';
    var now = '';
    try { now = new URL(window.location.href).searchParams.get('cfg') || ''; } catch (e) {}
    if (!was || !now || was === now) return;

    var vt = q.vendorTotals || null;
    var host = d.querySelector('.vdr-who') || d.querySelector('.side-panel-content--inner') || d;
    var box = document.createElement('div');
    box.className = 'vdr-cfgnote';

    var line = document.createElement('div');
    line.className = 'vdr-cfgnote__t';
    line.textContent = (T.rq && T.rq.cfgNote)
      || 'Prices below are this vendor. The quoted total was for a different version of the model.';
    box.appendChild(line);

    if (vt && vt.material != null && vt.execution != null) {
      var sum = document.createElement('div');
      sum.className = 'vdr-cfgnote__s';
      sum.textContent = Math.round(Number(vt.material) + Number(vt.execution)).toLocaleString()
        + (vt.time != null ? ('  /  ' + Math.round(Number(vt.time)).toLocaleString() + ' h') : '');
      box.appendChild(sum);
    }

    if (host.firstChild) host.insertBefore(box, host.firstChild);
    else host.appendChild(box);
  }

  /* WORK NOBODY OFFERED IS WORTH NO HOURS. A subcategory the vendor left
     out arrives with no rate, and lookupHourlyRate then walks its own
     ladder -- the reader's preferred rate, then the house ten -- so the
     roof this vendor never quoted was priced anyway, at the reader's
     figure, and the total drifted by exactly those trades.
     A rate of zero cannot say this: the ladder only accepts a positive
     number, so a zero falls through like a blank. The hours are what get
     cleared instead. No time, no money, and the line still shows with its
     quantity, which is honest -- this vendor is not doing it. */
  function blankUncovered(data) {
    var exec = data.execution || {};
    var covered = {};
    var list = data.subcategories || null;
    var i;

    if (list && list.length) {
      for (i = 0; i < list.length; i++) covered[String(list[i]).toLowerCase()] = true;
    } else {
      // older offers carry no list, so the rates they did send stand in
      var rates = data.hourlyRatesByCategory || {};
      for (var k in rates) {
        if (!Object.prototype.hasOwnProperty.call(rates, k)) continue;
        if (k === '__default') continue;
        covered[String(k).toLowerCase()] = true;
      }
      var mats = data.materials || {};
      var rows0 = qsRows();
      for (i = 0; i < rows0.length; i++) {
        var r0 = rows0[i];
        if (!r0 || !r0[0] || !r0[2]) continue;
        if (mats[r0[0]] !== undefined && mats[r0[0]] !== '') covered[String(r0[2]).toLowerCase()] = true;
      }
    }

    var out = {};
    for (var key in exec) {
      if (Object.prototype.hasOwnProperty.call(exec, key)) out[key] = exec[key];
    }

    var rows = qsRows();
    for (i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (!row || !row[0] || !row[2]) continue;
      if (covered[String(row[2]).toLowerCase()]) continue;
      out[row[0] + '_duration'] = 0;
      out[row[0] + '_workers'] = 0;
    }
    return out;
  }

  function showVendorBudget(data) {
    var d = vendorDrawer();
    var inner = d.querySelector('[data-vd-inner]');
    if (!inner) return;

    mergeBudgetPart(profileFromBudget(data));
    drawWho();

    // remember what belongs to the visitor
    vd.prices = window.user_prices;
    vd.exec = window.execution_data;

    lockWrites();
    // rates first: the render that follows reads them
    applyForeignRates(data.hourlyRatesByCategory);
    window.user_prices = data.materials || {};
    window.execution_data = blankUncovered(data);

    /* Redraw, and redraw again a beat later. The first pass fills the rows;
       the totals and the donuts are written by a second pass that runs
       after it, so cloning the cards immediately copied the old figures. */
    redrawBudget();

    /* The overview is copied, the rows are borrowed.
       The pass that fills the donuts looks for them inside the budget
       root it captured at start up. Cards moved into this drawer are
       outside it, so any later pass left them at zero -- they filled for
       a moment and then went blank. The cards are therefore cloned once
       the numbers are in them: a still picture of a budget that cannot
       change while it is only being read. */
    vd.borrowed = [];

    /* The overview is borrowed, not copied. The renderer holds references
       to these very elements and writes the totals into them on every
       pass, so moving them keeps the figures live -- a copy froze at the
       moment it was taken, which is why an actualised offer still showed
       the old sum. */
    var live = ['[data-budget-hero]', '[data-budget-cards]'];
    for (var i = 0; i < live.length; i++) {
      var node = document.querySelector(live[i]);
      if (!node || !node.parentNode) continue;
      var slotC = document.createComment('vdr-slot');
      node.parentNode.insertBefore(slotC, node);
      vd.borrowed.push({ node: node, slot: slotC });
      inner.appendChild(node);
    }

    var sections = document.querySelector('[data-budget-sections]');
    if (sections && sections.parentNode) {
      var slot = document.createComment('vdr-slot');
      sections.parentNode.insertBefore(slot, sections);
      vd.borrowed.push({ node: sections, slot: slot });
      inner.appendChild(sections);
    }

    d.querySelector('[data-vd-msg]').textContent = '';
    addSectionButtons(inner);
    vd.open = true;
    try {
      console.log('[VDR] pujceno ' + vd.borrowed.length + ' uzlu, ikon prevzeti: sec '
        + inner.querySelectorAll('.vdr-imp-icon--sec').length + ', item '
        + inner.querySelectorAll('.vdr-imp-icon--item').length);
    } catch (e) {}
  }

  function impIcon(cls, title, onClick) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'vdr-imp-icon ' + cls;
    b.title = title;
    b.setAttribute('aria-label', title);
    var img = document.createElement('img');
    img.src = IMG.open;
    img.alt = '';
    b.appendChild(img);
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      onClick();
    });
    return b;
  }

  function addSectionButtons(root) {
    var blocks = root.querySelectorAll('[data-section-heading]');
    for (var i = 0; i < blocks.length; i++) {
      (function (block) {
        var title = block.querySelector('.budget-section-header__title');
        if (!title || title.querySelector('.vdr-imp-icon')) return;
        var heading = block.getAttribute('data-section-heading');
        title.appendChild(impIcon('vdr-imp-icon--sec', T.impSection, function () {
          takeSection(heading);
        }));
      })(blocks[i]);
    }

    var items = root.querySelectorAll('.budget-item[data-item-id]');
    for (var j = 0; j < items.length; j++) {
      (function (row) {
        if (row.querySelector('.vdr-imp-icon--item')) return;
        var id = row.getAttribute('data-item-id');
        row.appendChild(impIcon('vdr-imp-icon--item', T.impItem, function () {
          takeItems([id]);
        }));
      })(items[j]);
    }
  }

  function confirmImp(go) {
    var old = document.getElementById('vdr-confirm');
    if (old) old.parentNode.removeChild(old);
    var wrap = document.createElement('div');
    wrap.id = 'vdr-confirm';
    wrap.innerHTML = ''
      + '<div class="vdr-c__box">'
      + '  <div class="vdr-c__title">' + T.confirmTitle + '</div>'
      + '  <div class="vdr-c__col">'
      + '    <button type="button" class="vdr-c__btn" data-c-no>' + T.confirmCancel + '</button>'
      + '    <button type="button" class="vdr-c__btn vdr-c__btn--ok" data-c-mode="material">' + T.confirmMaterial + '</button>'
      + '    <button type="button" class="vdr-c__btn vdr-c__btn--ok" data-c-mode="execution">' + T.confirmExecution + '</button>'
      + '    <button type="button" class="vdr-c__btn vdr-c__btn--ok" data-c-mode="all">' + T.confirmAll + '</button>'
      + '  </div>'
      + '</div>';
    document.body.appendChild(wrap);
    function shut() { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }
    wrap.addEventListener('click', function (e) { if (e.target === wrap) shut(); });
    wrap.querySelector('[data-c-no]').addEventListener('click', shut);
    var modes = wrap.querySelectorAll('[data-c-mode]');
    for (var i = 0; i < modes.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          shut();
          go(btn.getAttribute('data-c-mode'));
        });
      })(modes[i]);
    }
  }

  // material only, execution only, or the whole thing
  function dataFor(mode) {
    if (!vd.data || mode === 'all') return vd.data;
    var copy = {};
    for (var k in vd.data) {
      if (Object.prototype.hasOwnProperty.call(vd.data, k)) copy[k] = vd.data[k];
    }
    if (mode === 'material') copy.execution = {};
    else copy.materials = {};
    return copy;
  }

  function takeItems(ids) {
    if (!ids.length || typeof window.__levaImportInputIds !== 'function') return;
    confirmImp(function (mode) {
      withWrites(function () {
        window.__levaImportInputIds(ids, dataFor(mode), vd.name, true,
          (vd.data && vd.data.hourlyRatesByCategory) || {},
          { token: vd.token, ownerId: vd.owner, visibility: 'public' });
      });
      closeVendor();
    });
  }

  function takeSection(heading) {
    var map = window.productDataMap || {};
    var rows = map[heading] || [];
    var ids = [];
    for (var i = 0; i < rows.length; i++) if (rows[i] && rows[i][0]) ids.push(rows[i][0]);
    takeItems(ids);
  }

  function closeVendor() {
    var d = document.getElementById('Leva-Vendor-Drawer');

    var b = vd.borrowed || [];

    /* IKONY PREVZETI PATRI ZASUVCE, NE ROZPOCTU.

       Zasuvka si pujcuje SKUTECNE uzly rozpoctu a ikony prilepuje primo na ne.
       Pri vraceni jdou tedy s nimi zpatky do hlavniho rozpoctu, kde nemaji co
       delat - a nikdo je uz nesunda.

       U polozek se to neprojevilo, protoze radky se po zavreni prekresluji a
       ikony se ztrati s nimi. Hlavicky kategorii se ale neprekresluji, takze
       na nich devet ikon zustalo. Sundavaji se proto tady, jeste nez se uzel
       vrati na sve misto. */
    for (var c = 0; c < b.length; c++) {
      var node = b[c] && b[c].node;
      if (!node || !node.querySelectorAll) continue;
      var stuck = node.querySelectorAll('.vdr-imp-icon');
      for (var e = stuck.length - 1; e >= 0; e--) {
        if (stuck[e].parentNode) stuck[e].parentNode.removeChild(stuck[e]);
      }
    }

    for (var i = b.length - 1; i >= 0; i--) {
      if (b[i].slot && b[i].slot.parentNode) {
        b[i].slot.parentNode.insertBefore(b[i].node, b[i].slot);
        b[i].slot.parentNode.removeChild(b[i].slot);
      }
    }
    vd.borrowed = [];
    try {
      var dr0 = document.getElementById('Leva-Vendor-Drawer');
      var left = 0;
      var ic0 = document.querySelectorAll('.vdr-imp-icon');
      for (var q = 0; q < ic0.length; q++) if (!dr0 || !dr0.contains(ic0[q])) left++;
      console.log('[VDR] vraceno ' + b.length + ' uzlu, ikon prevzeti mimo zasuvku: ' + left
        + (left ? '  <-- zustaly v hlavnim rozpoctu' : ''));
    } catch (e) {}
    restoreRates();
    unlockWrites();
    redrawBudget();
    var dEl = document.getElementById('Leva-Vendor-Drawer');

    if (vd.prices) window.user_prices = vd.prices;
    if (vd.exec) window.execution_data = vd.exec;
    if (vd.open && typeof window.__budgetRenderItems === 'function') window.__budgetRenderItems();

    vd.open = false;
    vd.prices = null;
    vd.exec = null;

    if (!d) return;
    d.classList.remove('active');
    if (!document.querySelector('.side-panel.active')) {
      document.body.classList.remove('open-cc');
    }
  }

  /* ============================================================
     ON-DEMAND BUDGETS: THE GRANT IS READ, NOT JUST WRITTEN
     Approving a request has been writing status, grantDays and grantUntil
     into the record since the day it was built -- and nothing has ever
     looked at them. So the approval was a receipt: whoever held the link
     opened the prices, approved or not, expired or not.
     This is the reading end. It is a courtesy lock, not a safe: the rules
     on the collections are still open, so anyone who can open a console
     can read the record straight out. The lock that actually holds comes
     with those rules, and it cannot be turned on until this check exists,
     which is why it is in this order.
     ============================================================ */
  function grantFor(token, cb) {
    var me = myMail();
    if (!window.db || !token) { cb(null); return; }
    if (!me) { cb(null); return; }

    qOne('requests', 'fromEmail', '==', me).then(function (rows) {
      var best = null;
      rows.forEach(function (doc) {
        var r = doc.q;
        if (String(r.budgetToken || '') !== String(token)) return;
        if (r.status !== 'approved') return;
        var until = toMillis(r.grantUntil);
        if (!until || until < Date.now()) return;
        if (!best || until > best.until) best = { until: until, id: doc.id, req: r };
      });
      cb(best);
    }).catch(function () { cb(null); });
  }

  /* A budget shared on demand is private until its owner says otherwise. */
  function needsGrant(token, cb) {
    if (!window.db || !token) { cb(false); return; }
    window.db.collection('budget_details').doc(String(token)).get().then(function (doc) {
      if (!doc.exists) { cb(false); return; }
      var d = doc.data() || {};
      var mine = String(d.customerId || '') === String(window.customerId || '');
      if (mine) { cb(false); return; }
      /* Anything not plainly marked public is treated as private. A lock
         that opens when it cannot read the record is not a lock. */
      cb(d.isPublic !== true);
    }).catch(function () {
      // could not tell: err towards asking rather than handing it over
      cb(true);
    });
  }

  function askForGrant(token, name) {
    var d = prepVendor();
    if (!d) return;
    raise(d);
    d.style.zIndex = '100004';
    paintWho(d, null);
    d.classList.add('active');
    document.body.classList.add('open-cc');

    var host = d.querySelector('[data-vd-msg]');
    if (!host) return;
    host.textContent = '';

    var box = document.createElement('div');
    box.className = 'vdr-cfgnote';
    var line = document.createElement('div');
    line.className = 'vdr-cfgnote__t';
    line.textContent = (T.rq && T.rq.needGrant)
      || 'These prices are shared on request. Ask their owner and they land in Approvals.';
    box.appendChild(line);
    host.appendChild(box);

    var form = document.createElement('div');
    form.className = 'rq-slot__form';
    host.appendChild(form);

    ownerEmailOf(token, function (mail) {
      buildRequestForm(form, mail || '', '', 'requests');
      var extra = document.createElement('input');
      extra.type = 'hidden';
      extra.setAttribute('data-rq-token', String(token));
      form.appendChild(extra);
    });
  }

  /* Every door into a shared budget goes through here. */
  function openSharedGuarded(token, name, card) {
    needsGrant(token, function (locked) {
      if (!locked) { openVendor(token, name || '', card || null); return; }
      grantFor(token, function (grant) {
        if (grant) { openVendor(token, name || '', card || null); return; }

        /* The form belongs under the card that was clicked, where the eye
           already is -- opening a drawer of its own moved the reader away
           from the thing they were looking at and made a refusal feel like
           a dead end rather than the next step. */
        var row = card && card.classList && card.classList.contains('share-recommended-item')
          ? card
          : document.querySelector('.share-recommended-item[data-token="' + token + '"]');
        if (row) { toggleAskForm(row); return; }
        askForGrant(token, name || '');
      });
    });
  }

  /* Anything that used to reach for the old import dialogue is sent to
     this drawer instead. The old one stays in place for now -- other
     parts of the theme still call it -- but nothing routes to it. */
  window.__levaOpenSharedBudget = function (token, name, card) {
    openSharedGuarded(token, name || '', card || null);
  };

  (function redirectOldModal() {
    function install() {
      if (typeof window.openUseBudgetModal !== 'function') return false;
      if (window.openUseBudgetModal.__bicRouted) return true;
      var routed = function (token) {
        openSharedGuarded(token, '', null);
      };
      routed.__bicRouted = true;
      window.openUseBudgetModal = routed;

      var byToken = window.openBudgetImportByToken;
      if (typeof byToken === 'function' && !byToken.__bicRouted) {
        var routed2 = function (token) {
          if (!token) return;
          openSharedGuarded(String(token), '', null);
        };
        routed2.__bicRouted = true;
        window.openBudgetImportByToken = routed2;
      }
      return true;
    }
    if (install()) return;
    var tries = 0;
    var iv = setInterval(function () {
      if (install() || ++tries > 200) clearInterval(iv);
    }, 50);
  })();

  // a card in the list opens the budget instead of the import dialogue
  document.addEventListener('click', function (e) {
    var host = document.getElementById('Leva-Shared-Drawer');
    if (!host || !host.contains(e.target)) return;
    var row = e.target.closest ? e.target.closest('.share-recommended-item') : null;
    if (!row) return;
    var token = row.getAttribute('data-token');
    if (!token) return;
    e.preventDefault();
    e.stopPropagation();
    var nameEl = row.querySelector('.share-recommended-item-name');
    /* THROUGH THE GATE, like every other way in. This listener was written
       before there was one and went straight to openVendor, so a budget
       shared on request opened for anybody who clicked its card in the
       list -- the one route people actually use. */
    openSharedGuarded(token, nameEl ? nameEl.textContent.trim() : '', row);
  }, true);

  /* ============================================================
     W1  PRICE REQUESTS
     The project URL carries everything: ?cfg=... keeps the visitor's
     configuration and leva_req names the request. Nothing secret ever
     travels by mail -- the decision bar is shown to the signed in
     addressee only, so the sender can click their own link freely.
     ============================================================ */

  function rqStyle() {
    if (document.getElementById('rq-style')) return;
    var css = ''
      + '.rq-bar{position:fixed;left:16px;right:16px;bottom:30px;z-index:100020;background:#1A1C1D;'
      + 'color:#fff;border-radius:14px;display:flex;align-items:center;gap:16px;padding:14px 18px;'
      + 'box-shadow:0 10px 34px rgba(0,0,0,.3);}'
      + '.rq-bar__txt{flex:1 1 auto;font-size:14px;min-width:0;}'
      + '.rq-bar__who{display:block;font-size:12px;color:#A9ADB3;margin-top:2px;}'
      + '.rq-bar__b{width:44px;height:44px;border-radius:50%;border:0;cursor:pointer;'
      + 'display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;}'
      + '.rq-bar__b--no{background:#D8232A;}'
      + '.rq-bar__b--yes{background:#1C9E5A;}'
      + '.rq-bar__b svg{display:block;}'
      + '.rq-per{position:fixed;inset:0;z-index:100021;background:rgba(20,21,23,.45);'
      + 'display:flex;align-items:center;justify-content:center;}'
      + '.rq-per__box{background:#fff;border-radius:14px;padding:24px 28px;min-width:250px;text-align:center;}'
      + '.rq-per__t{font-size:15px;font-weight:600;color:#1A1C1D;margin-bottom:16px;}'
      + '.rq-per__b{display:block;width:100%;margin-top:10px;border:1px solid #D7D9DC;background:#fff;'
      + 'border-radius:999px;font-family:inherit;font-size:13px;padding:10px 18px;cursor:pointer;}'
      + '.rq-form{display:flex;flex-direction:column;gap:10px;padding:4px 0 16px;}'
      + '.rq-form label{font-size:12px;color:#6B7280;display:flex;flex-direction:column;gap:5px;}'
      + '.rq-form input,.rq-form textarea{border:1px solid #E0E1E3;border-radius:9px;padding:10px 11px;'
      + 'font-family:inherit;font-size:14px;color:#1A1C1D;background:#fff;width:100%;box-sizing:border-box;}'
      + '.rq-send{border:0;border-radius:999px;background:#D2A878;color:#1A1C1D;font-family:inherit;'
      + 'font-size:13px;padding:11px 22px;cursor:pointer;align-self:flex-start;}'
      + '.rq-msg{font-size:12px;color:#6B7280;}'
      + '#Leva-Quotes-Drawer .side-panel-content--inner{padding-top:18px;}'
      + '.rq-open{padding:0 0 14px;}'

      + '.share-recommended-item{position:relative;}'
      /* THE 72 PIXELS. A budget shared on request carries the theme's own
         action button in the row, where a free one carries an icon that
         floats -- so the right-hand column stopped 72px short of the
         margin its neighbour keeps. We draw our own button over the card,
         so this one is taking up room to do nothing. It stays in the
         document because the on-demand state is read off it. */
      + '.share-recommended-item .share-recommended-action[data-action="question"]'
      + '{position:absolute !important;width:0 !important;height:0 !important;'
      + 'padding:0 !important;margin:0 !important;border:0 !important;'
      + 'overflow:hidden !important;opacity:0 !important;pointer-events:none !important;}'
      + '.rq-ask-form{border:0;padding:10px 2px 4px;margin:0 0 6px;background:transparent;}'
      + '.rq-send--idle{background:#EDEEF0;color:#6B7280;}'
      + '.rq-send--idle:hover{background:#E4E6E9;color:#1A1C1D;}'
      + '.rq-bn{display:flex;align-items:center;gap:12px;background:#FFFFFF;border:1px solid #DADCE0;'
      + 'border-radius:12px;padding:12px 14px;margin-bottom:10px;}'
      + '.rq-bn.is-click{cursor:pointer;}'
      + '.rq-bn.is-click:hover{border-color:#D2A878;}'
      + '.rq-bn__dot{width:10px;height:10px;border-radius:50%;background:#C9CCD1;flex:0 0 auto;}'
      + '.rq-bn__txt{flex:1 1 auto;min-width:0;}'
      + '.rq-bn__t{font-size:13px;font-weight:700;color:#1A1C1D;letter-spacing:.04em;'
      + 'text-transform:uppercase;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}'
      + '.rq-bn__m{font-size:12px;color:#4B5563;margin-top:2px;'
      + 'overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}'
      + '.rq-bn__s{font-size:12px;color:#9CA3AF;margin-top:2px;'
      + 'overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}'
      + '.rq-bn__money{font-size:17px;font-weight:700;color:#1A1C1D;margin-top:6px;}'
      + '.rq-bn__until{font-size:11px;color:#9CA3AF;margin-top:1px;}'
      + '.rq-bn__until--soon{color:#8a6100;}'
      + '.rq-bn__until--gone{color:#D8232A;}'
      + '.rq-bn__st{font-size:11px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;'
      + 'color:#9CA3AF;white-space:nowrap;margin-right:22px;}'
      + '.rq-bn{position:relative;overflow:visible;}'
      /* The purple circle, the one every download on the site wears, sat
         on the corner of the frame so the status labels stay in one line
         down the right hand edge. */
      + '.rq-bn__open{position:absolute;top:50%;margin-top:-13px;right:-11px;width:26px;height:26px;'
      + 'background:#7B5FC9;border-radius:50%;box-shadow:0 2px 8px rgba(0,0,0,.16);}'
      + '.rq-bn__open img{width:12px;height:12px;filter:brightness(0) invert(1);}'
      + '.rq-bn--none{opacity:.55;}'
      + '.rq-bn--pending .rq-bn__dot{background:#D2A878;}'
      + '.rq-bn--pending .rq-bn__st{color:#8A6100;}'
      + '.rq-bn--pending{border-color:#D2A878;border-width:2px;background:#FFFDF9;'
      + 'box-shadow:0 2px 10px rgba(210,168,120,.18);}'
      + '.rq-bn--approved .rq-bn__dot{background:#1C9E5A;}'
      + '.rq-bn--approved .rq-bn__st{color:#1C6B38;}'
      + '.rq-bn--declined .rq-bn__dot{background:#D8232A;}'
      + '.rq-bn--declined .rq-bn__st{color:#D8232A;}'
      + '.rq-list{margin-top:18px;}'
      + '.rq-list + .rq-list{margin-top:26px;border-top:1px solid #DADCE0;padding-top:14px;}'
      + '.rq-list__h{font-size:11px;font-weight:600;letter-spacing:.05em;color:#9CA3AF;'
      + 'text-transform:uppercase;margin-bottom:10px;}'
      + '.rq-slot{margin-bottom:10px;}'
      + '.rq-slot .rq-bn{margin-bottom:0;}'
      + '.rq-acts{display:flex;justify-content:flex-end;gap:8px;padding:0 0 10px;}'
      + '.rq-bn__pill{border:1px solid #D2A878;background:#fff;color:#8a6100;border-radius:999px;'
      + 'padding:3px 10px;font-size:11px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;'
      + 'font-family:inherit;cursor:pointer;flex:0 0 auto;margin-left:8px;}'
      + '.rq-bn__pill--bin{border-color:#E5E7EB;color:#9CA3AF;}'
      + '.rq-bn__pill.is-bad{border-color:#D8232A;color:#D8232A;}'
      + '.rq-act{width:28px;height:28px;border-radius:50%;border:0;color:#fff;'
      + 'display:inline-flex;align-items:center;justify-content:center;cursor:pointer;}'
      + '.rq-act--link{background:#3F3222;}'
      + '.rq-act--cube{background:#5A6B47;}'
      + '.rq-act--bin{background:#D8232A;}'
      + '.rq-act--ok{background:#1C9E5A;}'
      + '.rq-act--chat{background:#7B5FC9;position:relative;}'
      + '.rq-chat__badge{position:absolute;top:-4px;right:-4px;min-width:16px;height:16px;'
      + 'border-radius:8px;background:#D8232A;color:#fff;font-size:10px;line-height:16px;'
      + 'text-align:center;padding:0 3px;font-weight:700;}'
      + '.rq-chat{margin:10px 0 0;background:rgba(0,0,0,0.04);border-radius:10px;padding:10px;}'
      + '.rq-chat__list{max-height:220px;overflow:auto;display:flex;flex-direction:column;gap:6px;}'
      + '.rq-chat__msg{max-width:80%;padding:7px 11px;border-radius:10px;font-size:13px;'
      + 'line-height:1.45;background:#fff;align-self:flex-start;word-break:break-word;}'
      + '.rq-chat__msg--me{background:#7B5FC9;color:#fff;align-self:flex-end;}'
      + '.rq-chat__empty{font-size:12px;color:#8a8a8a;padding:6px 2px;}'
      + '.rq-chat__row{display:flex;gap:8px;margin-top:10px;}'
      + '.rq-chat__in{flex:1 1 auto;border:1px solid rgba(0,0,0,0.14);border-radius:8px;'
      + 'padding:8px 10px;font-family:inherit;font-size:13px;}'
      + '.rq-chat__img{display:block;max-width:180px;border-radius:8px;margin-bottom:6px;}'
      + '.rq-chat__file{display:block;color:inherit;text-decoration:underline;'
      + 'font-size:12px;margin-bottom:4px;word-break:break-all;}'
      + '.rq-chat__clip{border:1px solid rgba(0,0,0,0.14);border-radius:8px;background:#fff;'
      + 'width:34px;font-size:18px;line-height:1;cursor:pointer;color:#7B5FC9;}'
      + '.rq-chat__send{border:0;border-radius:8px;background:#7B5FC9;color:#fff;'
      + 'padding:8px 14px;font-family:inherit;font-size:12px;font-weight:700;cursor:pointer;}'
      + '.rq-bn__act--3{right:60px;}'
      + '.rq-bn__act--4{right:96px;}'
      + '.rq-act--urge{background:#8a6b43;}'
      + '.rq-bn__act{position:absolute;top:50%;margin-top:-14px;right:-12px;}'
      + '.rq-bn__act--2{right:24px;}'
      + '.qs-detail{padding:2px 0 10px;}'
      + '.qs-line{display:flex;align-items:center;gap:10px;margin-top:8px;flex-wrap:wrap;}'
      + '.qs-line--addr{flex-wrap:nowrap;}'
      + '.qs-addr{flex:1 1 auto;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}'
      + '.qs-who{font-size:12px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;'
      + 'color:#6B7280;margin-top:12px;}'
      + '.qs-line b{font-size:14px;color:#1A1C1D;font-weight:600;}'
      + '.qs-ic{width:28px;height:28px;border-radius:50%;border:1px solid #DADCE0;background:#fff;'
      + 'color:#3F3222;display:inline-flex;align-items:center;justify-content:center;'
      + 'cursor:pointer;text-decoration:none;}'
      + '.qs-ic:hover{border-color:#D2A878;}'
      + '.qs-div{height:1px;background:#DADCE0;margin:8px 0 14px;}'
      + '.rq-act:hover{opacity:.88;}'
      + '.rq-act.is-done{background:#1C9E5A;}'
      + '.rq-bn.is-expired{opacity:.7;}'
      + '.rq-bn.is-expired .rq-bn__st{color:#9CA3AF;}'
      + '.qs-head{border-bottom:1px solid #DADCE0;padding:4px 0 16px;margin-bottom:14px;}'
      + '.qs-head__t{font-size:15px;font-weight:600;color:#1A1C1D;margin-bottom:12px;}'
      + '.qs-row{display:flex;gap:8px;margin-bottom:12px;}'
      + '.qs-btn{border:1px solid #DADCE0;background:#fff;color:#6B7280;border-radius:999px;'
      + 'font-family:inherit;font-size:12px;padding:8px 16px;cursor:pointer;}'
      + '.qs-btn.is-on{background:#1A1C1D;border-color:#1A1C1D;color:#fff;}'
      + '.qs-pick{margin:14px 0 6px;}'
      /* accent-color paints the box but leaves the tick to the browser,
         which picks near-black on a light fill and all but disappears. So
         the box is ours: sand when on, a white tick drawn on top. */
      + '.qs-pick input[type=checkbox]{appearance:none;-webkit-appearance:none;'
      + 'width:18px;height:18px;flex:0 0 auto;margin:0;border:1px solid #D2A878;'
      + 'border-radius:5px;background:#fff;position:relative;cursor:pointer;}'
      + '.qs-pick input[type=checkbox]:checked,'
      + '.qs-pick input[type=checkbox]:indeterminate{background:#D2A878;border-color:#D2A878;}'
      + '.qs-pick input[type=checkbox]:checked::after{content:"";position:absolute;'
      + 'left:6px;top:2px;width:4px;height:9px;border:solid #fff;border-width:0 2px 2px 0;'
      + 'transform:rotate(45deg);}'
      + '.qs-pick input[type=checkbox]:indeterminate::after{content:"";position:absolute;'
      + 'left:3px;top:7px;width:10px;height:2px;background:#fff;border-radius:1px;}'
      + '.qs-pick__none{font-size:12px;color:#6B7280;line-height:1.4;}'
      + '.qs-pick__g{border-top:1px solid #EFEFEF;}'
      + '.qs-pick__g:last-child{border-bottom:1px solid #EFEFEF;}'
      + '.qs-pick__cat{display:flex;align-items:center;gap:8px;font-size:11px;font-weight:700;'
      + 'letter-spacing:.05em;color:#1A1C1D;padding:9px 0;cursor:pointer;}'
      + '.qs-pick__car{margin-left:auto;color:#D2A878;font-size:11px;transition:transform 140ms;}'
      + '.qs-pick__g.is-open .qs-pick__car{transform:rotate(90deg);}'
      + '.qs-pick__n{font-size:11px;color:#9CA3AF;font-weight:600;letter-spacing:0;}'
      + '.qs-pick__body{display:none;padding:0 0 8px;}'
      + '.qs-pick__g.is-open .qs-pick__body{display:block;}'
      + '.qs-pick__s{display:flex;align-items:center;gap:8px;font-size:13px;color:#374151;'
      + 'padding:6px 0 6px 20px;border-top:1px solid #F5F5F5;}'
      + '.qs-pick__tag{font-size:11px;color:#9CA3AF;margin-left:auto;white-space:nowrap;}'
      /* THIRD LEVEL: the lines inside a subcategory. Defined here, with the
         rest of the tree, so the quote sheet and the sharing panel get the
         same thing -- written for one of them it broke the other. */
      + '.qs-pick__pair{display:block;width:100%;}'
      + '.qs-pick__car--sub{margin-left:8px;color:#D2A878;font-size:11px;'
      + 'transition:transform 140ms;flex:0 0 auto;}'
      + '.qs-pick__pair.is-open .qs-pick__car--sub{transform:rotate(90deg);}'
      + '.qs-pick__i{display:none;padding:2px 0 8px 44px;}'
      + '.qs-pick__pair.is-open .qs-pick__i{display:block;}'
      + '.qs-pick__it{display:flex;align-items:center;gap:8px;width:100%;'
      + 'font-size:12px;color:#6B7280;padding:4px 0;}'
      + '.qs-pick__itn{flex:1 1 auto;min-width:0;overflow:hidden;'
      + 'text-overflow:ellipsis;white-space:nowrap;}'
      + '.qs-pick__itc{font-size:10px;color:#C7CACD;white-space:nowrap;flex:0 0 auto;}'
      + '.qs-field{display:flex;flex-direction:column;gap:5px;font-size:12px;color:#6B7280;'
      + 'margin-bottom:12px;}'
      + '.qs-out{font-size:20px;font-weight:700;color:#1A1C1D;margin:-4px 0 12px;}'
      /* prof-v282 THE QUOTE AS A CARD (the AI reel's "what the supplier
         sees"): the lines priced, the labour, what is left, the total */
      + '.qs-card{background:#F5F5F5;border:1px solid #E2E2E2;border-radius:16px;padding:14px 15px;margin:4px 0 14px;'
      + 'color:#1A1C1D;animation:qs-card-in .45s cubic-bezier(.2,.7,.2,1) both;transition:transform .5s,opacity .5s;}'
      + '@keyframes qs-card-in{from{opacity:0;transform:perspective(900px) rotateY(40deg);}to{opacity:1;transform:none;}}'
      + '.qs-card[hidden]{display:none;}'
      + '.qs-card--sent{transform:scale(.96);opacity:.6;}'
      + '.qs-card__kick{font-size:11px;letter-spacing:.16em;font-weight:700;color:#7A5A36;text-transform:uppercase;margin-bottom:6px;}'
      + '.qs-card__who{font-size:15px;font-weight:700;margin-bottom:8px;}'
      + '.qs-card__who:empty{display:none;}'
      + '.qs-card__r{display:grid;grid-template-columns:1fr auto;gap:1px 10px;align-items:center;padding:7px 0;border-bottom:1px solid #E3E3E3;font-size:13px;}'
      + '.qs-card__n{font-weight:600;min-width:0;}'
      + '.qs-card__q{grid-column:1;font-size:11px;color:#6D6D6D;}'
      + '.qs-card__f{grid-column:2;grid-row:1 / span 2;min-width:78px;text-align:right;border:1px solid #CDCDCD;border-radius:8px;'
      + 'padding:5px 9px;background:#fff;font-weight:700;font-variant-numeric:tabular-nums;}'
      + '.qs-card__more{font-size:12px;color:#6D6D6D;padding:7px 0 0;}'
      + '.qs-card__more:empty{display:none;}'
      + '.qs-card__tot{display:flex;justify-content:space-between;align-items:baseline;gap:10px;margin-top:10px;padding-top:10px;border-top:1px solid #D9D9D9;}'
      + '.qs-card__tot span{font-size:12px;color:#555;text-transform:uppercase;letter-spacing:.08em;}'
      + '.qs-card__tot b{font-size:24px;font-variant-numeric:tabular-nums;}'
      + '.rq-send--card{display:block;width:100%;align-self:stretch;border-radius:12px;background:#D8232A;color:#fff;font-weight:700;'
      + 'letter-spacing:.1em;text-transform:uppercase;padding:14px;margin-bottom:8px;}'
      + '.rq-send--card:hover{filter:brightness(1.06);}'
      + '.qs-sub{font-size:15px;font-weight:600;color:#4B5563;margin:-6px 0 12px;}'
      + '.rq-det{padding:10px 14px 14px;border:1px solid #EFEFEF;border-top:0;'
      + 'border-radius:0 0 12px 12px;margin-top:-6px;background:#FCFCFC;}'
      + '.rq-det__r{display:flex;gap:10px;align-items:baseline;padding:3px 0;font-size:12px;}'
      + '.rq-det__k{flex:0 0 92px;color:#9CA3AF;font-size:11px;text-transform:uppercase;'
      + 'letter-spacing:.04em;}'
      + '.rq-det__k--note{flex:none;display:block;margin-top:10px;}'
      + '.rq-det__v{color:#1A1C1D;word-break:break-word;}'
      + 'a.rq-det__v{color:#8a6100;text-decoration:underline;}'
      + '.rq-det__note{font-size:13px;line-height:1.5;color:#374151;margin-top:4px;'
      + 'white-space:pre-wrap;}'
      + '.share-drawer-tab{position:relative;}'
      + '.rq-tabn{display:inline-block;margin-left:6px;min-width:17px;height:17px;padding:0 5px;'
      + 'border-radius:999px;background:#111;color:#fff;font-size:10px;font-weight:700;'
      + 'line-height:17px;text-align:center;vertical-align:middle;}'
      + '.rq-det--vendor{border:1px solid #E8D6B8;border-radius:12px;background:#FFFDF9;'
      + 'margin:0 0 12px;padding:2px 14px 12px;}'
      + '.rq-det__v--money{font-weight:700;font-size:15px;}'
      /* Sent is in flight, opened has landed: the budget's own blue for
         the first, green for the second. */
      + '.rq-bn__st--out{color:#2563eb;}'
      + '.rq-bn__st--seen{color:#2E7D46;}'
      + '.rq-terms{font-size:11px;line-height:1.4;color:#9CA3AF;margin-top:10px;}'
      + '.rq-terms a{color:#8a6100;text-decoration:underline;}'
      + '.qs-sub--mat{color:#4B5563;}'
      + '.qs-sub--exe{color:#2563eb;}'
      + '.qs-sub__h{color:#60a5fa;}'
      + '.qs-sub__sep{color:#9CA3AF;font-weight:400;padding:0 6px;}'
      + '.qs-offer{margin:4px 0 14px;}'
      + '.rq-msg--done{font-size:13px;font-weight:600;color:#1C6B38;padding:4px 0;}'
      + '.qs-log{border:1px solid #D2A878;background:#fff;color:#8a6100;border-radius:999px;'
      + 'padding:3px 10px;font-size:11px;font-family:inherit;cursor:pointer;}'
      + '.vdr-log{margin-left:12px;align-self:flex-start;}'
      + '.qs-model{border:1px solid #1A1C1D;background:#1A1C1D;color:#fff;border-radius:999px;'
      + 'font-family:inherit;font-size:12px;padding:9px 18px;cursor:pointer;margin:10px 0 2px;}'
      + '.qs-field input,.qs-field select{border:1px solid #E0E1E3;border-radius:9px;padding:10px 11px;'
      + 'font-family:inherit;font-size:14px;color:#1A1C1D;background:#fff;width:100%;box-sizing:border-box;}'
      + '.rq-slot__form{border:0;padding:12px 2px 4px;background:transparent;}'
      + '.rq-slot__form .rq-form{padding-bottom:4px;}';
    var tag = document.createElement('style');
    tag.id = 'rq-style';
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  function tick(color) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '20');
    svg.setAttribute('height', '20');
    svg.setAttribute('fill', 'none');
    var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    p.setAttribute('d', color === 'yes' ? 'M4 12.5l5 5L20 6.5' : 'M6 6l12 12M18 6L6 18');
    p.setAttribute('stroke', '#fff');
    p.setAttribute('stroke-width', '2.4');
    p.setAttribute('stroke-linecap', 'round');
    p.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(p);
    return svg;
  }

  function myEmail() {
    return String(window.customerEmail || '').trim().toLowerCase();
  }

  // ---- the addressee decides ----
  function showBar(reqId, req) {
    rqStyle();
    var old = document.querySelector('.rq-bar');
    if (old) old.parentNode.removeChild(old);

    var bar = document.createElement('div');
    bar.className = 'rq-bar';

    var txt = document.createElement('div');
    txt.className = 'rq-bar__txt';
    txt.textContent = T.rq.prompt;
    var who = document.createElement('span');
    who.className = 'rq-bar__who';
    who.textContent = [req.phone, req.place].filter(Boolean).join('  |  ');
    txt.appendChild(who);
    bar.appendChild(txt);

    var no = document.createElement('button');
    no.type = 'button';
    no.className = 'rq-bar__b rq-bar__b--no';
    no.title = T.rq.no;
    no.appendChild(tick('no'));
    no.addEventListener('click', function () { decide(reqId, null); });
    bar.appendChild(no);

    var yes = document.createElement('button');
    yes.type = 'button';
    yes.className = 'rq-bar__b rq-bar__b--yes';
    yes.title = T.rq.yes;
    yes.appendChild(tick('yes'));
    yes.addEventListener('click', function () { askPeriod(reqId); });
    bar.appendChild(yes);

    document.body.appendChild(bar);
  }

  function askPeriod(reqId) {
    var wrap = document.createElement('div');
    wrap.className = 'rq-per';
    wrap.innerHTML = ''
      + '<div class="rq-per__box">'
      + '  <div class="rq-per__t">' + T.rq.period + '</div>'
      + '  <button type="button" class="rq-per__b" data-days="14">' + T.rq.d14 + '</button>'
      + '  <button type="button" class="rq-per__b" data-days="60">' + T.rq.m2 + '</button>'
      + '</div>';
    document.body.appendChild(wrap);
    wrap.addEventListener('click', function (e) {
      if (e.target === wrap) wrap.parentNode.removeChild(wrap);
    });
    var bs = wrap.querySelectorAll('[data-days]');
    for (var i = 0; i < bs.length; i++) {
      (function (b) {
        b.addEventListener('click', function () {
          wrap.parentNode.removeChild(wrap);
          decide(reqId, Number(b.getAttribute('data-days')));
        });
      })(bs[i]);
    }
  }

  function decide(reqId, days) {
    if (!window.db) return;
    var patch = {
      status: days ? 'approved' : 'declined',
      decidedAt: new Date()
    };
    if (days) {
      var until = new Date();
      until.setDate(until.getDate() + days);
      patch.grantDays = days;
      patch.grantUntil = until;
    }
    window.db.collection('requests').doc(String(reqId)).set(patch, { merge: true })
      .then(function () {
        var bar = document.querySelector('.rq-bar');
        if (bar) {
          bar.querySelector('.rq-bar__txt').textContent = days ? T.rq.approved : T.rq.declined;
          var bs = bar.querySelectorAll('.rq-bar__b');
          for (var i = 0; i < bs.length; i++) bs[i].hidden = true;
          setTimeout(function () { if (bar.parentNode) bar.parentNode.removeChild(bar); }, 2500);
        }
      })
      .catch(function (e) { console.error('request decision failed', e); });
  }

  function checkRequestParam() {
    var id = '';
    try {
      id = new URL(window.location.href).searchParams.get('leva_req') || '';
    } catch (e) {}
    if (!id || !window.db) return;

    window.db.collection('requests').doc(id).get().then(function (doc) {
      if (!doc.exists) return;
      var req = doc.data() || {};
      if (req.status && req.status !== 'pending') return;
      // only the signed in addressee sees the bar
      var mine = myEmail();
      if (!mine || mine !== String(req.vendorEmail || '').toLowerCase()) return;
      showBar(id, req);
    }).catch(function () {});
  }

  // ---- the visitor asks ----
  function requestId() {
    return 'rq' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  }

  function projectUrl(id, param) {
    var u;
    try { u = new URL(window.location.href); } catch (e) { return window.location.href; }
    u.searchParams.set(param || 'leva_req', id);
    return u.toString();
  }

  // Today this hands the mail to the visitor's own client. When the worker
  // exists it will send from info@theleva.com with Reply-To on the visitor
  // and them in copy; only the body of this function changes.
  function projectName() {
    try {
      var ctx = window.shareProductContext || {};
      var t = (ctx.title || '').trim();
      var v = (ctx.variantTitle || '').trim();
      if (t) return v ? (t + ' / ' + v) : t;
    } catch (e) {}
    var h1 = document.querySelector('h1');
    return h1 ? h1.textContent.trim() : '';
  }

  function townOf(place) {
    return String(place || '').split(',')[0].trim();
  }

  /* The mail is the first thing a vendor sees, and often the only thing
     before they decide whether to open the link at all. It opened with a
     phone number and nothing else -- no sender, no job. */
  function sendRequestMail(to, url, req, kind) {
    /* The letter opens with the request and closes with who is asking. A
       name standing alone above the greeting read like a header, not a
       signature. */
    var body = ''
      + (req.note ? (req.note + '\n\n') : '')
      + (req.fromName ? (req.fromName + '\n') : '')
      + 'Phone: ' + (req.phone || '') + '\n'
      + 'Place: ' + (req.place || '') + '\n'
      + 'Email: ' + (req.fromEmail || '') + '\n'
      + '\n' + url + '\n';

    /* Two different things ask through this form. One is a job -- price
       my project, here is where it is. The other only wants to see a
       budget somebody has shared, and calling that a price request for a
       project misdescribes it in the one line a recipient reads first. */
    var subject = (kind === 'requests')
      ? ((T.rq && T.rq.subjectBudget) || 'Budget request')
      : T.rq.subject;
    var name = projectName();
    var town = townOf(req.place);
    if (name) subject += ': ' + name;
    if (kind !== 'requests' && town) subject += ' - ' + town;

    var href = 'mailto:' + encodeURIComponent(to)
      + '?subject=' + encodeURIComponent(subject)
      + '&body=' + encodeURIComponent(body);
    window.location.href = href;
  }

  /* The most recent request this person sent, whoever it went to. */
  function lastSentByMe(cb) {
    var me = myMail();
    if (!window.db || !me) { cb(null); return; }
    qOne('quotes', 'fromEmail', '==', me).then(function (rows) {
      var best = null;
      rows.forEach(function (doc) {
        var at = toMillis(doc.q.createdAt);
        if (!best || at > best.at) best = { at: at, q: doc.q };
      });
      cb(best ? best.q : null);
    }).catch(function () { cb(null); });
  }

  /* Sending is the moment the agreement matters, so the line sits with the
     button rather than somewhere in a settings page. */
  function termsLine(host, what) {
    var p = document.createElement('div');
    p.className = 'rq-terms';
    p.appendChild(document.createTextNode(what + ' '));
    var a = document.createElement('a');
    a.href = '/pages/terms-and-conditions';
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = (T.rq && T.rq.termsLink) || 'Terms & Conditions';
    p.appendChild(a);
    p.appendChild(document.createTextNode('.'));
    host.appendChild(p);
  }

  /* ============================================================
     TWO IDENTITIES, KEPT APART
     Writing to a vendor about a job and publishing a budget for the world
     are different acts with different audiences. Reading the name and
     phone for a request out of the sharing profile tied them together, so
     a name typed once into an enquiry turned up on a public card its owner
     never meant to sign -- and the same for the address.
     These are the enquiry's own details, stored with the enquiries and
     never read from or written to the sharing profile. What the sharing
     form says is what the public sees; what the enquiry form says is what
     the vendor sees.
     ============================================================ */
  var RQ_ME = 'leva-rq-me';

  function rqMe() {
    try {
      var raw = localStorage.getItem(RQ_ME);
      return raw ? (JSON.parse(raw) || {}) : {};
    } catch (e) { return {}; }
  }

  function rqMeSet(key, value) {
    if (!key) return;
    try {
      var all = rqMe();
      all[key] = String(value || '');
      localStorage.setItem(RQ_ME, JSON.stringify(all));
    } catch (e) {}
  }

  /* Last resort only: an enquiry sent before this existed carries the
     details on its own record, and those are the person's own words. */
  function rqMeVal(key, fallback) {
    var mine = rqMe();
    if (mine[key]) return mine[key];
    return fallback || '';
  }

  function buildRequestForm(host, vendorEmail, vendorId, kind, prev) {
    var coll = kind === 'requests' ? 'requests' : 'quotes';
    var param = kind === 'requests' ? 'leva_req' : 'leva_quote';
    rqStyle();
    var form = document.createElement('div');
    form.className = 'rq-form';

    function field(labelText, tag) {
      var l = document.createElement('label');
      l.textContent = labelText;
      var i = document.createElement(tag || 'input');
      if (tag === 'textarea') i.rows = 2;
      l.appendChild(i);
      form.appendChild(l);
      return i;
    }

    /* A name before an address: a vendor answering an enquiry wants to
       know who is asking, and an email alone does not say. Prefilled from
       the profile when there is one, and required either way. */
    /* REOPENING A LIVE REQUEST SHOWS WHAT WAS SENT. The form used to come
       up blank every time, so anyone coming back to change one line had to
       type the address, the phone and the description again from memory --
       and whatever they half-remembered was what got saved over the top.
       Changing the vendor address still starts a new request; the details
       simply travel with it. */
    var was = prev || {};
    var myName = field((T.rq && T.rq.myName) || 'Name');
    myName.type = 'text';
    myName.value = was.fromName || rqMeVal('name');
    myName.addEventListener('change', function () { rqMeSet('name', myName.value); });

    // mine first, then where it goes: no room to mix the two up
    var myMail = field(T.rq.myEmail);
    myMail.type = 'email';
    myMail.value = was.fromEmail || window.customerEmail || '';

    var phone = field(T.rq.myPhone);
    phone.type = 'tel';
    phone.value = was.phone || rqMeVal('phone');
    phone.addEventListener('change', function () { rqMeSet('phone', phone.value); });

    var place = field(T.rq.place);
    place.value = was.place || rqMeVal('place');
    place.addEventListener('change', function () { rqMeSet('place', place.value); });
    attachPlaceSuggest(place);

    var mail = field(T.rq.sendTo);
    mail.type = 'text';
    mail.placeholder = 'name@company.com, second@company.com';
    if (was.vendorEmails && was.vendorEmails.length) mail.value = was.vendorEmails.join(', ');
    else if (was.vendorEmail) mail.value = was.vendorEmail;
    else if (vendorEmail) mail.value = vendorEmail;
    var hint = document.createElement('div');
    hint.className = 'rq-msg';
    hint.textContent = T.rq.sendToHint;
    form.appendChild(hint);

    var note = field(T.rq.note, 'textarea');
    /* A note handed in from outside wins over the one carried over from the
       last request, and is spent the moment it is used -- reopening the form
       later must not resurrect it. */
    var handed = '';
    try {
      handed = String(window.__levaQuoteNote || '');
      window.__levaQuoteNote = '';
    } catch (e) { handed = ''; }
    note.value = handed || was.note || '';

    var msg = document.createElement('div');
    msg.className = 'rq-msg';

    var send = document.createElement('button');
    send.type = 'button';
    send.className = 'rq-send';
    send.textContent = was.answeredAt
      ? ((T.rq && T.rq.sendActual) || 'Send actualisation')
      : T.rq.send;
    send.addEventListener('click', function () {
      var list = mail.value.split(/[,;\s]+/);
      var to = [];
      for (var i = 0; i < list.length; i++) {
        var one = list[i].trim();
        if (one && one.indexOf('@') > 0) to.push(one.toLowerCase());
      }
      var p = phone.value.trim();
      var pl = place.value.trim();
      var nm = myName.value.trim();
      if (!nm) { msg.textContent = (T.rq && T.rq.needName) || 'Please add your name.'; return; }
      if (!to.length) { msg.textContent = T.rq.needEmail; return; }
      if (!p) { msg.textContent = T.rq.needPhone; return; }
      if (!pl) { msg.textContent = T.rq.needPlace; return; }
      if (!window.db) return;

      /* One request per address. Asking the same vendor again refreshes
         the request that is already there, so a single link keeps
         working and always shows the state as it stands now. */
      var id = (coll === 'quotes' && existingQuoteId(to[0])) || quoteId();
      var url = projectUrl(id, param);
      var payload = {
        status: 'pending',
        createdAt: new Date(),
        fromCustomerId: window.customerId ? String(window.customerId) : '',
        fromName: nm,
        fromEmail: myMail.value.trim() || window.customerEmail || '',
        vendorEmail: to[0],
        vendorEmails: to,
        vendorId: String(vendorId || ''),
        phone: p,
        place: pl,
        note: note.value.trim(),
        projectUrl: url,
        budgetToken: (function () {
          var f = form.querySelector('[data-rq-token]');
          return f ? String(f.getAttribute('data-rq-token') || '') : '';
        })(),
        productHandle: (window.shareProductContext && window.shareProductContext.handle) || '',
        // the model the sender is looking at, so the vendor can load it
        configId: (function () {
          try { return new URL(window.location.href).searchParams.get('cfg') || ''; }
          catch (e) { return ''; }
        })(),
        variantId: (window.currentVariantId ? String(window.currentVariantId) : '')
      };
      window.db.collection(coll).doc(id).set(payload, { merge: true }).then(function () {
        msg.textContent = T.rq.sent;
        sendRequestMail(to.join(','), url, payload, kind);
      }).catch(function (e) {
        console.error('request save failed', e);
      });
    });

    form.appendChild(send);
    form.appendChild(msg);
    termsLine(form, (T.rq && T.rq.termsSend) || 'By sending this request you agree to our');
    host.innerHTML = '';
    host.appendChild(form);
  }

  /* A quote is an answer about one model, so the row can lead back to it.
     The drawers close and, when the record points at another project, the
     page follows -- with the quote parameter stripped, or the sheet would
     simply open again on arrival. */
  function modelUrl(id, q) {
    var raw = (q && q.projectUrl) || projectUrl(id, 'leva_quote');
    try {
      var u = new URL(raw, window.location.href);
      u.searchParams.delete('leva_quote');
      u.searchParams.delete('leva_req');
      u.searchParams.delete('leva_offer');
      return u.toString();
    } catch (e) { return raw; }
  }

  function showModel(id, q) {
    closeVendor();
    closeQuotes();
    close();
    closeShareDrawer();
    closeBudget();
    document.body.classList.remove('open-cc');

    var target = modelUrl(id, q);
    try {
      var here = new URL(window.location.href);
      var there = new URL(target);
      if (here.pathname === there.pathname
        && String(here.searchParams.get('cfg') || '') === String(there.searchParams.get('cfg') || '')) {
        return;
      }
    } catch (e) {}
    window.location.href = target;
  }

  var lastDelete = 'not used yet';

  function dropQuote(id, slot, btn) {
    lastDelete = 'bin tapped on ' + (id || '-');
    if (slot && slot.parentNode) slot.parentNode.removeChild(slot);

    if (!id || !window.db) {
      lastDelete = 'no id or no db, the row went but nothing was deleted';
      return;
    }

    window.db.collection('quotes').doc(String(id)).delete()
      .then(function () { lastDelete = 'deleted ' + id; })
      .catch(function (e) {
        lastDelete = 'failed ' + id + ': ' + (e && e.code ? e.code + ' ' : '')
          + (e && e.message ? e.message : String(e));
        console.error('delete failed', e);
        var host = document.querySelector('#Leva-Quotes-Drawer .side-panel-content--inner');
        if (host) {
          var warn = document.createElement('div');
          warn.className = 'rq-msg';
          warn.style.color = '#D8232A';
          warn.textContent = lastDelete;
          host.insertBefore(warn, host.firstChild);
        }
      });
  }

  window.__levaLastDelete = function () { return lastDelete; };

  function bannerPill(label, extra, onClick) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'rq-bn__pill' + (extra ? ' ' + extra : '');
    b.textContent = label;
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      onClick(b);
    });
    return b;
  }

  /* What the vendor promised, as one number. The totals travel with the
     offer from prof-v183 on; older ones simply have nothing to show. */
  function offerMoney(q) {
    var vt = q && q.vendorTotals;
    if (!vt || vt.material == null || vt.execution == null) return '';
    var n = Math.round(Number(vt.material) + Number(vt.execution));
    if (!isFinite(n) || n <= 0) return '';
    try { return window.formatPrice ? window.formatPrice(n) : n.toLocaleString(); }
    catch (e) { return n.toLocaleString(); }
  }

  /* THE STRING SAYS A DATE, so a date is what goes in it. Feeding it the
     number of days left produced "valid until 30", which reads as a day of
     some unnamed month. The locale renders the day and the month; the
     colour, not the wording, says how urgent it is. */
  function untilText(q) {
    var u = q && q.validUntil;
    if (!u) return null;
    var when;
    try { when = u.toDate ? u.toDate() : new Date(u); } catch (e) { return null; }
    if (!when || isNaN(when.getTime())) return null;

    var days = Math.ceil((when.getTime() - Date.now()) / 86400000);
    var shown;
    try {
      shown = when.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
    } catch (e) {
      shown = when.getDate() + '.' + (when.getMonth() + 1) + '.';
    }

    var raw = (T.rq && T.rq.validUntil) || 'valid until {{ date }}';
    var label = raw.indexOf('{{ date }}') >= 0
      ? raw.split('{{ date }}').join(shown)
      : (raw.indexOf('%d') >= 0 ? raw.split('%d').join(shown) : (raw + ' ' + shown));

    return { text: (days < 0) ? ((T.rq && T.rq.qExpired) || 'expired') : label, days: days };
  }

  /* A Nominatim address is six levels of nesting and the card has one
     line. The street and the town are what tell a person where this is;
     the district, the region and the country do not, and pushed the date
     off the row. */
  function shortPlace(place) {
    var s = String(place || '').trim();
    if (!s) return '';
    var bits = s.split(',');
    var out = bits.slice(0, 2).join(',').trim();
    if (out.length > 34) out = out.slice(0, 33).replace(/[\s,]+$/, '') + '...';
    return out;
  }

  /* One banner, four states. Faded until something happened, full
     colour once it did. Clicking it opens the same questionnaire the
     request is sent with. */
  function stateBanner(state, title, sub, onClick, onOpen, mid, money, until) {
    var b = document.createElement('div');
    b.className = 'rq-bn rq-bn--' + state;

    var dot = document.createElement('span');
    dot.className = 'rq-bn__dot';
    b.appendChild(dot);

    var txt = document.createElement('div');
    txt.className = 'rq-bn__txt';
    if (title) {
      var t = document.createElement('div');
      t.className = 'rq-bn__t';
      t.textContent = title;
      txt.appendChild(t);
    }
    /* Three lines, three jobs: who in caps, how to reach them in plain
       type, and where -- one line each, because a card is read at a
       glance and a wrapped address pushed the date out of sight. */
    if (mid) {
      var m = document.createElement('div');
      m.className = 'rq-bn__m';
      m.textContent = mid;
      txt.appendChild(m);
    }
    if (sub) {
      var s = document.createElement('div');
      s.className = 'rq-bn__s';
      s.textContent = sub;
      txt.appendChild(s);
    }

    /* The number is the reason the list is open at all, and it was the one
       thing the card did not say -- three offers meant opening three. The
       date under it decides which one to answer first. */
    if (money) {
      var mo = document.createElement('div');
      mo.className = 'rq-bn__money';
      mo.textContent = money;
      txt.appendChild(mo);
    }
    if (until) {
      var un = document.createElement('div');
      un.className = 'rq-bn__until';
      un.textContent = until;
      txt.appendChild(un);
    }
    b.appendChild(txt);

    var st = document.createElement('span');
    st.className = 'rq-bn__st';
    st.textContent = state === 'none' ? T.rq.stNone
      : state === 'pending' ? T.rq.stPending
      : state === 'approved' ? T.rq.stApproved : T.rq.stDeclined;
    b.appendChild(st);

    if (onClick) {
      b.classList.add('is-click');
      b.addEventListener('click', onClick);
    }

    /* An approved request means the prices are there to be read, so the
       banner carries the download icon: it opens the budget in the same
       drawer a shared one uses, with implement at every level. */
    if (state === 'approved' && onOpen) {
      var ic = impIcon('vdr-imp-icon--item rq-bn__open', T.impAll, onOpen);
      b.appendChild(ic);
    }

    return b;
  }

  /* The requests this customer has sent for this product, with whatever
     answer has come back. An answered one carries the prices, so its
     banner opens them in the drawer a shared budget uses. */
  function stateOf(q) {
    var s = String(q.status || 'pending');
    if (s === 'answered' || s === 'approved') return 'approved';
    if (s === 'declined') return 'declined';
    return 'pending';
  }

  // an offer past its date is still an offer; the prices stay readable
  function isExpired(q) {
    try {
      var u = q.validUntil;
      var when = u && u.toDate ? u.toDate() : (u ? new Date(u) : null);
      return !!when && when.getTime() < Date.now();
    } catch (e) { return false; }
  }

  function whenText(q) {
    var d = q.answeredAt || q.decidedAt || q.createdAt;
    try {
      var when = d && d.toDate ? d.toDate() : (d ? new Date(d) : null);
      if (!when) return '';
      var days = Math.floor((Date.now() - when.getTime()) / 86400000);
      if (days <= 0) return 'today';
      if (days === 1) return '1 day ago';
      return days + ' days ago';
    } catch (e) { return ''; }
  }

  /* ---------------------------------------------------------------------
     VLAKNO U NABIDKY.

     Zpravy visi u nabidky, ne u cloveka. Kdyz ma dodavatel tri nabidky na
     tri stavby, jsou to tri rozhovory - jeden dlouhy by se za pul roku
     nedal cist a nikdo by nevedel, ktere polozky se tyka.

     Kdo smi cist, uz je dane nabidkou samotnou: fromEmail a vendorEmails.
     Proto je vlakno podkolekce a ne samostatny zaznam s vlastnim seznamem
     ucastniku, ktery by se casem rozesel.

     Vlakno vznika az prvni zpravou. Ikona je ale na kazde nabidce, jen bez
     odznaku - jinak by clovek hledal, kde se pise.
     --------------------------------------------------------------------- */
  var MSG_LIMIT = 200;
  var SCRAPE_URL = 'https://leva-scrape.long-cloud-d006.workers.dev';
  var MSG_UPLOAD_MAX = 8 * 1024 * 1024;

  /* Priloha ve zprave je odkaz na uz nahrany soubor, ne jeho kopie. Fotka
     ze stavby tedy zustava u projektu a do vlakna se jen posle - a kdyz ji
     nekdo smaze, zmizi na obou mistech, coz je spravne. */
  function projectHandleFromUrl() {
    try {
      var m = String(location.search || '').match(/[?&]p=([A-Za-z0-9_-]+)/);
      return m ? m[1] : '';
    } catch (e) { return ''; }
  }

  var MSG_TYPES = {
    pdf: 'application/pdf',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    xls: 'application/vnd.ms-excel', csv: 'text/csv',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    doc: 'application/msword', txt: 'text/plain',
    jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png',
    webp: 'image/webp', heic: 'image/heic'
  };

  function msgFileType(file) {
    var t = String(file.type || '').toLowerCase();
    if (t.indexOf('image/') === 0 || t === 'application/pdf') return t;
    var m = String(file.name || '').toLowerCase().match(/\.([a-z0-9]+)$/);
    return (m && MSG_TYPES[m[1]]) || t || '';
  }

  /* Obrazek se zmensi jeste tady - telefon foti ctyri tisice pixelu a do
     zpravy staci zlomek. */
  function msgShrink(file, cb) {
    var type = msgFileType(file);
    if (type.indexOf('image/') !== 0) { cb(file, type); return; }
    var img = new Image();
    var url = URL.createObjectURL(file);
    img.onload = function () {
      var w = img.naturalWidth, h = img.naturalHeight;
      var scale = Math.min(1, 1568 / Math.max(w, h));
      if (scale >= 1 && file.size <= 900000) { URL.revokeObjectURL(url); cb(file, type); return; }
      var c = document.createElement('canvas');
      c.width = Math.round(w * scale);
      c.height = Math.round(h * scale);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      c.toBlob(function (b) {
        URL.revokeObjectURL(url);
        cb(b || file, b ? 'image/jpeg' : type);
      }, 'image/jpeg', 0.85);
    };
    img.onerror = function () { URL.revokeObjectURL(url); cb(file, type); };
    img.src = url;
  }

  function msgUpload(file, offerId, cb) {
    var type = msgFileType(file);
    if (!type) { cb(null); return; }
    msgShrink(file, function (blob, sendType) {
      if (blob.size > MSG_UPLOAD_MAX) { cb(null); return; }
      var q = '?project=' + encodeURIComponent(projectHandleFromUrl() || ('offer-' + offerId))
            + '&identity=' + encodeURIComponent(myMail())
            + '&name=' + encodeURIComponent(String(file.name || '').slice(0, 120));
      fetch(SCRAPE_URL + '/attach/upload' + q, {
        method: 'POST', headers: { 'Content-Type': sendType }, body: blob
      }).then(function (r) { return r.json(); })
        .then(function (d) { cb(d && d.ok ? d.attachment : null); })
        .catch(function () { cb(null); });
    });
  }

  function msgsRef(offerId) {
    if (!window.db || !offerId) return null;
    return window.db.collection('offers').doc(offerId).collection('messages');
  }

  function msgTime(m) {
    if (m && m.at && m.at.seconds) return m.at.seconds * 1000;
    return Number(m && m.ms) || 0;
  }

  /* Posledni cteni si drzi kazdy ucastnik zvlast, primo na nabidce - jinak
     by se muselo cist cele vlakno jen kvuli tomu, aby se spocital odznak. */
  function readKey(mail) {
    return String(mail || '').toLowerCase().replace(/[^a-z0-9]/g, '_');
  }

  function markRead(offerId) {
    if (!window.db || !offerId) return;
    var me = myMail();
    if (!me) return;
    var patch = {};
    patch['readBy.' + readKey(me)] = Date.now();
    window.db.collection('offers').doc(offerId).update(patch).catch(function () {});
  }

  function unreadCount(q, msgs) {
    var me = myMail();
    if (!me) return 0;
    var since = (q.readBy && q.readBy[readKey(me)]) || 0;
    var n = 0;
    for (var i = 0; i < msgs.length; i++) {
      if (String(msgs[i].from || '').toLowerCase() === me) continue;
      if (msgTime(msgs[i]) > since) n++;
    }
    return n;
  }

  function loadMsgs(offerId, cb) {
    var ref = msgsRef(offerId);
    if (!ref) { cb([]); return; }
    ref.orderBy('ms').limit(MSG_LIMIT).get().then(function (snap) {
      var out = [];
      snap.forEach(function (d) {
        var m = d.data() || {};
        m.id = d.id;
        out.push(m);
      });
      cb(out);
    }).catch(function () { cb([]); });
  }

  function sendMsg(offerId, text, att, cb) {
    var ref = msgsRef(offerId);
    var me = myMail();
    if (!ref || !me || (!text && !att)) { cb(false); return; }
    ref.add({
      from: me,
      text: String(text || '').slice(0, 4000),
      att: att ? {
        id: String(att.id || ''),
        title: String(att.title || '').slice(0, 120),
        imageUrl: String(att.imageUrl || ''),
        storageUrl: String(att.storageUrl || ''),
        size: Number(att.size) || 0
      } : null,
      /* Vlastni cislo vedle serveroveho casu: razeni musi fungovat i v
         okamziku, kdy server jeste svuj cas nedoplnil. */
      ms: Date.now(),
      at: new Date()
    }).then(function () {
      markRead(offerId);
      cb(true);
    }).catch(function () { cb(false); });
  }

  /* Panel se rozbaluje na miste, stejne jako formular nabidky - je to
     vzorec, ktery uz lidi znaji. */
  function chatPanel(slot, offerId, q) {
    var open = slot.querySelector('.rq-chat');
    if (open) { slot.removeChild(open); return; }

    var box = document.createElement('div');
    box.className = 'rq-chat';
    var list = document.createElement('div');
    list.className = 'rq-chat__list';
    box.appendChild(list);

    var wait = document.createElement('div');
    wait.className = 'rq-chat__empty';
    wait.textContent = (T.rq && T.rq.chatLoading) || 'Loading...';
    list.appendChild(wait);

    var rowBox = document.createElement('div');
    rowBox.className = 'rq-chat__row';
    var input = document.createElement('input');
    input.type = 'text';
    input.className = 'rq-chat__in';
    input.placeholder = (T.rq && T.rq.chatPlaceholder) || 'Write a message';
    var clip = document.createElement('button');
    clip.type = 'button';
    clip.className = 'rq-chat__clip';
    clip.title = (T.rq && T.rq.chatAttach) || 'Attach';
    clip.textContent = '+';
    var fileIn = document.createElement('input');
    fileIn.type = 'file';
    fileIn.style.display = 'none';
    fileIn.accept = 'image/*,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv,application/msword,text/plain';
    var send = document.createElement('button');
    send.type = 'button';
    send.className = 'rq-chat__send';
    send.textContent = (T.rq && T.rq.chatSend) || 'Send';
    rowBox.appendChild(clip);
    rowBox.appendChild(fileIn);
    rowBox.appendChild(input);
    rowBox.appendChild(send);
    box.appendChild(rowBox);
    slot.appendChild(box);
    box.scrollIntoView({ block: 'nearest' });

    function paint(msgs) {
      list.innerHTML = '';
      if (!msgs.length) {
        var e = document.createElement('div');
        e.className = 'rq-chat__empty';
        e.textContent = (T.rq && T.rq.chatEmpty) || 'No messages yet.';
        list.appendChild(e);
        return;
      }
      var me = myMail();
      for (var i = 0; i < msgs.length; i++) {
        var m = msgs[i];
        var mine = String(m.from || '').toLowerCase() === me;
        var b = document.createElement('div');
        b.className = 'rq-chat__msg' + (mine ? ' rq-chat__msg--me' : '');
        if (m.att && m.att.imageUrl) {
          var im = document.createElement('img');
          im.className = 'rq-chat__img';
          im.src = m.att.imageUrl;
          im.alt = '';
          b.appendChild(im);
        } else if (m.att && m.att.storageUrl) {
          var fa = document.createElement('a');
          fa.className = 'rq-chat__file';
          fa.href = m.att.storageUrl;
          fa.target = '_blank';
          fa.rel = 'noopener';
          fa.textContent = m.att.title || 'file';
          b.appendChild(fa);
        }
        if (m.text) {
          var tx = document.createElement('span');
          tx.textContent = String(m.text);
          b.appendChild(tx);
        }
        list.appendChild(b);
      }
      list.scrollTop = list.scrollHeight;
    }

    loadMsgs(offerId, function (msgs) {
      paint(msgs);
      markRead(offerId);
      var badge = slot.querySelector('.rq-chat__badge');
      if (badge && badge.parentNode) badge.parentNode.removeChild(badge);
    });

    function submit() {
      var v = String(input.value || '').trim();
      if (!v) return;
      input.value = '';
      send.disabled = true;
      sendMsg(offerId, v, null, function (ok) {
        send.disabled = false;
        if (!ok) { input.value = v; return; }
        loadMsgs(offerId, paint);
      });
    }
    send.addEventListener('click', submit);

    clip.addEventListener('click', function () { fileIn.click(); });
    fileIn.addEventListener('change', function () {
      var f = fileIn.files && fileIn.files[0];
      fileIn.value = '';
      if (!f) return;
      clip.disabled = true;
      clip.textContent = '..';
      msgUpload(f, offerId, function (att) {
        clip.disabled = false;
        clip.textContent = '+';
        if (!att) return;
        sendMsg(offerId, String(input.value || '').trim(), att, function (ok) {
          if (!ok) return;
          input.value = '';
          loadMsgs(offerId, paint);
        });
      });
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); submit(); }
    });
  }

  /* Ikona na banner. Odznak se dopocita az kdyz vlakno neco ma - u prazdne
     nabidky by cislo nula jen prekazelo. */
  /* URGENCE JDE MAILEM, NE PRES LEVA.

     Dodavatel, ktery se tyden neozval, uz vlakno neotevre - upozorneni v
     aplikaci by cekalo tam, kam se nediva. Mail otevre v tom, co ma
     nastavene, s vyplnenym adresatem i textem, a staci odeslat.

     Odkaz na projekt je v tele zpravy, aby se nemusel nikam prihlasovat. */
  function urgeLink(q) {
    var to = String(q.vendorEmail || (q.vendorEmails && q.vendorEmails[0]) || q.fromEmail || '');
    var who = String(q.fromName || q.vendorName || '').trim();
    var place = shortPlace(q.place) || '';
    var link = '';
    try { link = location.origin + location.pathname + location.search; } catch (e) {}
    var subj = (T.rq && T.rq.urgeSubject) || 'Following up on my request';
    var body = ((T.rq && T.rq.urgeBody) || 'Hello[NAME],\n\nI sent you a request for a quote[PLACE] and have not heard back. Could you let me know if you are able to price it?\n\nThe project is here:\n[LINK]\n\nThank you.')
      .split('[NAME]').join(who ? (' ' + who) : '')
      .split('[PLACE]').join(place ? (' for ' + place) : '')
      .split('[LINK]').join(link);
    return 'mailto:' + encodeURIComponent(to)
      + '?subject=' + encodeURIComponent(subj)
      + '&body=' + encodeURIComponent(body);
  }

  function urgeIcon(bn, q) {
    var b = rowIcon('urge', (T.rq && T.rq.urgeTitle) || 'Send a reminder', function (ev) {
      if (ev && ev.stopPropagation) ev.stopPropagation();
      try { window.location.href = urgeLink(q); } catch (e) {}
    });
    b.classList.add('rq-bn__act', 'rq-bn__act--4');
    bn.appendChild(b);
    return b;
  }

  function chatIcon(bn, slot, offerId, q) {
    var b = rowIcon('chat', (T.rq && T.rq.chatTitle) || 'Messages', function (ev) {
      if (ev && ev.stopPropagation) ev.stopPropagation();
      chatPanel(slot, offerId, q);
    });
    b.classList.add('rq-bn__act', 'rq-bn__act--3');
    bn.appendChild(b);

    loadMsgs(offerId, function (msgs) {
      var n = unreadCount(q, msgs);
      if (!n) return;
      var dot = document.createElement('span');
      dot.className = 'rq-chat__badge';
      dot.textContent = n > 9 ? '9+' : String(n);
      b.appendChild(dot);
    });
    return b;
  }

  /* CO Z TOHO VIDI AGENT.

     Jen vlakna sveho uzivatele a jen to, co vidi on sam - kdyz nekdo nevidi
     cizi ceny, nesmi je videt ani jeho agent. Vraci se souhrn, ne cele
     zpravy: agent ma odpovedet na "kde chybi cena", ne prepisovat
     konverzaci. */
  /* URGENCE JDE MAILEM A ZAROVEN DO VLAKNA.

     Mail dojde tam, kam se dodavatel diva dnes. Zprava ve vlakne pocka na
     den, kdy si zalozi ucet - a pak najde celou historii, ne prazdny chat.
     Jedno klepnuti proto dela obe veci, ne jednu z nich. */
  function reminderText(q) {
    var place = shortPlace(q.place) || '';
    return ((T.rq && T.rq.urgeBody) || 'Hello[NAME],\n\nI sent you a request for a quote[PLACE] and have not heard back. Could you let me know if you are able to price it?\n\nThank you.')
      .split('[NAME]').join('')
      .split('[PLACE]').join(place ? (' for ' + place) : '')
      .split('[LINK]').join('')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }

  /* WHAT AN ANSWER PROMISES, IN FIGURES (prof-v281, 2026-10-27).

     The assistant compares the offers on a project (Marek: the offers card
     from the reel, "ktere pak AI asistent umi vyhodnotit"). It gets what the
     reader of the quote already sees: the vendor's own totals -- the same
     sum offerMoney shows -- the subcategories the answer covers and the
     items it put a price on. Only for the reader's own requests, only once
     answered; older answers without totals give nothing. */
  function offerFigures(q) {
    if (!q || !q.answeredAt) return null;
    var vt = q.vendorTotals || null;
    if (!vt || vt.material == null || vt.execution == null) return null;
    var mat = Number(vt.material), exe = Number(vt.execution);
    if (!isFinite(mat) || !isFinite(exe) || mat + exe <= 0) return null;
    var ids = [];
    var m = q.materials || {};
    for (var k in m) {
      if (!Object.prototype.hasOwnProperty.call(m, k)) continue;
      if (String(k).indexOf('_') !== -1) continue;
      if (m[k] === '' || m[k] == null) continue;
      ids.push(String(k));
    }
    return {
      material: mat,
      execution: exe,
      hours: (vt.time != null && isFinite(Number(vt.time))) ? Number(vt.time) : null,
      subs: (q.subcategories || []).slice(0, 80).map(String),
      ids: ids.slice(0, 800),
      name: String(q.vendorName || q.vendorEmail || '')
    };
  }

  /* bic-v187: the answers to my requests sent to several suppliers, each
     its own offers record (writeGroupAnswer), as rows of LevaThreads.list */
  function groupAnswers(cb) {
    var me = myMail();
    if (!window.db || !me) { cb([]); return; }
    qOne('offers', 'toEmails', 'array-contains', me).then(function (rows) {
      var out = [];
      rows.forEach(function (row) {
        var q = row.q || {};
        if (!q.requestId || q.status === 'discarded') return;
        if (typeof forThisProduct === 'function' && !forThisProduct(q)) return;
        var at = toMillis(q.answeredAt || q.createdAt);
        out.push({
          offerId: row.id,
          withWhom: q.fromName || q.fromEmail || '',
          direction: 'sent',
          place: '',
          state: 'answered',
          messages: 0,
          unread: 0,
          createdAt: at,
          lastAt: at,
          lastFromMe: false,
          lastText: '',
          attachments: 0,
          hasPrice: true,
          subject: '',
          opened: true,
          urgeUrl: '',
          group: String(q.requestId),
          offer: offerFigures({ answeredAt: q.answeredAt || q.createdAt || 1, vendorTotals: q.vendorTotals, materials: q.materials,
                                subcategories: q.subcategories, vendorName: q.fromName, vendorEmail: q.fromEmail })
        });
      });
      cb(out);
    }).catch(function () { cb([]); });
  }

  window.LevaThreads = {
    /* Vrati adresu mailu a zaroven ulozi tutez zpravu do vlakna. Volajici
       ji jen otevre - poradi je zamerne: kdyby zapis selhal, mail se stejne
       otevre a clovek neni bez moznosti. */
    /* Zapis zpravy, jejiz text sklada nekdo jiny. Drawer zna jazyk
       rozhovoru, tenhle soubor ne - takze text prijde odtamtud a tady se
       jen ulozi. */
    note: function (offerId, text, cb) {
      if (!offerId || !text) { if (cb) cb(false); return; }
      sendMsg(offerId, String(text).slice(0, 4000), null, function (ok) {
        if (cb) cb(ok);
      });
    },

    remind: function (offerId, cb) {
      if (!window.db || !offerId) { cb(''); return; }
      window.db.collection('offers').doc(offerId).get().then(function (doc) {
        var q = (doc && doc.exists) ? (doc.data() || {}) : null;
        if (!q) { cb(''); return; }
        var url = urgeLink(q);
        sendMsg(offerId, reminderText(q), null, function () {});
        cb(url);
      }).catch(function () { cb(''); });
    },
    list: function (cb0) {
      if (!window.db || !myMail()) { cb0([]); return; }
      /* bic-v187: the requests' rows, then the answers kept apart (groupAnswers) */
      var cb = function (rows) {
        groupAnswers(function (extra) {
          var all2 = (rows || []).concat(extra || []);
          all2.sort(function (a, b) { return b.lastAt - a.lastAt; });
          cb0(all2);
        });
      };
      /* VSECHNY POPTAVKY A NABIDKY, NE JEN TY SE ZPRAVAMI.

         Prvni verze vracela jen vlakna, ve kterych uz nekdo neco napsal -
         takze poptavka odeslana pred tydnem, na kterou nikdo neodpovedel,
         v seznamu vubec nebyla. A prave na tu se clovek pta. */
      loadQuotes(function (all) {
        var out = [];
        var left = all.length;
        if (!left) { cb([]); return; }
        var me = myMail();
        /* JEN TENHLE PROJEKT. Poptavky na jinou stavbu do souhrnu nepatri -
           agent odpovida na projekt, ktery ma clovek otevreny, a michat do
           toho cizi nabidky by ho zmatlo stejne jako jeho. */
        var mine = [];
        for (var f = 0; f < all.length; f++) {
          if (all[f].q.status === 'discarded') continue;
          if (typeof forThisProduct === 'function' && !forThisProduct(all[f].q)) continue;
          mine.push(all[f]);
        }
        all = mine;
        left = all.length;
        if (!left) { cb([]); return; }
        for (var i = 0; i < all.length; i++) {
          (function (row) {
            var q = row.q;
            loadMsgs(row.id, function (msgs) {
              var last = msgs.length ? msgs[msgs.length - 1] : null;
              var created = (q.createdAt && q.createdAt.seconds) ? q.createdAt.seconds * 1000 : 0;
              out.push({
                offerId: row.id,
                /* Kdo je ten druhy - u odeslane poptavky dodavatel, u
                   prijate nabidky ten, kdo ji poslal. */
                withWhom: (isMine(q) ? ((q.vendorEmails && q.vendorEmails.length > 1) ? q.vendorEmails.join(', ') : (q.vendorName || q.vendorEmail)) : (q.fromName || q.fromEmail)) || '',
                direction: isMine(q) ? 'sent' : 'received',
                place: shortPlace(q.place) || '',
                state: stateOf(q) || '',
                messages: msgs.length,
                unread: unreadCount(q, msgs),
                createdAt: created,
                lastAt: last ? msgTime(last) : created,
                lastFromMe: last ? (String(last.from || '').toLowerCase() === me) : true,
                lastText: last ? String(last.text || '').slice(0, 160) : '',
                attachments: msgs.filter(function (m) { return !!m.att; }).length,
                hasPrice: !!q.answeredAt,
                /* Predmet puvodni poptavky, aby na nej pripominka mohla
                   navazat misto zakladani noveho vlakna v poste. */
                subject: (function(){
                  var base = (T.rq && T.rq.quoteSubject) || '';
                  var nm = '';
                  try { nm = projectName() || ''; } catch (e) {}
                  return base + (nm ? (': ' + nm) : '');
                })(),
                opened: !!q.openedAt,
                urgeUrl: q.answeredAt ? '' : urgeLink(q),
                offer: isMine(q) ? offerFigures(q) : null
              });
              if (--left <= 0) {
                out.sort(function (a, b) { return b.lastAt - a.lastAt; });
                cb(out);
              }
            });
          })(all[i]);
        }
      });
    }
  };

  function rowIcon(kind, title, onClick) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'rq-act rq-act--' + kind;
    b.title = title;
    b.setAttribute('aria-label', title);
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '13');
    svg.setAttribute('height', '13');
    svg.setAttribute('fill', 'none');
    var paths = kind === 'link'
      ? ['M10 13a5 5 0 0 0 7.1 0l3-3a5 5 0 0 0-7.1-7.1L11.5 4.4',
         'M14 11a5 5 0 0 0-7.1 0l-3 3a5 5 0 0 0 7.1 7.1l1.4-1.4']
      : kind === 'cube'
      ? ['M12 2.6l8.4 4.7v9.4L12 21.4 3.6 16.7V7.3z',
         'M3.6 7.3L12 12l8.4-4.7', 'M12 12v9.4']
      : kind === 'ok'
      ? ['M4 12.5l5 5L20 6.5']
      : kind === 'chat'
      ? ['M21 11.5a8.4 8.4 0 0 1-9 8.4 8.9 8.9 0 0 1-4-.9L3 21l1.9-4.6A8.4 8.4 0 0 1 12 3a8.4 8.4 0 0 1 9 8.5z']
      : kind === 'urge'
      ? ['M3 6.5h18v11H3z', 'M3 7l9 6.5L21 7']
      : ['M4 7h16', 'M10 11v6M14 11v6',
         'M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12', 'M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2'];
    for (var i = 0; i < paths.length; i++) {
      var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      p.setAttribute('d', paths[i]);
      p.setAttribute('stroke', 'currentColor');
      p.setAttribute('stroke-width', '2');
      p.setAttribute('stroke-linecap', 'round');
      p.setAttribute('stroke-linejoin', 'round');
      svg.appendChild(p);
    }
    b.appendChild(svg);
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      onClick(b);
    });
    return b;
  }

  /* The link that was mailed can be handed over again, and a request
     that is no longer wanted can be dropped: once it is, the vendor's
     link leads nowhere. */
  function rowActions(id, q, slot) {
    var row = document.createElement('div');
    row.className = 'rq-acts';

    row.appendChild(rowIcon('bin', T.rq.discard, function (btn) {
      /* bic-v188: a shared request is not the supplier's to delete -- he leaves it */
      if (q && isGroupFor(q) && window.db && id) {
        var mk = groupKey(myMail()), nope = { declinedBy: {} };
        nope.declinedBy[mk] = new Date();
        if (slot && slot.parentNode) slot.parentNode.removeChild(slot);
        window.db.collection('quotes').doc(String(id)).set(nope, { merge: true }).catch(function () {});
        return;
      }
      dropQuote(id, slot, btn);
    }));

    return row;
  }

  function confirmYesNo(go) {
    var old = document.getElementById('vdr-confirm');
    if (old) old.parentNode.removeChild(old);
    var wrap = document.createElement('div');
    wrap.id = 'vdr-confirm';
    wrap.innerHTML = ''
      + '<div class="vdr-c__box">'
      + '  <div class="vdr-c__title">' + T.confirmTitle + '</div>'
      + '  <div class="vdr-c__col">'
      + '    <button type="button" class="vdr-c__btn" data-c-no>' + T.confirmCancel + '</button>'
      + '    <button type="button" class="vdr-c__btn vdr-c__btn--ok" data-c-ok>' + T.rq.yes + '</button>'
      + '  </div>'
      + '</div>';
    document.body.appendChild(wrap);
    function shut() { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }
    wrap.addEventListener('click', function (e) { if (e.target === wrap) shut(); });
    wrap.querySelector('[data-c-no]').addEventListener('click', shut);
    wrap.querySelector('[data-c-ok]').addEventListener('click', function () { shut(); go(); });
  }

  /* WHO ANSWERED, ON THE PAGE WHERE THE ANSWER IS. The vendor's side has
     always shown who was asking -- name, address, phone, description --
     while the asker's side showed nothing about the vendor at all: opening
     a priced quote gave back the form they had sent, as though nothing had
     come of it. The two sides now say the same kind of thing about each
     other. */
  function vendorDetail(q) {
    var name = q.vendorName || '';
    var mail = (q.vendorEmails && q.vendorEmails[0]) || q.vendorEmail || '';
    var phone = q.vendorPhone || '';
    var money = offerMoney(q);
    var ut = untilText(q);
    var subs = (q.subcategories && q.subcategories.length) ? q.subcategories.length : 0;
    if (!name && !mail && !phone && !money) return null;

    var box = document.createElement('div');
    box.className = 'rq-det rq-det--vendor';

    var head = document.createElement('div');
    head.className = 'rq-det__k rq-det__k--note';
    head.textContent = (T.rq && T.rq.whoAnswered) || 'Who answered';
    box.appendChild(head);

    var line = function (label, value, href) {
      if (!value) return;
      var row = document.createElement('div');
      row.className = 'rq-det__r';
      var k = document.createElement('span');
      k.className = 'rq-det__k';
      k.textContent = label;
      row.appendChild(k);
      var v = document.createElement(href ? 'a' : 'span');
      v.className = 'rq-det__v';
      if (href) v.href = href;
      v.textContent = value;
      row.appendChild(v);
      box.appendChild(row);
    };

    line((T.rq && T.rq.myName) || 'Name', name);
    line(T.rq.myEmail, mail, mail ? ('mailto:' + mail) : null);
    line(T.rq.myPhone, phone, phone ? ('tel:' + String(phone).replace(/\s+/g, '')) : null);
    line(T.rq.qValid || 'Valid', ut ? ut.text : '');

    /* The figure and what it covers belong together: a total for eight
       trades out of thirty-two is not a total for the build. */
    if (money) {
      var row2 = document.createElement('div');
      row2.className = 'rq-det__r';
      var k2 = document.createElement('span');
      k2.className = 'rq-det__k';
      k2.textContent = T.rq.quoteReceived || 'Quote';
      row2.appendChild(k2);
      var v2 = document.createElement('span');
      v2.className = 'rq-det__v rq-det__v--money';
      v2.textContent = money + (subs ? ('   ' + subs + ' x ' + ((T.rq && T.rq.execution) || 'Execution')) : '');
      row2.appendChild(v2);
      box.appendChild(row2);
    }

    return box;
  }

  function quoteRow(host, id, q) {
    var slot = document.createElement('div');
    slot.className = 'rq-slot';

    var state = stateOf(q);
    var mailLine = (q.vendorEmails && q.vendorEmails[0]) || q.vendorEmail || '';
    var title = q.vendorName || '';
    var sub = [shortPlace(q.place), whenText(q)].filter(Boolean).join('  |  ');

    var openBudget = null;
    if (state === 'approved') {
      openBudget = function () {
        /* The list was read when the drawer opened; the offer may have
           been answered again since. The record is fetched fresh so the
           numbers on screen are the ones that were last sent. */
        if (window.db) {
          window.db.collection('quotes').doc(String(id)).get().then(function (doc) {
            if (doc.exists) q = doc.data() || q;
            showOffer();
          }).catch(showOffer);
        } else {
          showOffer();
        }
      };

      var showOffer = function () {
        // the answer holds the vendor's own prices and times
        vd.data = {
          materials: q.materials || {},
          execution: q.execution || {},
          hourlyRatesByCategory: q.hourlyRatesByCategory || {},
          subcategories: q.subcategories || null,
          cfg: q.cfg || '',
          vendorTotals: q.vendorTotals || null
        };
        vd.token = id;
        vd.owner = String(q.vendorId || '');
        vd.name = title;
        if (vd.open) closeVendor();
        var d = prepVendor();
        if (!d) return;
        raise(d);
        d.style.zIndex = '100004';
        paintWho(d, null);
        d.querySelector('[data-vd-msg]').textContent = '';
        noteOtherModel(d, q);
        d.classList.add('active');
        document.body.classList.add('open-cc');
        showVendorBudget(vd.data);
      };
    }

    var expired = state === 'approved' && isExpired(q);
    var bn = stateBanner(state, title, sub, function () {
      var open = slot.querySelector('.rq-slot__form');
      if (open) { slot.removeChild(open); return; }

      /* Opening the card is the moment it has been read. The mark was
         being stored but nothing ever wrote it, so the count on the tab
         had no way of going down. */
      markRowSeen(id);
      var d = document.getElementById('Leva-Quotes-Drawer');
      if (d) paintTabCounts(d);
      paintBadges();

      /* AND THE OTHER SIDE DESERVES TO KNOW. A vendor who has sent a price
         and heard nothing cannot tell silence from a mail that never
         arrived. The read mark above is private to this reader, so a
         second one goes on the quote itself, where its author can see it. */
      if (q.answeredAt && !q.openedAt && window.db) {
        q.openedAt = new Date();
        window.db.collection('quotes').doc(String(id))
          .set({ openedAt: q.openedAt }, { merge: true }).catch(function () {});
      }

      var box = document.createElement('div');
      box.className = 'rq-slot__form';
      // the link and the bin belong to this request, so they appear with it
      buildRequestForm(box, title, '', null, q);
      // after the form: it clears its host, so icons added first vanished
      var who = q.answeredAt ? vendorDetail(q) : null;
      if (who) box.insertBefore(who, box.firstChild);
      box.insertBefore(rowActions(id, q, slot), box.firstChild);
      slot.appendChild(box);
      box.scrollIntoView({ block: 'nearest' });
    }, openBudget, mailLine,
      offerMoney(q), (untilText(q) || {}).text || '');

    var ut = untilText(q);
    var utEl = bn.querySelector('.rq-bn__until');
    if (ut && utEl) {
      if (ut.days < 0) utEl.classList.add('rq-bn__until--gone');
      else if (ut.days <= 7) utEl.classList.add('rq-bn__until--soon');
    }

    if (expired) {
      bn.classList.add('is-expired');
      var st = bn.querySelector('.rq-bn__st');
      if (st) st.textContent = T.rq.qExpired;
    } else if (q.actualisedAt) {
      var st2 = bn.querySelector('.rq-bn__st');
      if (st2) st2.textContent = T.rq.qActual;
    }
    slot.appendChild(bn);
    host.appendChild(slot);
  }

  // the four states side by side, so the meaning of each is plain
  /* A SAMPLE FIGURE IS STILL A FIGURE. Written as text it stayed in
     dollars after the reader switched to euros, so the one part of the
     drawer meant to teach the layout was the one part contradicting it.
     The samples hold a number and are formatted the way a real total is,
     which also means they follow the rate. */
  function sampleMoney(n) {
    if (!n) return '';
    try {
      if (typeof window.formatPrice === 'function') return window.formatPrice(n);
    } catch (e) {}
    return Math.round(n).toLocaleString();
  }

  /* The same panel a real answered card shows, filled with the sample. */
  function sampleWho(r) {
    var box = document.createElement('div');
    box.className = 'rq-det rq-det--vendor';

    var head = document.createElement('div');
    head.className = 'rq-det__k rq-det__k--note';
    head.textContent = (T.rq && T.rq.whoAnswered) || 'Who answered';
    box.appendChild(head);

    var line = function (label, value, cls) {
      if (!value) return;
      var row = document.createElement('div');
      row.className = 'rq-det__r';
      var k = document.createElement('span');
      k.className = 'rq-det__k';
      k.textContent = label;
      row.appendChild(k);
      var v = document.createElement('span');
      v.className = 'rq-det__v' + (cls ? (' ' + cls) : '');
      v.textContent = value;
      row.appendChild(v);
      box.appendChild(row);
    };

    line((T.rq && T.rq.myName) || 'Name', r[1]);
    line(T.rq.myEmail, r[2]);
    line(T.rq.myPhone, r[6] || '');
    line(T.rq.qValid || 'Valid', r[5] || '');
    line(T.rq.quoteReceived || 'Quote', r[4] || '', 'rq-det__v--money');
    return box;
  }

  /* ONE RULE FOR ALL THREE TABS. Samples were drawn always on one tab and
     only-when-empty on another, so the tab that most needed teaching -- a
     vendor's first job -- was the one that hid the examples the moment a
     single request arrived. They stay until the list can teach the shape
     by itself, which takes a few rows, not one. */
  var SAMPLE_UNTIL = 5;

  function wantSamples(n) {
    return (n || 0) < SAMPLE_UNTIL;
  }

  function sampleRows(host) {
    var wrap = document.createElement('div');
    wrap.className = 'rq-list';
    var h = document.createElement('div');
    h.className = 'rq-list__h';
    h.textContent = T.rq.sample;
    wrap.appendChild(h);

    /* A SAMPLE SHOULD LOOK LIKE THE REAL THING. These rows carried an
       address and a town, while a card that has actually been answered
       carries a name in caps, an email, a place, a figure and a date --
       so the sample taught a newcomer the wrong shape and made the real
       list look like a different feature. Invented vendors, invented
       money; the layout is the layout they will get. */
    var vd = function (d) { return T.rq.validUntil.split('%d').join(d); };
    var rows = [
      ['none', 'Reeve Timber Joinery', 'joinery@reevestimber.com',
        'Wicker Park, Chicago, IL', '', ''],
      ['pending', 'Thompson Woodwork', 'matt@thompsonwoodwork.com',
        'Logan Square, Chicago, IL  |  asked 2 days ago', '', '', '+1 312 555 0148'],
      ['approved', 'Nordic Frames', 'info@nordicframes.cz',
        'Kralovo Pole, Brno', sampleMoney(38640), vd('14 Sep'), '+420 777 210 480'],
      ['actual', 'Holzbau Studio', 'studio@holzbau.de',
        'Urfahr, Linz  |  updated today', sampleMoney(44180), vd('30 Sep'), '+43 664 128 9930'],
      // an offer whose date has passed: still readable, no longer binding
      ['expired', 'Alpine Build Werkstatt', 'workshop@alpinebuild.at',
        'Maxglan, Salzburg', sampleMoney(41025), vd('2 Aug'), '+43 662 884 1170'],
      ['declined', 'BuildCo Supply', 'sales@buildco.com',
        'Lakewood, CO  |  ' + T.rq.again, '', '', '+1 303 555 0192']
    ];
    for (var i = 0; i < rows.length; i++) {
      (function (r) {
        var slot = document.createElement('div');
        slot.className = 'rq-slot';
        // expired is an approved offer past its date, so it is drawn as one
        var look = (r[0] === 'expired' || r[0] === 'actual') ? 'approved' : r[0];
        var priced = (r[0] === 'approved' || r[0] === 'expired' || r[0] === 'actual');
        var fake = {
          vendorName: r[1], vendorEmail: r[2], vendorPhone: r[6] || '',
          answeredAt: priced ? { seconds: Math.round(Date.now() / 1000) } : null
        };

        var bnS = stateBanner(look, r[1], r[3], function () {
          var open = slot.querySelector('.rq-slot__form');
          if (open) { slot.removeChild(open); return; }
          var box = document.createElement('div');
          box.className = 'rq-slot__form';
          buildRequestForm(box, r[2], '');
          if (priced) {
            var who = sampleWho(r);
            if (who) box.insertBefore(who, box.firstChild);
          }
          box.insertBefore(rowActions('', { vendorEmail: r[2] }, slot), box.firstChild);
          slot.appendChild(box);
        }, priced ? function () {} : null, r[2], r[4] || '', r[5] || '');

        if (r[0] === 'actual') {
          var stA = bnS.querySelector('.rq-bn__st');
          if (stA) stA.textContent = T.rq.qActual;
        }
        if (r[0] === 'expired') {
          bnS.classList.add('is-expired');
          var stS = bnS.querySelector('.rq-bn__st');
          if (stS) stS.textContent = T.rq.qExpired;
        }
        slot.appendChild(bnS);
        wrap.appendChild(slot);
      })(rows[i]);
    }
    host.appendChild(wrap);
  }

  var quoteByEmail = {};

  function myMail() {
    return String(window.customerEmail || '').trim().toLowerCase();
  }

  /* Both lists come from one read and are split by address. Matching on
     the customer id alone put a request in the sender's list only, and
     an equality query on the vendor address returned nothing when the
     stored value differed by case or carried more than one recipient. */
  /* ============================================================
     ASK FOR WHAT IS YOURS, NOT FOR EVERYTHING
     Every list here used to pull a whole collection down and sift it in
     the browser. That works only while the rules are open to all, and it
     is the one thing standing between now and closing them: a rule can
     let a query through only when the query itself proves that every
     document it can return belongs to the person asking. An unfiltered
     read can prove nothing, so it gets refused outright.
     So each list is now the union of a few narrow queries -- mine, and
     the ones addressed to me -- which is also a great deal less traffic
     on a collection that only grows.
     ============================================================ */
  function qOne(coll, field, op, value) {
    if (!window.db) return Promise.resolve([]);
    return window.db.collection(coll).where(field, op, value).get()
      .then(function (snap) {
        var out = [];
        snap.forEach(function (doc) { out.push({ id: doc.id, q: doc.data() || {} }); });
        return out;
      })
      .catch(function (e) {
        console.error('query failed: ' + coll + ' ' + field, e);
        return [];
      });
  }

  function qUnion(parts, cb) {
    Promise.all(parts).then(function (lists) {
      var seen = {};
      var out = [];
      for (var i = 0; i < lists.length; i++) {
        for (var j = 0; j < lists[i].length; j++) {
          var row = lists[i][j];
          if (seen[row.id]) continue;
          seen[row.id] = true;
          out.push(row);
        }
      }
      cb(out);
    }).catch(function () { cb([]); });
  }

  /* bic-v188 A SHARED REQUEST (one link to several suppliers, bic-v187) is,
     for each supplier, his own: his answer sits in its own offers record,
     and that is what his side shows -- answered, with his figures; one who
     declined is marked on the request (declinedBy) and does not see it. */
  function groupKey(mail) { return String(mail || '').toLowerCase().replace(/[^a-z0-9]/g, '_').slice(0, 60); }
  function isGroupFor(q) { return !!(q && q.vendorEmails && q.vendorEmails.length > 1 && !isMine(q) && isForMe(q)); }
  function groupDeclined(q) { var k = groupKey(myMail()); return !!(q && q.declinedBy && k && q.declinedBy[k]); }
  var GROUP_KEEP = ['answeredAt', 'validUntil', 'coefficient', 'rateCoefficient', 'hourlyRatesByCategory',
                    'materials', 'execution', 'subcategories', 'vendorTotals', 'cfg'];
  function withMyAnswer(id, q, cb) {
    var me = myMail();
    if (!window.db || !me || !isGroupFor(q)) { cb(q); return; }
    window.db.collection('offers').doc('qa_' + String(id) + '_' + groupKey(me)).get().then(function (d) {
      if (!d || !d.exists) { cb(q); return; }
      var a = d.data() || {}, q2 = {};
      for (var k in q) if (Object.prototype.hasOwnProperty.call(q, k)) q2[k] = q[k];
      for (var i = 0; i < GROUP_KEEP.length; i++) if (a[GROUP_KEEP[i]] !== undefined) q2[GROUP_KEEP[i]] = a[GROUP_KEEP[i]];
      q2.status = 'answered';
      q2.vendorEmail = me;
      q2.vendorName = a.fromName || q2.vendorName || '';
      q2.groupAnswerId = d.id;
      cb(q2);
    }).catch(function () { cb(q); });
  }

  /* Quotes travel in both directions, so both directions are asked for. */
  function quotesForMe(cb) {
    var me = myMail();
    if (!me) { cb([]); return; }
    qUnion([
      qOne('quotes', 'fromEmail', '==', me),
      qOne('quotes', 'vendorEmail', '==', me),
      qOne('quotes', 'vendorEmails', 'array-contains', me)
    ], function (rows) {
      /* bic-v188: a shared request I declined is gone for me, one I answered is answered */
      rows = rows.filter(function (r) { return !(isGroupFor(r.q) && groupDeclined(r.q)); });
      var left = 0;
      for (var i = 0; i < rows.length; i++) if (isGroupFor(rows[i].q)) left++;
      if (!left) { cb(rows); return; }
      rows.forEach(function (r) {
        if (!isGroupFor(r.q)) return;
        withMyAnswer(r.id, r.q, function (q2) { r.q = q2; if (--left <= 0) cb(rows); });
      });
    });
  }

  function requestsForMe(cb) {
    var me = myMail();
    if (!me) { cb([]); return; }
    qUnion([
      qOne('requests', 'fromEmail', '==', me),
      qOne('requests', 'vendorEmail', '==', me)
    ], cb);
  }

  function offersForMe(cb) {
    var me = myMail();
    if (!me) { cb([]); return; }
    qUnion([
      qOne('offers', 'toEmails', 'array-contains', me),
      qOne('offers', 'fromEmail', '==', me)
    ], cb);
  }

  function loadQuotes(cb) {
    if (!window.db) { cb([]); return; }
    quotesForMe(cb);
  }

  function isMine(q) {
    var me = myMail();
    if (!me) return false;
    return String(q.fromEmail || '').toLowerCase() === me;
  }

  function isForMe(q) {
    var me = myMail();
    if (!me) return false;
    if (String(q.vendorEmail || '').toLowerCase() === me) return true;
    var list = q.vendorEmails || [];
    for (var i = 0; i < list.length; i++) {
      if (String(list[i] || '').toLowerCase() === me) return true;
    }
    return false;
  }

  function existingQuoteId(email) {
    var key = String(email || '').toLowerCase();
    return key && quoteByEmail[key] ? quoteByEmail[key] : '';
  }

  function vendorRows(host) {
    var wrap = document.createElement('div');
    wrap.className = 'rq-list';

    var h = document.createElement('div');
    h.className = 'rq-list__h';
    h.textContent = T.rq.title;
    wrap.appendChild(h);

    var list = document.createElement('div');
    wrap.appendChild(list);
    host.appendChild(wrap);
    if (!window.db || !window.customerId) sampleRows(host);

    if (!window.db || !window.customerId) { wrap.hidden = true; return; }

    var handle = (window.shareProductContext && window.shareProductContext.handle) || '';
    loadQuotes(function (all) {
      var byMail = {};
      var rows = [];
      for (var i = 0; i < all.length; i++) {
        var id = all[i].id;
        var q = all[i].q;
        if (q.status === 'discarded') continue;
        if (!isMine(q)) continue;
        if (!forThisProduct(q)) continue;

        var mail = String(q.vendorEmail || '').toLowerCase();
        var when = (q.createdAt && q.createdAt.seconds) ? q.createdAt.seconds : 0;
        if (mail) {
          var seen = byMail[mail];
          if (seen && seen.when >= when) continue;
          if (seen) {
            for (var r = 0; r < rows.length; r++) {
              if (rows[r].id === seen.id) { rows.splice(r, 1); break; }
            }
          }
          byMail[mail] = { id: id, when: when };
          quoteByEmail[mail] = id;
        }
        rows.push({ id: id, q: q });
      }

      if (!rows.length) { wrap.hidden = true; sampleRows(host); return; }
      rows.sort(function (a, b) {
        var av = a.q.createdAt && a.q.createdAt.seconds ? a.q.createdAt.seconds : 0;
        var bv = b.q.createdAt && b.q.createdAt.seconds ? b.q.createdAt.seconds : 0;
        return bv - av;
      });
      list.innerHTML = '';
      for (var k = 0; k < rows.length; k++) quoteRow(list, rows[k].id, rows[k].q);
      if (wantSamples(rows.length)) sampleRows(host);
    });
  }

  /* Quotes have a drawer of their own now: asking for one is a job in
     itself, not a corner of the list of shared budgets. */
  function openQuotes() {
    var d = document.getElementById('Leva-Quotes-Drawer');
    if (!d) return;
    raise(d);
    closeShareDrawer();
    close();
    closeBudget();
    markSeen('quotes');
    paintQuotes(d);
    d.classList.add('active');
    document.body.classList.add('open-cc');
  }

  /* Offers matter more than the form once they start arriving, so the
     drawer opens on the overview. The send button is the whole form
     folded up: the first tap unfolds it in place. */
  var qTab = 'requests';

  /* ONE PRODUCT, ONE SET OF PAPERS. An enquiry is about a building, so it
     belongs to the page for that building and nowhere else. Records made
     before the handle was stored carry none, and letting those through --
     which is what "compare only when there is something to compare"
     amounts to -- put a tiny house enquiry in front of a Taurus. Anything
     that cannot say which product it is for is not for this one. */
  function forThisProduct(rec) {
    var h = (window.shareProductContext && window.shareProductContext.handle) || '';
    if (!h) return true;
    return String(rec && rec.productHandle || '') === h;
  }

  function paintQuotes(d) {
    rqStyle();
    wireQuoteTabs(d);
    paintTabCounts(d);
    var host = d.querySelector('[data-quotes-host]');
    if (!host) return;
    host.innerHTML = '';

    if (qTab === 'requests') paintRequests(host);
    else if (qTab === 'offers') paintOffers(host);
    else paintApprovals(host);
  }

  /* THE ENVELOPE SAYS HOW MANY, THE TABS SAY WHERE. One number on the icon
     got someone to open the drawer and then left them to hunt through
     three lists for whatever it meant. Each tab carries its own share of
     it, counted the same way: news on the left, work owed in the middle
     and on the right. */
  function tabBadge(d, name, n) {
    var tab = d.querySelector('[data-q-tab="' + name + '"]');
    if (!tab) return;
    var old = tab.querySelector('.rq-tabn');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    if (!n) return;
    var s = document.createElement('span');
    s.className = 'rq-tabn';
    s.textContent = n > 99 ? '99+' : String(n);
    tab.appendChild(s);
  }

  function paintTabCounts(d) {
    if (!window.db || !myMail()) return;
    var me = myMail();

    /* THE DRAWER IS OPEN ON ONE PROJECT. The envelope has always counted
       only what belongs to the product being looked at; the tabs counted
       everything the person had anywhere, so a number appeared over a
       project that had nothing waiting on it. */
    var h = badgeHandle();
    var here = function (rec) {
      if (!h) return true;
      return String(rec && rec.productHandle || '') === h;
    };

    loadSeen(function () {
      quotesForMe(function (rows) {
        var answers = 0;
        var owed = 0;
        for (var i = 0; i < rows.length; i++) {
          var q = rows[i].q;
          if (q.status === 'discarded') continue;
          if (!here(q)) continue;

          if (String(q.fromEmail || '').toLowerCase() === me) {
            // an answer I have not opened yet
            if (q.answeredAt && toMillis(q.answeredAt) > rowSeenAt(rows[i].id)) answers++;
            continue;
          }
          if (!isForMe(q)) continue;
          if (q.status === 'declined') continue;
          var askedAt = toMillis(q.createdAt);
          var saidAt = toMillis(q.answeredAt);
          if (saidAt && askedAt && saidAt >= askedAt) continue;
          if (saidAt && !askedAt) continue;
          owed++;
        }
        tabBadge(d, 'requests', answers);
        tabBadge(d, 'offers', owed);
      });

      qOne('requests', 'vendorEmail', '==', me).then(function (rows) {
        var n = 0;
        for (var i = 0; i < rows.length; i++) {
          var r = rows[i].q;
          if (!here(r)) continue;
          if (!r.status || r.status === 'pending') { n++; continue; }
          if (r.status !== 'approved') continue;
          var until = toMillis(r.grantUntil);
          if (!until || until <= Date.now()) continue;
          if ((until - Date.now()) > 7 * 86400000) continue;
          n++;
        }
        tabBadge(d, 'approvals', n);
      });
    });
  }

  function wireQuoteTabs(d) {
    if (d.getAttribute('data-q-wired') === '1') return;
    d.setAttribute('data-q-wired', '1');
    var tabs = d.querySelectorAll('[data-q-tab]');
    for (var i = 0; i < tabs.length; i++) {
      (function (b) {
        b.addEventListener('click', function () {
          qTab = b.getAttribute('data-q-tab');
          for (var j = 0; j < tabs.length; j++) {
            var on = tabs[j] === b;
            tabs[j].classList.toggle('tab-active', on);
            tabs[j].setAttribute('aria-selected', on ? 'true' : 'false');
          }
          paintQuotes(d);
        });
      })(tabs[i]);
    }
  }

  function emptyNote(host, text) {
    var p = document.createElement('div');
    p.className = 'rq-msg';
    p.textContent = text;
    host.appendChild(p);
  }

  // ---- what I have sent ----
  function paintRequests(host) {
    var slot = document.createElement('div');
    slot.className = 'rq-open';
    host.appendChild(slot);

    /* The button that opens the form and the button that sends it are two
       different acts, and calling both of them "Send request" made the
       first one look like it had already done something. */
    var open = document.createElement('button');
    open.type = 'button';
    open.className = 'rq-send';
    open.textContent = (T.rq && T.rq.newRequest) || 'New request';
    open.addEventListener('click', function () {
      slot.innerHTML = '';
      /* A fresh request still starts from the last one this person sent:
         the place and the phone do not change between vendors, and typing
         them out again is how they end up different by accident. The
         address to send to is left empty -- that is the one thing that is
         meant to be new. */
      lastSentByMe(function (prev) {
        slot.innerHTML = '';
        buildRequestForm(slot, (window.__levaQuoteVendorEmail || ''), '', null,
          prev ? { fromName: prev.fromName, fromEmail: prev.fromEmail,
                   phone: prev.phone, place: prev.place, note: prev.note } : null);
      });
    });
    slot.appendChild(open);

    vendorRows(host);
  }

  // ---- what someone asked me to price ----
  /* WHAT ARRIVES, AND WHAT ANSWERING IT LOOKS LIKE. An empty Offers tab
     said only that nobody had written -- it never showed a vendor what a
     job coming in looks like, or that answering means ticking the trades
     they price rather than the whole build. Invented people, invented
     projects. */
  function offerSamples(host) {
    var wrap = document.createElement('div');
    wrap.className = 'rq-list';
    var h = document.createElement('div');
    h.className = 'rq-list__h';
    h.textContent = T.rq.sample;
    wrap.appendChild(h);

    var rows = [
      /* One of each, no more: the samples exist to show what the states
         look like, and a second identical card teaches nothing. */
      {
        state: 'pending',
        name: 'Dana Whitfield', mail: 'dana.whitfield@gmail.com',
        phone: '+1 512 555 0173',
        place: 'Hyde Park, Austin, TX  |  asked today',
        note: 'Two-bedroom tiny house on a sloping plot, ready to start in spring. '
          + 'I need the frame and the roof priced; the fit-out I will do myself. '
          + 'Please quote labour separately from materials.'
      },
      {
        state: 'approved',
        name: 'Owen Brackett', mail: 'owen@brackettbuild.co.uk',
        phone: '+44 7700 118234',
        place: 'Stroud, Gloucestershire  |  quoted yesterday',
        money: 31450, valid: '18 Sep',
        note: 'Workshop and store at the end of a garden. Priced the frame, '
          + 'the sheathing and the roof covering.'
      },
      {
        state: 'approved',
        name: 'Marie Lindqvist', mail: 'marie@lindqvistbygg.se',
        phone: '+46 70 445 2218',
        place: 'Limhamn, Malmo  |  quoted 5 days ago',
        money: 28910, valid: '30 Sep', opened: true,
        note: 'Guest cabin next to an existing house. Quoted the timber frame, '
          + 'the cladding and the roof; groundworks are handled locally.'
      }
    ];

    for (var i = 0; i < rows.length; i++) {
      (function (r) {
        var slot = document.createElement('div');
        slot.className = 'rq-slot';

        var money = sampleMoney(r.money);
        var valid = r.valid ? T.rq.validUntil.split('%d').join(r.valid) : '';

        var bn = stateBanner(r.state === 'approved' ? 'approved' : 'pending',
          r.name, r.place, function () {
            var open = slot.querySelector('.rq-det');
            if (open) { slot.removeChild(open); return; }
            slot.appendChild(requestDetail({
              fromName: r.name, fromEmail: r.mail, phone: r.phone,
              place: r.place.split('  |  ')[0], note: r.note
            }));
          }, null, r.mail, money, valid);

        if (r.state === 'approved') {
          var st = bn.querySelector('.rq-bn__st');
          if (st) {
            st.textContent = r.opened
              ? ((T.rq && T.rq.qOpened) || 'Quote opened')
              : ((T.rq && T.rq.qSent) || 'Quote sent');
            st.classList.add(r.opened ? 'rq-bn__st--seen' : 'rq-bn__st--out');
          }
        }

        slot.appendChild(bn);
        wrap.appendChild(slot);
      })(rows[i]);
    }

    host.appendChild(wrap);
  }

  /* THE MIRROR OF NEW REQUEST. Answering was the only way a price could
     travel, so a vendor with something to offer had to wait to be asked.
     The form takes the two things a request takes from the other side --
     who it goes to and what it is about -- and the pricing underneath is
     the sheet that already exists. */
  function newOfferButton(host) {
    var slot = document.createElement('div');
    slot.className = 'rq-open';
    host.appendChild(slot);

    var open = document.createElement('button');
    open.type = 'button';
    open.className = 'rq-send';
    open.textContent = (T.rq && T.rq.newOffer) || 'New offer';
    open.addEventListener('click', function () {
      slot.innerHTML = '';
      buildOfferOut(slot);
    });
    slot.appendChild(open);
  }

  function buildOfferOut(host) {
    rqStyle();
    var form = document.createElement('div');
    form.className = 'rq-form';

    var field = function (labelText, tag) {
      var l = document.createElement('label');
      l.textContent = labelText;
      var i = document.createElement(tag || 'input');
      if (tag === 'textarea') i.rows = 2;
      l.appendChild(i);
      form.appendChild(l);
      return i;
    };

    var myName = field((T.rq && T.rq.myName) || 'Name');
    myName.value = rqMeVal('name');
    myName.addEventListener('change', function () { rqMeSet('name', myName.value); });

    var myMailEl = field(T.rq.myEmail);
    myMailEl.type = 'email';
    myMailEl.value = window.customerEmail || '';
    myMailEl.readOnly = true;

    var phone = field(T.rq.myPhone);
    phone.type = 'tel';
    phone.value = rqMeVal('phone');
    phone.addEventListener('change', function () { rqMeSet('phone', phone.value); });

    var to = field((T.rq && T.rq.offerTo) || 'Offer to');
    to.type = 'text';
    to.placeholder = 'name@company.com, second@company.com';

    var hint = document.createElement('div');
    hint.className = 'rq-msg';
    hint.textContent = T.rq.sendToHint;
    form.appendChild(hint);

    var note = field(T.rq.note, 'textarea');

    var msg = document.createElement('div');
    msg.className = 'rq-msg';
    form.appendChild(msg);

    host.appendChild(form);

    /* ONE FORM, NOT TWO STEPS. Asking who it is for and then making the
       vendor press a button to reach the pricing put the tree behind a
       door -- and the door was labelled Send, so pressing it looked like
       the offer was already going out. The sheet sits underneath and the
       recipient is read at the moment it is sent. */
    qt.id = null;
    qt.doc = null;
    qt.unsolicited = true;
    qt.offerTo = [];
    qt.offerNote = '';

    var sync = function () {
      var list = to.value.split(/[,;\s]+/);
      var mails = [];
      for (var i = 0; i < list.length; i++) {
        var one = list[i].trim();
        if (one && one.indexOf('@') > 0) mails.push(one.toLowerCase());
      }
      qt.offerTo = mails;
      qt.offerNote = note.value.trim();
      qt.vendorName = myName.value.trim();
      qt.vendorPhone = phone.value.trim();
    };
    to.addEventListener('input', sync);
    note.addEventListener('input', sync);
    myName.addEventListener('input', sync);
    phone.addEventListener('input', sync);
    sync();

    var box = document.createElement('div');
    box.className = 'rq-slot__form';
    host.appendChild(box);
    buildQuoteFields(box);

    form.scrollIntoView({ block: 'nearest' });
  }

  function paintOffers(host) {
    newOfferButton(host);
    if (!myMail()) { emptyNote(host, T.rq.noneOff); offerSamples(host); return; }
    var list = document.createElement('div');
    host.appendChild(list);

    loadQuotes(function (all) {
      /* Several requests can arrive from the same person; only the last
         one is worth answering, so the older ones are set aside -- the
         same rule the sender's list follows. */
      var byMail = {};
      var rows = [];
      for (var i = 0; i < all.length; i++) {
        var id = all[i].id;
        var q = all[i].q;
        if (q.status === 'discarded') continue;
        if (!isForMe(q)) continue;
        if (!forThisProduct(q)) continue;

        var mail = String(q.fromEmail || '').toLowerCase();
        var when = (q.createdAt && q.createdAt.seconds) ? q.createdAt.seconds : 0;
        if (mail) {
          var seen = byMail[mail];
          if (seen && seen.when >= when) continue;
          if (seen) {
            for (var r = 0; r < rows.length; r++) {
              if (rows[r].id === seen.id) { rows.splice(r, 1); break; }
            }
          }
          byMail[mail] = { id: id, when: when };
        }
        rows.push({ id: id, q: q });
      }

      if (!rows.length) { emptyNote(host, T.rq.noneOff); offerSamples(host); return; }
      rows.sort(function (a, b) {
        var av = a.q.createdAt && a.q.createdAt.seconds ? a.q.createdAt.seconds : 0;
        var bv = b.q.createdAt && b.q.createdAt.seconds ? b.q.createdAt.seconds : 0;
        return bv - av;
      });
      for (var k = 0; k < rows.length; k++) offerRow(list, rows[k].id, rows[k].q);
      if (wantSamples(rows.length)) offerSamples(host);
    });
  }

  /* OPENING THE SHEET LOADS THE MODEL IT IS ABOUT. Pricing ran against
     whatever happened to be on screen, and the button that fixed that was
     one the vendor had to think of pressing -- so an offer went out priced
     on somebody else's shape more than once. The sheet cannot be filled in
     for the wrong building if the building arrives with it.
     Nothing is rebuilt when the page already holds that configuration,
     which is the ordinary case: the vendor followed the link. */
  function withModel(q, cb) {
    var want = (q && (q.configId || q.cfg)) || '';
    var have = '';
    try { have = new URL(window.location.href).searchParams.get('cfg') || ''; } catch (e) {}
    if (!want || want === have) { cb(); return; }

    var lib = window.SaunaLib;
    if (!lib || typeof lib.loadConfig !== 'function') { cb(); return; }

    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('cfg', want);
        window.history.replaceState(null, '', u.toString());
      } catch (e) {}
      /* The budget redraws from the new bill of quantities, so the sheet
         is built on the quantities it is about, not the ones before it. */
      setTimeout(function () {
        if (typeof window.__budgetRenderItems === 'function') {
          try { window.__budgetRenderItems(); } catch (e) {}
        }
        cb();
      }, 400);
    };

    setTimeout(finish, 6000);
    try {
      lib.loadConfig(want).then(finish).catch(finish);
    } catch (e) { finish(); }
  }

  function offerRow(host, id, q) {
    var slot = document.createElement('div');
    slot.className = 'rq-slot';

    var bn = stateBanner(stateOf(q), q.fromName || q.fromEmail || '',
      [shortPlace(q.place), whenText(q)].filter(Boolean).join('  |  '), function () {
        var open = slot.querySelector('.rq-slot__form');
        if (open) { slot.removeChild(open); return; }
        var box = document.createElement('div');
        box.className = 'rq-slot__form';
        qt.unsolicited = false;
        var wait = document.createElement('div');
        wait.className = 'bic-d__msg';
        wait.textContent = (T.rq && T.rq.loadingModel) || 'Loading their model...';
        box.appendChild(wait);
        slot.appendChild(box);
        box.scrollIntoView({ block: 'nearest' });

        withModel(q, function () {
          box.innerHTML = '';
          buildOfferForm(box, id, q);
          box.insertBefore(rowActions(id, q, slot), box.firstChild);
        });
      }, null, q.fromEmail || '');

    /* "Approved" is the word for a granted request, not for a price that
       has gone out -- and once it has gone out the thing worth knowing is
       whether anybody has looked at it. */
    if (q.answeredAt) {
      var stO = bn.querySelector('.rq-bn__st');
      if (stO) {
        stO.textContent = q.openedAt
          ? ((T.rq && T.rq.qOpened) || 'Quote opened')
          : ((T.rq && T.rq.qSent) || 'Quote sent');
        stO.classList.add(q.openedAt ? 'rq-bn__st--seen' : 'rq-bn__st--out');
      }
    }

    /* Once it is answered there is nothing left to refuse, so the bin
       gives way to a tick: the work on this one is done. */
    if (stateOf(q) === 'approved') {
      var done = rowIcon('ok', T.rq.quoteSent, function () {});
      done.classList.add('rq-bn__act');
      done.style.cursor = 'default';
      bn.appendChild(done);
      chatIcon(bn, slot, id, q);
      slot.appendChild(bn);
      host.appendChild(slot);
      return;
    }

    /* Refusing used to sit on the banner, next to nothing else. Once the
       row's own icons arrived it read as a second bin with a different
       meaning, so it moved in with them. */
    chatIcon(bn, slot, id, q);
    /* Urgovat ma smysl jen dokud cena neprisla. */
    if (!q.answeredAt) urgeIcon(bn, q);
    slot.appendChild(bn);
    host.appendChild(slot);
  }

  /* The request as it was sent, a divider, then the vendor's own part.
     Both on one sheet, so nothing has to be looked up elsewhere. */
  /* Two facts and what to do with them: the phone dials or saves as a
     contact, the address opens on a map. No heading, because two lines
     explain themselves. */
  function contactIcon(kind, title, onClick, href) {
    var b = document.createElement(href ? 'a' : 'button');
    if (href) {
      b.href = href;
      if (kind !== 'call') b.target = '_blank';
      b.rel = 'noopener';
    } else {
      b.type = 'button';
    }
    b.className = 'qs-ic qs-ic--' + kind;
    b.title = title;
    b.setAttribute('aria-label', title);

    var paths = kind === 'call'
      ? ['M6.6 10.8a15 15 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11 11 0 0 0 3.5.56 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1 11 11 0 0 0 .56 3.5 1 1 0 0 1-.25 1l-2.2 2.3z']
      : kind === 'card'
      ? ['M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z',
         'M9.5 11.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4z', 'M6 16c.6-1.8 2-2.6 3.5-2.6S12.4 14.2 13 16', 'M15 9h4M15 12.5h4']
      : ['M12 2a7 7 0 0 0-7 7c0 5.2 7 13 7 13s7-7.8 7-13a7 7 0 0 0-7-7z', 'M12 11.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z'];

    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '14');
    svg.setAttribute('height', '14');
    svg.setAttribute('fill', 'none');
    for (var i = 0; i < paths.length; i++) {
      var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      p.setAttribute('d', paths[i]);
      p.setAttribute('stroke', 'currentColor');
      p.setAttribute('stroke-width', '1.9');
      p.setAttribute('stroke-linecap', 'round');
      p.setAttribute('stroke-linejoin', 'round');
      svg.appendChild(p);
    }
    b.appendChild(svg);
    if (onClick) b.addEventListener('click', function (e) { e.stopPropagation(); onClick(); });
    return b;
  }

  /* A downloaded .vcf usually lands in Files and nothing opens it. Handing
     the card to the system share sheet lets the phone offer Contacts
     straight away; the download stays as the way out on a desktop. */
  function saveCard(q) {
    var name = (q.fromEmail || 'LEVA contact').split('@')[0].replace(/[._-]+/g, ' ');
    var lines = [
      'BEGIN:VCARD', 'VERSION:3.0',
      'FN:' + name,
      q.phone ? ('TEL;TYPE=CELL:' + q.phone) : '',
      q.fromEmail ? ('EMAIL:' + q.fromEmail) : '',
      q.place ? ('ADR;TYPE=WORK:;;' + String(q.place).replace(/,/g, ';')) : '',
      'NOTE:LEVA',
      'END:VCARD'
    ].filter(Boolean).join('\r\n');

    var blob = new Blob([lines], { type: 'text/vcard;charset=utf-8' });
    var fileName = (name || 'contact').replace(/\s+/g, '-').toLowerCase() + '.vcf';

    try {
      if (window.File && navigator.canShare) {
        var file = new File([blob], fileName, { type: 'text/vcard' });
        if (navigator.canShare({ files: [file] })) {
          navigator.share({ files: [file] }).catch(function () { downloadCard(blob, fileName); });
          return;
        }
      }
    } catch (e) {}

    downloadCard(blob, fileName);
  }

  function downloadCard(blob, fileName) {
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      if (a.parentNode) a.parentNode.removeChild(a);
      // a phone may still be reading the file when the tab lets go of it
      setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
    }, 0);
  }

  function buildOfferForm(box, id, q) {
    var det = document.createElement('div');
    det.className = 'qs-detail';

    if (q.phone) {
      var rowP = document.createElement('div');
      rowP.className = 'qs-line';
      var vp = document.createElement('b');
      vp.textContent = q.phone;
      rowP.appendChild(vp);
      rowP.appendChild(contactIcon('call', q.phone, null, 'tel:' + String(q.phone).replace(/\s+/g, '')));
      rowP.appendChild(contactIcon('card', q.fromEmail || '', function () { saveCard(q); }));
      det.appendChild(rowP);
    }

    /* Who is asking, in caps, above where it is being built. A full
       Nominatim address is three lines of nesting nobody reads, so it
       stays on one and trails off -- the map icon beside it is what a
       person actually taps. */
    if (q.fromName) {
      var rowN = document.createElement('div');
      rowN.className = 'qs-who';
      rowN.textContent = String(q.fromName).toUpperCase();
      det.appendChild(rowN);
    }

    if (q.place) {
      var rowA = document.createElement('div');
      rowA.className = 'qs-line qs-line--addr';
      var va = document.createElement('b');
      va.className = 'qs-addr';
      va.textContent = q.place;
      va.title = q.place;
      rowA.appendChild(va);
      rowA.appendChild(contactIcon('map', q.place, null,
        'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(q.place)));
      det.appendChild(rowA);
    }

    box.appendChild(det);

    /* The budget has numbers only once the sender's configuration is on
       screen, so their model is loaded from here, right under what they
       asked for. */
    var cfg = q.configId || '';
    if (!cfg && q.projectUrl) {
      try { cfg = new URL(q.projectUrl).searchParams.get('cfg') || ''; } catch (e) {}
    }
    var here = '';
    try { here = new URL(window.location.href).searchParams.get('cfg') || ''; } catch (e) {}
    var load = null;
    if (cfg && cfg !== here) {
      load = document.createElement('button');
      load.type = 'button';
      load.className = 'qs-model';
      load.textContent = T.rq.loadModel;
      load.setAttribute('data-cfg', cfg);
      load.addEventListener('click', function () {
        try {
          var use = load.getAttribute('data-cfg') || cfg;
          var u = new URL(window.location.origin
            + (q.productHandle ? '/products/' + q.productHandle : window.location.pathname));
          u.searchParams.set('cfg', use);
          u.searchParams.set('leva_quote', id);
          window.location.href = u.toString();
        } catch (e) {}
      });
      det.appendChild(load);
    }

    /* The person paying keeps shaping the project, so the model on the
       offer is whatever they have now, not what they had when they
       asked. Their own budget record carries the current one. */
    if (window.db && q.fromCustomerId && q.productHandle) {
      var ids = [];
      if (q.variantId) ids.push(q.fromCustomerId + '__' + q.productHandle + '__' + q.variantId);
      ids.push(q.fromCustomerId + '__' + q.productHandle);
      (function look(i) {
        if (i >= ids.length) return;
        window.db.collection('budget_details').doc(ids[i]).get().then(function (doc) {
          if (!doc.exists) { look(i + 1); return; }
          var live = (doc.data() || {}).configId || '';
          if (live && live !== cfg) {
            cfg = live;
            if (load) load.setAttribute('data-cfg', live);
          }
        }).catch(function () {});
      })(0);
    }


    var hr = document.createElement('div');
    hr.className = 'qs-div';
    box.appendChild(hr);

    qt.id = id;
    qt.doc = q;
    buildQuoteFields(box);
  }

  // ---- prices someone wants to see, waiting on my word ----
  /* Who is asking to see my prices, and what deciding looks like. */
  function approvalSamples(host) {
    var wrap = document.createElement('div');
    wrap.className = 'rq-list';
    var h = document.createElement('div');
    h.className = 'rq-list__h';
    h.textContent = T.rq.sample;
    wrap.appendChild(h);

    var rows = [
      {
        state: 'pending',
        name: 'Tomas Prochazka', mail: 'tomas@prochazkastavby.cz',
        phone: '+420 731 664 205',
        place: 'Zabovresky, Brno  |  asked today',
        note: 'Building three cabins for a campsite and comparing suppliers. '
          + 'I would like to see your material prices before I ask you to quote.'
      },
      {
        state: 'approved',
        name: 'Elena Rossi', mail: 'elena@rossilegno.it',
        phone: '+39 340 118 2276',
        place: 'Trento  |  ' + ((T.rq && T.rq.stSoon) || 'ends in %d days').split('%d').join('4'),
        note: 'Carpentry workshop looking at your rates for a joint project this autumn.'
      },
      {
        state: 'declined',
        name: 'Greg Salter', mail: 'greg.salter@outlook.com',
        phone: '',
        place: 'Manchester  |  decided last week',
        note: 'No project named, no details given.'
      }
    ];

    for (var i = 0; i < rows.length; i++) {
      (function (r) {
        var slot = document.createElement('div');
        slot.className = 'rq-slot';

        var bn = stateBanner(r.state, r.name, r.place, function () {
          var open = slot.querySelector('.rq-det');
          if (open) { slot.removeChild(open); return; }
          slot.appendChild(requestDetail({
            fromName: r.name, fromEmail: r.mail, phone: r.phone,
            place: r.place.split('  |  ')[0], note: r.note
          }));
        }, null, [r.mail, r.phone].filter(Boolean).join('  |  '));

        slot.appendChild(bn);
        wrap.appendChild(slot);
      })(rows[i]);
    }

    host.appendChild(wrap);
  }

  function paintApprovals(host) {
    if (!myMail() || !window.db) { emptyNote(host, T.rq.noneApp); approvalSamples(host); return; }
    var list = document.createElement('div');
    host.appendChild(list);

    qOne('requests', 'vendorEmail', '==', myMail())
      .then(function (rows) {
        var n = 0;
        var ending = [];
        rows.forEach(function (doc) {
          var r = doc.q;
          if (!forThisProduct(r)) return;

          if (!r.status || r.status === 'pending') { n++; approvalRow(list, doc.id, r); return; }

          /* An owner who granted access for a fortnight has no way of
             knowing it is about to lapse, and the person on the other end
             finds out by being locked out. The ones inside a week are
             listed here, so a renewal is a decision rather than a
             surprise. */
          if (r.status !== 'approved') return;
          var until = toMillis(r.grantUntil);
          if (!until || until <= Date.now()) return;
          var days = Math.ceil((until - Date.now()) / 86400000);
          if (days > 7) return;
          ending.push({ id: doc.id, r: r, days: days });
        });

        if (ending.length) {
          var head = document.createElement('div');
          head.className = 'rq-sec';
          head.textContent = (T.rq && T.rq.endingSoon) || 'ACCESS ENDING SOON';
          list.appendChild(head);
          for (var i = 0; i < ending.length; i++) {
            grantRow(list, ending[i].id, ending[i].r, ending[i].days);
          }
        }

        if (!n && !ending.length) emptyNote(host, T.rq.noneApp);
        if (wantSamples(n + ending.length)) approvalSamples(host);
      })
      .catch(function () { emptyNote(host, T.rq.noneApp); approvalSamples(host); });
  }

  /* A grant that is nearly up, with one button to extend it. */
  function grantRow(host, id, r, days) {
    var slot = document.createElement('div');
    slot.className = 'rq-slot';

    var bn = stateBanner('approved', r.fromName || r.fromEmail || '',
      [shortPlace(r.place),
        ((T.rq && T.rq.stSoon) || 'ends in %d days').split('%d').join(String(days))
      ].filter(Boolean).join('  |  '), null, null,
      [r.fromEmail, r.phone].filter(Boolean).join('  |  '));

    var more = rowIcon('ok', (T.rq && T.rq.extend) || 'Extend', function (btn) {
      var until = new Date(Date.now() + (Number(r.grantDays) || 14) * 86400000);
      window.db.collection('requests').doc(String(id))
        .set({ grantUntil: until, decidedAt: new Date() }, { merge: true })
        .then(function () { if (slot.parentNode) slot.parentNode.removeChild(slot); })
        .catch(function (e) {
          btn.classList.add('is-bad');
          btn.title = String(e && e.message ? e.message : e);
        });
    });
    more.classList.add('rq-bn__act');
    bn.appendChild(more);

    slot.appendChild(bn);
    host.appendChild(slot);
  }

  /* Everything the asker actually sent, in full. */
  function requestDetail(r) {
    var box = document.createElement('div');
    box.className = 'rq-det';

    var line = function (label, value, href) {
      if (!value) return;
      var row = document.createElement('div');
      row.className = 'rq-det__r';
      var k = document.createElement('span');
      k.className = 'rq-det__k';
      k.textContent = label;
      row.appendChild(k);
      if (href) {
        var a = document.createElement('a');
        a.className = 'rq-det__v';
        a.href = href;
        a.textContent = value;
        row.appendChild(a);
      } else {
        var v = document.createElement('span');
        v.className = 'rq-det__v';
        v.textContent = value;
        row.appendChild(v);
      }
      box.appendChild(row);
    };

    line((T.rq && T.rq.myName) || 'Name', r.fromName);
    line(T.rq.myEmail, r.fromEmail, r.fromEmail ? ('mailto:' + r.fromEmail) : null);
    line(T.rq.myPhone, r.phone, r.phone ? ('tel:' + String(r.phone).replace(/\s+/g, '')) : null);
    line(T.rq.place, r.place, r.place
      ? ('https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(r.place))
      : null);

    // the description last and unclipped: it is the part worth reading
    if (r.note) {
      var head = document.createElement('div');
      head.className = 'rq-det__k rq-det__k--note';
      head.textContent = T.rq.note;
      box.appendChild(head);
      var body = document.createElement('div');
      body.className = 'rq-det__note';
      body.textContent = r.note;
      box.appendChild(body);
    }

    return box;
  }

  function approvalRow(host, id, r) {
    var slot = document.createElement('div');
    slot.className = 'rq-slot';

    /* DECIDING NEEDS THE WHOLE REQUEST. The card is three shortened lines,
       and the description -- the one place the asker says what they are
       building and why they want the prices -- was not on it anywhere.
       Approving blind is not approving. */
    var bn = stateBanner('pending', r.fromName || r.fromEmail || '',
      [shortPlace(r.place), whenText(r)].filter(Boolean).join('  |  '), function () {
        var open = slot.querySelector('.rq-det');
        if (open) { slot.removeChild(open); return; }
        slot.appendChild(requestDetail(r));
      }, null,
      [r.fromEmail, r.phone].filter(Boolean).join('  |  '));

    // one click either way: no form on this side at all
    var no = rowIcon('bin', T.rq.no, function () {
      confirmYesNo(function () {
        window.db.collection('requests').doc(String(id))
          .set({ status: 'declined', decidedAt: new Date() }, { merge: true })
          .then(function () { if (slot.parentNode) slot.parentNode.removeChild(slot); })
          .catch(function () {});
      });
    });
    no.classList.add('rq-bn__act');
    bn.appendChild(no);

    var ok = rowIcon('ok', T.rq.approve, function () {
      askPeriod(id);
      if (slot.parentNode) slot.parentNode.removeChild(slot);
    });
    ok.classList.add('rq-bn__act', 'rq-bn__act--2');
    bn.appendChild(ok);

    slot.appendChild(bn);
    host.appendChild(slot);
  }

  /* ============================================================
     W2  QUOTES
     The same carrier as a price request: the project URL, with
     leva_quote naming the record. The vendor opens it, prices the
     project on an empty budget of their own, and sends the result
     back. Nothing of theirs is overwritten while they do it.
     ============================================================ */
  var qt = { id: '', doc: null, prices: null, exec: null };

  /* The place of realisation names a town, so it suggests towns. The
     browser's own datalist was tried and failed: on Android the popup
     does not reopen once options arrive from a fetch, so the field went
     quiet. This is a list of our own, parked on body and placed by the
     input's rectangle, which is the only way out of the drawer's
     overflow -- the reason the first styled attempt never showed. */
  var placeLast = 'not used yet';
  window.__levaPlaceLast = function () { return placeLast; };

  function placeBox() {
    var box = document.getElementById('rq-place-sug');
    if (box) return box;
    box = document.createElement('div');
    box.id = 'rq-place-sug';
    box.style.cssText = 'position:fixed;z-index:100011;display:none;'
      + 'background:#fff;border:1px solid #E5E7EB;border-radius:12px;'
      + 'box-shadow:0 12px 32px rgba(0,0,0,.16);overflow:auto;max-height:240px;';
    document.body.appendChild(box);
    return box;
  }

  function placeHide() {
    var box = document.getElementById('rq-place-sug');
    if (box) { box.style.display = 'none'; box.innerHTML = ''; }
  }

  function placePlace(input) {
    var box = placeBox();
    var r = input.getBoundingClientRect();
    box.style.left = Math.round(r.left) + 'px';
    box.style.top = Math.round(r.bottom + 4) + 'px';
    box.style.width = Math.round(r.width) + 'px';
  }

  function attachPlaceSuggest(input) {
    if (!input || input.__suggest) return;
    input.__suggest = true;
    input.setAttribute('autocomplete', 'off');
    placeLast = 'wired, nothing typed yet';

    var timer = null;
    var seq = 0;

    function draw(rows, forInput) {
      var box = placeBox();
      box.innerHTML = '';
      if (!rows || !rows.length) { placeHide(); return; }
      for (var i = 0; i < rows.length; i++) {
        (function (name) {
          var it = document.createElement('div');
          it.textContent = name;
          it.style.cssText = 'padding:10px 12px;font-size:14px;line-height:1.3;cursor:pointer;'
            + 'border-bottom:1px solid #F3F4F6;';
          it.addEventListener('mousedown', function (e) { e.preventDefault(); });
          it.addEventListener('click', function () {
            forInput.value = name;
            placeLast = 'picked ' + name;
            placeHide();
          });
          box.appendChild(it);
        })(rows[i].display_name);
      }
      placePlace(forInput);
      box.style.display = 'block';
    }

    input.addEventListener('input', function () {
      var q = String(input.value || '').trim();
      clearTimeout(timer);
      if (q.length < 3) {
        placeLast = 'typed ' + q.length + ' characters, need 3';
        placeHide();
        return;
      }
      placeLast = 'waiting for the pause after "' + q + '"';
      timer = setTimeout(function () {
        var mine = ++seq;
        var lang = 'en';
        try { lang = pageLang(); } catch (e) {}
        placeLast = 'sent "' + q + '"';
        fetch('https://nominatim.openstreetmap.org/search?format=json&limit=6'
          + '&accept-language=' + encodeURIComponent(lang)
          + '&q=' + encodeURIComponent(q), { headers: { 'Accept': 'application/json' } })
          .then(function (r) {
            placeLast = 'http ' + r.status + ' for "' + q + '"';
            return r.ok ? r.json() : [];
          })
          .then(function (rows) {
            if (mine !== seq) return;
            placeLast = 'http 200, ' + ((rows && rows.length) || 0) + ' rows for "' + q + '"';
            draw(rows, input);
          })
          .catch(function (e) {
            placeLast = 'failed: ' + (e && e.message ? e.message : String(e));
            placeHide();
          });
      }, 900);
    });

    input.addEventListener('blur', function () {
      setTimeout(placeHide, 250);
    });

    window.addEventListener('scroll', function () {
      var box = document.getElementById('rq-place-sug');
      if (box && box.style.display === 'block') placePlace(input);
    }, true);
  }

  function quoteId() {
    return 'qt' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  }

  /* Clearing the two globals once is not enough: the page loads a set of
     demo prices of its own a moment later and puts them straight back, so
     the sheet filled up again. While a quote is being priced the globals
     are held: reads get the blank sheet, writes from anywhere else are
     dropped, and the vendor's own edits land in it as usual. */
  function holdEmpty() {
    qt.mats = {};
    qt.execMap = {};
    try {
      Object.defineProperty(window, 'user_prices', {
        configurable: true,
        get: function () { return qt.mats; },
        set: function () { /* the sheet stays blank */ }
      });
      Object.defineProperty(window, 'execution_data', {
        configurable: true,
        get: function () { return qt.execMap; },
        set: function () { }
      });
    } catch (e) {}
  }

  function releaseHold() {
    try {
      delete window.user_prices;
      delete window.execution_data;
    } catch (e) {}
  }

  function emptyBudget() {
    qt.prices = window.user_prices;
    qt.exec = window.execution_data;
    holdEmpty();
    if (typeof window.__budgetRenderItems === 'function') window.__budgetRenderItems();
    // whatever arrives late is drawn against the blank sheet
    var n = 0;
    var iv = setInterval(function () {
      if (!qt.id || ++n > 20) { clearInterval(iv); return; }
      if (typeof window.__budgetRenderItems === 'function') window.__budgetRenderItems();
    }, 700);
  }

  function restoreBudget() {
    releaseHold();
    if (qt.prices) window.user_prices = qt.prices;
    if (qt.exec) window.execution_data = qt.exec;
    qt.prices = null;
    qt.exec = null;
    qt.id = '';
    if (typeof window.__budgetRenderItems === 'function') window.__budgetRenderItems();
  }

  function isMoneyKey(key) {
    var cut = String(key).lastIndexOf('_');
    if (cut === -1) return true;
    return /^[A-Z]{3}$/.test(String(key).slice(cut + 1));
  }

  /* What the vendor has on screen is their own budget: the sandbox only
     holds what they typed over it. Sending the sandbox alone therefore
     sent almost nothing, and the reader filled the gap with their own
     prices and times. The stashed originals are the base now, with the
     sandbox laid on top. */
  function mergeSheets(base, over) {
    var out = {};
    var key;
    for (key in base) {
      if (!Object.prototype.hasOwnProperty.call(base, key)) continue;
      if (base[key] === '' || base[key] == null) continue;
      out[key] = base[key];
    }
    for (key in over) {
      if (!Object.prototype.hasOwnProperty.call(over, key)) continue;
      if (over[key] === '' || over[key] == null) continue;
      out[key] = over[key];
    }
    return out;
  }

  function cfgOfPage() {
    try { return new URL(window.location.href).searchParams.get('cfg') || ''; }
    catch (e) { return ''; }
  }

  /* The vendor's own totals ride along, not to be shown but to be checked
     against: when the reader's sum differs, something did not travel. */
  function readNumFor(sel) {
    var el = document.querySelector(sel);
    if (!el) return null;
    var raw = (el.textContent || '').replace(/[^0-9.,]/g, '');
    if (!raw) return null;
    var dot = raw.lastIndexOf('.');
    var com = raw.lastIndexOf(',');
    var dec = Math.max(dot, com);
    var n = (dec !== -1 && dot !== com && (raw.length - dec - 1) <= 2)
      ? parseFloat(raw.slice(0, dec).replace(/[.,]/g, '') + '.' + raw.slice(dec + 1))
      : parseFloat(raw.replace(/[.,]/g, ''));
    return isFinite(n) ? n : null;
  }

  /* THE OFFER IS WHAT WAS TICKED, AND ONLY THAT. Sending the whole sheet
     made a joiner look like a general contractor; sending the reader's own
     figures back to them made the total look agreed when nothing was. So:
     the lines the vendor priced, inside the subcategories they kept, and
     their rate on those subcategories. Nothing else travels, and the
     reader's budget is not consulted to fill any of it in. */
  function collectQuote() {
    var mats = {};
    var exec = {};
    var p = mergeSheets(qt.prices || {}, qt.mats || {});
    var e = mergeSheets(qt.exec || {}, qt.execMap || {});
    if (!Object.keys(p).length) p = window.user_prices || {};
    if (!Object.keys(e).length) e = window.execution_data || {};
    var k = (isFinite(qt.coef) && qt.coef > 0) ? qt.coef : 1;

    var take = qsTakenIds();
    var subs = qsTakenSubs();

    for (var i = 0; i < take.length; i++) {
      var id = take[i];
      var v = p[id];
      if (v === '' || v == null) continue;
      var n = Number(v);
      mats[id] = (k !== 1 && isFinite(n) && n !== 0) ? String(n * k) : v;

      // the currency twin of the same figure, when the sheet carries one
      for (var key in p) {
        if (!Object.prototype.hasOwnProperty.call(p, key)) continue;
        if (key.indexOf(id + '_') !== 0) continue;
        if (!isMoneyKey(key)) { mats[key] = p[key]; continue; }
        var cn = Number(p[key]);
        mats[key] = (k !== 1 && isFinite(cn) && cn !== 0) ? String(cn * k) : p[key];
      }
    }

    /* Times ride with the subcategory that was kept: an hour is only worth
       sending when there is a rate to price it with. */
    var rows = qsRows();
    for (var r = 0; r < rows.length; r++) {
      var row = rows[r];
      if (!row || !row[0] || !row[2]) continue;
      if (!subs[String(row[2])]) continue;
      var rid = row[0];
      for (var k2 in e) {
        if (!Object.prototype.hasOwnProperty.call(e, k2)) continue;
        if (k2.indexOf(rid + '_') !== 0) continue;
        if (e[k2] === '' || e[k2] == null) continue;
        exec[k2] = e[k2];
      }
    }

    return { materials: mats, execution: exec };
  }

  /* The lines that travel: priced by this vendor, in a kept subcategory. */
  /* What the ticked part of the sheet comes to. The screen totals cannot
     answer this -- they are the whole building -- and promising the
     building while sending a trade is exactly the gap this was built to
     close. */
  function qsPickedTotals() {
    var prices = qt.prices || window.user_prices || {};
    var execd = qt.exec || window.execution_data || {};
    var rates = window.hourlyRatesMap || {};
    var subs = qsTakenSubs();
    var rows = qsRows();
    var unit = (function () {
      var el = document.getElementById('unitSelector');
      return (el && el.getAttribute('data-current-unit')) || 'metric';
    })();

    var num = function (v) {
      if (v === undefined || v === null || v === '') return 0;
      var n = parseFloat(String(v).replace(',', '.'));
      return isFinite(n) ? n : 0;
    };

    var mat = 0, mins = 0, money = 0, seen = false;

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (!row || !row[0] || !row[2]) continue;
      var sub = String(row[2]);
      var ids2 = qt.pickedIds || null;
      if (ids2 && ids2[row[0]] !== undefined) { if (!ids2[row[0]]) continue; }
      else if (!subs[sub]) continue;
      seen = true;

      var mu = num(row[10]);
      var iu = num(row[11]);
      var units = (unit === 'metric') ? mu : iu;

      if (qsOwnPrice(prices, row[0])) {
        var base = num(prices[row[0]]);
        if (unit !== 'metric' && mu > 0 && iu > 0) base = (base * mu) / iu;
        mat += base * units;
      }

      var rate = rates[sub];
      if (rate === undefined) rate = rates[sub.toLowerCase()];
      var rn = parseFloat(rate);
      if (!isFinite(rn) || rn <= 0) continue;

      var dur = num(execd[row[0] + '_duration']) || num(row[23]);
      var wrk = num(execd[row[0] + '_workers']) || num(row[26]) || 1;
      var m = dur * wrk;
      if (unit !== 'metric' && mu > 0 && iu > 0) m = (m * mu) / iu;
      m = m * units;
      mins += m;
      money += (rn / 60) * m;
    }

    if (!seen) return { material: null, execution: null, hours: null };
    return { material: mat, execution: money, hours: mins / 60 };
  }

  /* prof-v282: the priced lines the quote carries, by the same arithmetic as
     qsPickedTotals (so the card adds up to what is sent): unit price per
     the unit on screen, times the material coefficient. Biggest first. */
  function qsCardLines(k) {
    var prices = qt.prices || window.user_prices || {};
    var subs = qsTakenSubs();
    var rows = qsRows();
    var ids2 = qt.pickedIds || null;
    var unit = (function () {
      var el = document.getElementById('unitSelector');
      return (el && el.getAttribute('data-current-unit')) || 'metric';
    })();
    var num = function (v) {
      if (v === undefined || v === null || v === '') return 0;
      var n = parseFloat(String(v).replace(',', '.'));
      return isFinite(n) ? n : 0;
    };
    var out = [];
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (!row || !row[0] || !row[2]) continue;
      if (ids2 && ids2[row[0]] !== undefined) { if (!ids2[row[0]]) continue; }
      else if (!subs[String(row[2])]) continue;
      if (!qsOwnPrice(prices, row[0])) continue;
      var mu = num(row[10]), iu = num(row[11]);
      var units = (unit === 'metric') ? mu : iu;
      var base = num(prices[row[0]]);
      if (unit !== 'metric' && mu > 0 && iu > 0) base = (base * mu) / iu;
      out.push({
        row: row, units: units, unitName: String((unit === 'metric' ? row[12] : row[13]) || row[12] || '').toLowerCase(),
        unitPrice: base * k, line: base * units * k
      });
    }
    out.sort(function (a, b) { return b.line - a.line; });
    return out;
  }

  function qsMoney(n, dec) {
    n = Number(n) || 0;
    if (!dec && typeof window.formatPrice === 'function') {
      try { return window.formatPrice(Math.round(n)); } catch (e) {}
    }
    var cur = 'USD';
    try { cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'; } catch (e2) {}
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur,
        minimumFractionDigits: dec ? 2 : 0, maximumFractionDigits: dec ? 2 : 0 }).format(dec ? n : Math.round(n));
    } catch (e3) { return dec ? n.toFixed(2) : String(Math.round(n)); }
  }

  function qsTakenIds() {
    var prices = qt.prices || window.user_prices || {};
    var subs = qsTakenSubs();
    var ids = qt.pickedIds || null;
    var rows = qsRows();
    var out = [];
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (!row || !row[0] || !row[2]) continue;
      /* A line is offered only if its own box is ticked. The subcategory
         is still consulted for anything predating line-level choice. */
      if (ids && ids[row[0]] !== undefined) { if (!ids[row[0]]) continue; }
      else if (!subs[String(row[2])]) continue;
      if (!qsOwnPrice(prices, row[0])) continue;
      out.push(row[0]);
    }
    return out;
  }

  function qsTakenSubs() {
    var out = {};
    var picked = qt.picked || null;
    var offered = qt.offered || [];
    var ids = qt.pickedIds || null;

    for (var i = 0; i < offered.length; i++) {
      var e = offered[i];
      if (ids) {
        var rows = e.all || [];
        for (var r = 0; r < rows.length; r++) {
          if (rows[r] && ids[rows[r][0]]) { out[e.sub] = true; break; }
        }
        continue;
      }
      if (!picked || picked[e.sub]) out[e.sub] = true;
    }
    return out;
  }

  /* Sending works from two places: the bar on the project, and the form
     in Offers. It therefore reports back to whoever called it instead of
     assuming the bar is on screen. */
  function sendQuote(done) {
    if (!window.db || (!qt.id && !qt.unsolicited)) { if (done) done(new Error('no request')); return; }
    // an unprompted offer needs somewhere to go, and it is read on send
    if (qt.unsolicited && (!qt.offerTo || !qt.offerTo.length)) {
      if (done) done(new Error(T.rq.needEmail || 'no recipient'));
      return;
    }
    if (!window.customerId) {
      // looking around never needed an account; sending does
      askToRegister();
      if (done) done(new Error('not signed in'));
      return;
    }

    /* The hourly rates were missing from the offer, so execution was
       priced with the reader's own rate and the total never matched what
       the vendor saw. They are fetched, multiplied and sent along. */
    if (typeof window.getExternalBudgetData === 'function') {
      window.getExternalBudgetData(String(window.customerId), true)
        .then(function (mine) {
          writeQuote(scaleRates(wholeRatePicture((mine && mine.hourlyRatesByCategory) || {})), done);
        })
        .catch(function () { writeQuote(scaleRates(wholeRatePicture({})), done); });
      return;
    }
    writeQuote(scaleRates(wholeRatePicture({})), done);
  }

  /* The saved profile holds only the categories a vendor actually set.
     Everything left on the house rate was never stored, so it never
     travelled, and the reader priced it with their own rate instead.
     The live map has every category, so it fills the gaps, and the
     vendor's own fallback rate rides along under __default. */
  function wholeRatePicture(saved) {
    var out = {};
    var cat;
    var subs = qsTakenSubs();
    var keep = function (name) {
      var s = String(name || '');
      if (subs[s]) return true;
      for (var q in subs) {
        if (Object.prototype.hasOwnProperty.call(subs, q)
          && String(q).toLowerCase() === s.toLowerCase()) return true;
      }
      return false;
    };

    for (cat in saved) {
      if (!Object.prototype.hasOwnProperty.call(saved, cat)) continue;
      if (!keep(cat)) continue;
      out[String(cat).toLowerCase()] = saved[cat];
    }
    var live = window.hourlyRatesMap || {};
    for (cat in live) {
      if (!Object.prototype.hasOwnProperty.call(live, cat)) continue;
      if (!keep(cat)) continue;
      var key = String(cat).toLowerCase();
      if (out[key] !== undefined) continue;
      var n = Number(live[cat]);
      if (isFinite(n) && n > 0) out[key] = n;
    }

    /* NO HOUSE RATE ANY MORE. It existed so a category the offer did not
       mention still had something to price with -- but an offer that says
       nothing about a category is not offering it, and inventing a rate is
       how a joiner ended up quoting the plumbing. */
    return out;
  }

  function vendorFallbackRate() {
    var pv = document.getElementById('preferred-vendor');
    if (pv) {
      var n = parseFloat((pv.textContent || '').replace(/[^0-9.,-]/g, '').replace(',', '.'));
      if (isFinite(n) && n > 0) return n;
    }
    var fx = 1;
    try { if (window.Shopify && window.Shopify.currency) fx = Number(window.Shopify.currency.rate) || 1; } catch (e) {}
    return 10 * fx;
  }

  function scaleRates(rates) {
    var r = (isFinite(qt.rateCoef) && qt.rateCoef > 0) ? qt.rateCoef : 1;
    var out = {};
    for (var cat in rates) {
      if (!Object.prototype.hasOwnProperty.call(rates, cat)) continue;
      var src = rates[cat];
      if (src === null || src === undefined) continue;

      if (typeof src !== 'object') {
        var flat = Number(src);
        out[cat] = (isFinite(flat) && flat > 0 && r !== 1) ? flat * r : src;
        continue;
      }

      var copy = {};
      for (var k in src) {
        if (!Object.prototype.hasOwnProperty.call(src, k)) continue;
        var n = Number(src[k]);
        // an hourly rate is money and moves; anything else is left alone
        copy[k] = (r !== 1 && isFinite(n) && n > 0) ? n * r : src[k];
      }
      out[cat] = copy;
    }
    return out;
  }

  function writeOffer(rates, snap, until, done) {
    var km = (isFinite(qt.coef) && qt.coef > 0) ? qt.coef : 1;
    var kr = (isFinite(qt.rateCoef) && qt.rateCoef > 0) ? qt.rateCoef : 1;
    var t = qsPickedTotals();
    var id = offerId();
    var url = projectUrl(id, 'leva_offer');

    var payload = {
      status: 'sent',
      createdAt: new Date(),
      fromEmail: String(window.customerEmail || '').toLowerCase(),
      fromCustomerId: String(window.customerId),
      fromName: qt.vendorName || '',
      fromPhone: qt.vendorPhone || '',
      toEmails: qt.offerTo || [],
      note: qt.offerNote || '',
      projectUrl: url,
      productHandle: (window.shareProductContext && window.shareProductContext.handle) || '',
      configId: cfgOfPage(),
      cfg: cfgOfPage(),
      validUntil: until,
      coefficient: km,
      rateCoefficient: kr,
      hourlyRatesByCategory: rates,
      materials: snap.materials,
      execution: snap.execution,
      subcategories: Object.keys(qsTakenSubs()),
      vendorTotals: {
        material: (t.material === null) ? null : t.material * km,
        execution: (t.execution === null) ? null : t.execution * kr,
        time: (t.hours === null) ? null : Math.round(t.hours),
        rawMaterial: t.material,
        rawExecution: t.execution,
        coefficient: km,
        rateCoefficient: kr
      }
    };

    window.db.collection('offers').doc(id).set(payload).then(function () {
      var body = ''
        + (payload.fromName ? (payload.fromName + '\n\n') : '')
        + (payload.note ? (payload.note + '\n\n') : '')
        + (payload.fromPhone ? ('Phone: ' + payload.fromPhone + '\n') : '')
        + 'Email: ' + payload.fromEmail + '\n'
        + '\n' + url + '\n';
      var subject = T.rq.quoteSubject;
      var name = projectName();
      if (name) subject += ': ' + name;
      window.location.href = 'mailto:' + encodeURIComponent((qt.offerTo || []).join(','))
        + '?subject=' + encodeURIComponent(subject)
        + '&body=' + encodeURIComponent(body);
      if (done) done(null);
    }).catch(function (e) { if (done) done(e); });
  }

  /* bic-v187 AN ANSWER TO A REQUEST SENT TO SEVERAL SUPPLIERS. They all got
     the same link (one mail, Bcc), so the request record cannot hold the
     answer -- the second would overwrite the first. Each supplier's answer
     is an offers record of its own, the same fields an unprompted offer
     carries (writeOffer), addressed to the requester, tied to the request
     by requestId, its id fixed per supplier so answering again replaces
     the earlier answer. The requester's Offers tab shows it as an offer;
     LevaThreads.list reads it as a priced answer to compare. The request
     itself stays pending for the others. */
  function writeGroupAnswer(rates, snap, until, done) {
    var km = (isFinite(qt.coef) && qt.coef > 0) ? qt.coef : 1;
    var kr = (isFinite(qt.rateCoef) && qt.rateCoef > 0) ? qt.rateCoef : 1;
    var t = qsPickedTotals();
    var me = String(window.customerEmail || '').toLowerCase();
    var id = 'qa_' + String(qt.id) + '_' + me.replace(/[^a-z0-9]/g, '_').slice(0, 60);
    var url = (qt.doc && qt.doc.projectUrl) || window.location.href;
    try {
      var u = new URL(url);
      u.searchParams.delete('leva_quote');
      u.searchParams.set('leva_offer', id);
      url = u.toString();
    } catch (eU) {}
    var payload = {
      status: 'sent',
      createdAt: new Date(),
      answeredAt: new Date(),
      requestId: String(qt.id),
      fromEmail: me,
      fromCustomerId: String(window.customerId),
      fromName: qt.vendorName || '',
      fromPhone: qt.vendorPhone || '',
      toEmails: [String((qt.doc && qt.doc.fromEmail) || '').toLowerCase()],
      note: '',
      projectUrl: url,
      productHandle: (qt.doc && qt.doc.productHandle) || (window.shareProductContext && window.shareProductContext.handle) || '',
      configId: cfgOfPage(),
      cfg: cfgOfPage(),
      validUntil: until,
      coefficient: km,
      rateCoefficient: kr,
      hourlyRatesByCategory: rates,
      materials: snap.materials,
      execution: snap.execution,
      subcategories: Object.keys(qsTakenSubs()),
      vendorTotals: {
        material: (t.material === null) ? null : t.material * km,
        execution: (t.execution === null) ? null : t.execution * kr,
        time: (t.hours === null) ? null : Math.round(t.hours),
        rawMaterial: t.material,
        rawExecution: t.execution,
        coefficient: km,
        rateCoefficient: kr
      }
    };
    window.db.collection('offers').doc(id).set(payload).then(function () {
      qt.doc = qt.doc || {};
      qt.doc.status = 'answered';
      var bar = document.querySelector('.rq-bar');
      if (bar) {
        bar.querySelector('.rq-bar__txt').textContent = T.rq.quoteSent;
        var bs = bar.querySelectorAll('.rq-bar__b');
        for (var i = 0; i < bs.length; i++) bs[i].hidden = true;
      }
      restoreBudget();
      if (done) done(null);
      offerProfile(snap);
    }).catch(function (err) {
      console.error('group answer save failed', err);
      if (done) done(err);
    });
  }

  function writeQuote(rates, done) {
    var snap = collectQuote();
    var until = new Date();
    until.setDate(until.getDate() + (qt.validDays || 30));

    /* THE SAME SHEET, SENT THE OTHER WAY. A vendor who has not been asked
       still wants to price a project and put it in front of somebody --
       the pricing is identical, only the destination differs, so the sheet
       is shared and the record it writes is not. */
    if (qt.unsolicited) { writeOffer(rates, snap, until, done); return; }
    /* bic-v187: one request, several suppliers, one link -- every answer
       its own record, so a second supplier never writes over the first */
    if (qt.doc && qt.doc.vendorEmails && qt.doc.vendorEmails.length > 1) { writeGroupAnswer(rates, snap, until, done); return; }

    // answering twice is an actualisation, and the other side should see it
    var already = qt.doc && (qt.doc.status === 'answered' || qt.doc.answeredAt);
    var patch = {
      status: 'answered',
      answeredAt: new Date(),
      validUntil: until,
      coefficient: (isFinite(qt.coef) && qt.coef > 0) ? qt.coef : 1,
      rateCoefficient: (isFinite(qt.rateCoef) && qt.rateCoef > 0) ? qt.rateCoef : 1,
      hourlyRatesByCategory: rates,
      vendorId: String(window.customerId),
      vendorEmail: String(window.customerEmail || '').toLowerCase(),
      vendorName: qt.vendorName || '',
      vendorPhone: qt.vendorPhone || '',
      materials: snap.materials,
      execution: snap.execution,
      cfg: cfgOfPage(),
      /* Scaled on the way out. The prices in the snapshot already carry
         the coefficient, so a raw screen total would be compared against
         a multiplied one and every check would read as a mismatch. Time
         carries no coefficient and travels as it is. */
      subcategories: Object.keys(qsTakenSubs()),
      vendorTotals: (function () {
        var km = (isFinite(qt.coef) && qt.coef > 0) ? qt.coef : 1;
        var kr = (isFinite(qt.rateCoef) && qt.rateCoef > 0) ? qt.rateCoef : 1;
        var t = qsPickedTotals();
        return {
          material: (t.material === null) ? null : t.material * km,
          execution: (t.execution === null) ? null : t.execution * kr,
          time: (t.hours === null) ? null : Math.round(t.hours),
          rawMaterial: t.material,
          rawExecution: t.execution,
          coefficient: km,
          rateCoefficient: kr
        };
      })()
    };
    if (already) patch.actualisedAt = new Date();

    /* A SECOND ANSWER MUST REPLACE THE FIRST, NOT JOIN IT. set with merge
       goes key by key into a map, so a narrower offer poured itself into
       the wide one already on the record and every line the vendor had
       just deselected stayed exactly where it was. The three maps are
       cleared first, then written; everything else on the record -- who
       asked, when, the address -- is left alone. */
    var ref = window.db.collection('quotes').doc(String(qt.id));
    var wipe = {};
    try {
      var del = window.firebase.firestore.FieldValue.delete();
      wipe = { materials: del, execution: del, hourlyRatesByCategory: del };
    } catch (e) { wipe = null; }

    (wipe ? ref.set(wipe, { merge: true }) : Promise.resolve())
      .catch(function () {})
      .then(function () { return ref.set(patch, { merge: true }); })
      .then(function () {
      qt.doc = qt.doc || {};
      qt.doc.status = 'answered';
      var bar = document.querySelector('.rq-bar');
      if (bar) {
        bar.querySelector('.rq-bar__txt').textContent = T.rq.quoteSent;
        var bs = bar.querySelectorAll('.rq-bar__b');
        for (var i = 0; i < bs.length; i++) bs[i].hidden = true;
      }
      restoreBudget();
      if (done) done(null);
      offerProfile(snap);
    }).catch(function (err) {
      console.error('quote save failed', err);
      if (done) done(err);
    });
  }

  // the account exists by now, so the offer costs one tap
  function offerProfile(snap) {
    if (!window.LevaProfile || !window.db || !window.customerId) return;
    confirmImp(function () {
      window.db.collection('public_data').doc(String(window.customerId))
        .set({ profile: { is_vendor: 'yes' } }, { merge: true })
        .catch(function () {});
    });
  }

  function askToRegister() {
    var old = document.getElementById('vdr-confirm');
    if (old) old.parentNode.removeChild(old);
    var wrap = document.createElement('div');
    wrap.id = 'vdr-confirm';
    wrap.innerHTML = ''
      + '<div class="vdr-c__box">'
      + '  <div class="vdr-c__title">' + T.rq.quoteLoginTitle + '</div>'
      + '  <div class="rq-msg" style="margin-bottom:14px;">' + T.rq.quoteLoginText + '</div>'
      + '  <div class="vdr-c__col">'
      + '    <button type="button" class="vdr-c__btn" data-c-no>' + T.rq.cancel + '</button>'
      + '    <button type="button" class="vdr-c__btn vdr-c__btn--ok" data-c-go>' + T.rq.quoteLoginCta + '</button>'
      + '  </div>'
      + '</div>';
    document.body.appendChild(wrap);
    function shut() { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }
    wrap.addEventListener('click', function (e) { if (e.target === wrap) shut(); });
    wrap.querySelector('[data-c-no]').addEventListener('click', shut);
    wrap.querySelector('[data-c-go]').addEventListener('click', function () {
      window.location.href = '/account/register?return_url='
        + encodeURIComponent(window.location.pathname + window.location.search);
    });
  }

  function showQuoteBar(id, doc) {
    rqStyle();
    var old = document.querySelector('.rq-bar');
    if (old) old.parentNode.removeChild(old);

    var bar = document.createElement('div');
    bar.className = 'rq-bar';

    var txt = document.createElement('div');
    txt.className = 'rq-bar__txt';
    txt.textContent = T.rq.quotePrompt;
    var who = document.createElement('span');
    who.className = 'rq-bar__who';
    who.textContent = [doc.phone, doc.place].filter(Boolean).join('  |  ');
    txt.appendChild(who);
    bar.appendChild(txt);

    // no is an answer in itself and needs no form
    var no = document.createElement('button');
    no.type = 'button';
    no.className = 'rq-bar__b rq-bar__b--no';
    no.title = T.rq.no;
    no.appendChild(tick('no'));
    no.addEventListener('click', function () {
      confirmYesNo(function () {
        /* bic-v188: on a shared request NO is this supplier's alone */
        var mk = groupKey(myMail());
        var nope = null;
        if (doc && doc.vendorEmails && doc.vendorEmails.length > 1) {
          /* nobody signed in: the bar goes, the request stays for the others */
          if (mk && isForMe(doc)) { nope = { declinedBy: {} }; nope.declinedBy[mk] = new Date(); }
        } else nope = { status: 'declined', decidedAt: new Date() };
        if (nope) window.db.collection('quotes').doc(String(id))
          .set(nope, { merge: true })
          .catch(function () {});
        restoreBudget();
        if (bar.parentNode) bar.parentNode.removeChild(bar);
      });
    });
    bar.appendChild(no);

    // yes opens the sheet where the pricing actually happens
    var yes = document.createElement('button');
    yes.type = 'button';
    yes.className = 'rq-bar__b rq-bar__b--yes';
    yes.title = T.rq.quoteSend;
    yes.appendChild(tick('yes'));
    yes.addEventListener('click', function () { openQuoteSheet(id, doc); });
    bar.appendChild(yes);

    document.body.appendChild(bar);
  }

  /* The pricing sheet: the budget as usual, with a header that decides
     where the numbers start from, what they are multiplied by and how
     long the offer holds. */
  function openQuoteSheet(id, doc) {
    var d = document.getElementById('Leva-Quotes-Drawer');
    if (!d) return;
    qTab = 'offers';
    qt.id = id;
    qt.doc = doc;
    qt.unsolicited = false;
    raise(d);
    closeShareDrawer();
    close();
    paintQuotes(d);
    d.classList.add('active');
    document.body.classList.add('open-cc');
  }

  /* Where the numbers start from, what they are multiplied by, how long
     the offer holds. Used by the sheet and by the row in Offers, so the
     two can never drift apart. */
  /* The vendor prices with the budget they already have on screen --
     theirs if they keep one, blank if they do not. A coefficient lifts
     or lowers it, applied once when the offer is sent, so what is stored
     is plain numbers. Nothing is recalculated per visitor later. */
  /* ============================================================
     WHAT A VENDOR IS ACTUALLY OFFERING
     A quote used to carry the whole bill of quantities, so a joiner who
     priced the framing appeared to be quoting the roof, the permits and
     the cleanup as well -- at whatever the catalogue happened to say.
     An offer now carries only the work its sender put a figure on: their
     own hourly rate on a subcategory, their own price on a line. What
     they never touched is not in the offer at all, and nothing of the
     reader's is folded in to fill the gap.
     RATES ARE PER SUBCATEGORY, PRICES ARE PER LINE, which is why a
     subcategory can travel as labour only, as material only, or as both.
     ============================================================ */
  /* ============================================================
     THE NAMES THE BUDGET USES
     Category and subcategory were being read straight out of the row --
     columns 1 and 2 -- which are the English originals. The budget never
     reads those: every language has its own pair of columns in the same
     row, and the budget picks them by locale. So the tree showed English
     next to a Czech budget, on data that had the Czech in it all along.
     Same table, same columns, same rule.
     ============================================================ */
  var LANG_COL = {
    EN: 0, AR: 28, CS: 29, DE: 30, EL: 31, ES: 32, FI: 33, FR: 34,
    HE: 35, HU: 36, IT: 37, JA: 38, KO: 39, NL: 40, NO: 41, PL: 42,
    PT: 43, RO: 44, RU: 45, SK: 46, SV: 47, TR: 48, UK: 49, ZH: 50
  };

  function langCol() {
    var l = 'en';
    try {
      if (typeof Shopify !== 'undefined' && Shopify.locale) l = Shopify.locale;
    } catch (e) {}
    var idx = LANG_COL[String(l).toUpperCase()];
    return (idx === undefined || idx === null) ? 0 : idx;
  }

  /* The subcategory sits twenty columns after its category, the way
     getNamesForHeading reads it. */
  function rowCat(row, fallback) {
    var i = langCol();
    if (!i) return String((row && row[1]) || fallback || '');
    return String((row && row[i]) || (row && row[1]) || fallback || '');
  }

  function rowSub(row, fallback) {
    var i = langCol();
    if (!i) return String((row && row[2]) || fallback || '');
    return String((row && row[i + 20]) || (row && row[2]) || fallback || '');
  }

  /* The card list and the filter live in another block of this file, so
     the pair is published rather than duplicated. */
  window.__levaRowCat = rowCat;
  window.__levaRowSub = rowSub;

  /* The line's own name, in the reader's language: same row, the column
     the budget uses for titles. */
  function rowItem(row) {
    var i = langCol();
    var t = '';
    if (i && row && row[i + 40]) t = String(row[i + 40]);
    else t = String((row && row[3]) || (row && row[0]) || '');
    // the budget strips the pi marker: the size is shown on its own line
    return t.replace(/\u03c0/g, '').replace(/\s{2,}/g, ' ').trim();
  }
  window.__levaRowItem = rowItem;

  function qsRows() {
    if (Object.prototype.toString.call(window.productData) === '[object Array]'
      && window.productData.length) return window.productData;
    var out = [];
    var m = window.productDataMap || {};
    for (var k in m) {
      if (!Object.prototype.hasOwnProperty.call(m, k)) continue;
      if (Object.prototype.toString.call(m[k]) === '[object Array]') out = out.concat(m[k]);
    }
    return out;
  }

  /* A PRICE THIS VENDOR STANDS BEHIND. The first cut of this asked for
     lines with no _source marker -- meaning typed here and nowhere else --
     and in a real budget that is almost nothing: the marker records where
     a figure came from, not whose it is. A vendor who took a price list
     from a merchant and works from it is quoting that price. So the test
     is simply whether the line has a price on their sheet at all; what
     they left blank is what they are not offering. */
  function qsOwnPrice(prices, id) {
    if (!id) return false;
    var v = prices[id];
    if (v === undefined || v === null || v === '') return false;
    var n = parseFloat(String(v).replace(',', '.'));
    return isFinite(n) && n > 0;
  }

  function qsOwnRate(sub) {
    var map = window.hourlyRatesMap || {};
    var key = String(sub || '');
    var v = map[key];
    if (v === undefined) v = map[key.toLowerCase()];
    if (v && typeof v === 'object') return false;
    var n = parseFloat(v);
    return isFinite(n) && n > 0;
  }

  /* One entry per subcategory the vendor has something to say about. */
  function qsOffered() {
    var prices = qt.prices || window.user_prices || {};
    var rows = qsRows();
    var map = {};
    var order = [];
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (!row || !row[0] || !row[2]) continue;
      var sub = String(row[2]);
      if (!map[sub]) {
        /* The key stays English -- rates, prices and saved lists are all
           keyed by it -- and only what the reader sees is translated. */
        map[sub] = {
          sub: sub, label: rowSub(row, sub), cat: rowCat(row, ''),
          rate: qsOwnRate(sub), ids: [], all: []
        };
        order.push(sub);
      }
      map[sub].all.push(row);
      if (qsOwnPrice(prices, row[0])) map[sub].ids.push(row[0]);
    }
    var out = [];
    for (var j = 0; j < order.length; j++) {
      var e = map[order[j]];
      if (e.rate || e.ids.length) out.push(e);
    }
    return out;
  }

  /* ============================================================
     ONE PICKER, TWO PLACES
     The tree in the quote sheet is the one the vendor already knows, so
     the sharing panel gets that exact code rather than a second version
     of it -- same classes, same markup, same behaviour. Rebuilding it by
     hand produced something that looked almost right and then collided
     with whatever CSS surrounded it.
     ============================================================ */
  /* ITEMS DECIDE, NOT SUBCATEGORIES. Insulation covers the floor, the
     walls and the roof under one name, and a vendor who only does roofs
     was made to offer all three. The tick therefore goes on the line
     itself; a subcategory is the switch for its own lines and shows half
     a tick when only some are on. */
  function buildPickTree(offered, picked, onChange, pickedIds) {
    var pickWrap = document.createElement('div');
    pickWrap.className = 'qs-pick';

    if (!offered.length) {
      var none = document.createElement('div');
      none.className = 'qs-pick__none';
      none.textContent = (T.rq && T.rq.qNothing)
        || 'Nothing priced yet. Set an hourly rate or a material price and it appears here.';
      pickWrap.appendChild(none);
      return pickWrap;
    }

    var byCat = {};
    var catOrder = [];
    for (var oi = 0; oi < offered.length; oi++) {
      var e = offered[oi];
      if (picked[e.sub] === undefined) picked[e.sub] = true;
      if (!byCat[e.cat]) { byCat[e.cat] = []; catOrder.push(e.cat); }
      byCat[e.cat].push(e);
    }

    for (var ci = 0; ci < catOrder.length; ci++) {
      (function (cat) {
        var group = document.createElement('div');
        group.className = 'qs-pick__g';

        var head2 = document.createElement('div');
        head2.className = 'qs-pick__cat';
        var all = document.createElement('input');
        all.type = 'checkbox';
        all.addEventListener('click', function (ev) { ev.stopPropagation(); });
        head2.appendChild(all);
        head2.appendChild(document.createTextNode(cat.toUpperCase()));

        var cnt = document.createElement('span');
        cnt.className = 'qs-pick__n';
        cnt.textContent = byCat[cat].length + ' x';
        head2.appendChild(cnt);

        var car = document.createElement('span');
        car.className = 'qs-pick__car';
        car.textContent = '>';
        head2.appendChild(car);
        head2.addEventListener('click', function () { group.classList.toggle('is-open'); });
        group.appendChild(head2);

        var body = document.createElement('div');
        body.className = 'qs-pick__body';
        var kids = [];

        for (var si = 0; si < byCat[cat].length; si++) {
          (function (entry) {
            var l = document.createElement('label');
            l.className = 'qs-pick__s';
            var itemBoxes = [];
            var syncGroup = function () {
              var on = 0;
              var half = 0;
              for (var q = 0; q < kids.length; q++) {
                if (kids[q].checked) on++;
                else if (kids[q].indeterminate) half++;
              }
              all.checked = (on === kids.length && kids.length > 0);
              all.indeterminate = (!all.checked && (on > 0 || half > 0));
            };

            var cb = document.createElement('input');
            cb.type = 'checkbox';
            cb.checked = !!picked[entry.sub];
            cb.addEventListener('click', function (ev) { ev.stopPropagation(); });
            cb.addEventListener('change', function () {
              picked[entry.sub] = cb.checked;
              cb.indeterminate = false;
              for (var w = 0; w < itemBoxes.length; w++) {
                itemBoxes[w].checked = cb.checked;
                if (pickedIds && entry.all && entry.all[w]) {
                  pickedIds[entry.all[w][0]] = cb.checked;
                }
              }
              syncGroup();
              if (onChange) onChange(picked, pickedIds);
            });
            kids.push(cb);
            l.appendChild(cb);
            l.appendChild(document.createTextNode(entry.label || entry.sub));

            var tag = document.createElement('span');
            tag.className = 'qs-pick__tag';
            tag.textContent = [
              entry.rate ? ((T.rq && T.rq.execution) || 'Execution') : '',
              entry.ids && entry.ids.length
                ? (entry.ids.length + ' x ' + ((T.rq && T.rq.materials) || 'Materials'))
                : ''
            ].filter(Boolean).join(' + ');
            l.appendChild(tag);

            /* THE THIRD LEVEL. A subcategory is still a group of things,
               and stopping there left the reader guessing which of them a
               vendor actually prices. The lines open underneath, read
               only: what travels is decided one level up, and showing a
               tick beside a line nobody can untick would be a lie. */
            var lines = entry.all || [];
            if (lines.length) {
              var caret = document.createElement('span');
              caret.className = 'qs-pick__car qs-pick__car--sub';
              caret.textContent = '>';
              l.appendChild(caret);

              var kidsBox = document.createElement('div');
              kidsBox.className = 'qs-pick__i';

              for (var li = 0; li < lines.length; li++) {
                var row3 = lines[li];
                if (!row3 || !row3[0]) continue;
                (function (r3) {
                  var one = document.createElement('label');
                  one.className = 'qs-pick__it';

                  var icb = document.createElement('input');
                  icb.type = 'checkbox';
                  if (pickedIds && pickedIds[r3[0]] === undefined) pickedIds[r3[0]] = !!picked[entry.sub];
                  icb.checked = pickedIds ? !!pickedIds[r3[0]] : !!picked[entry.sub];
                  icb.addEventListener('click', function (ev) { ev.stopPropagation(); });
                  icb.addEventListener('change', function () {
                    if (pickedIds) pickedIds[r3[0]] = icb.checked;
                    var on = 0;
                    for (var w = 0; w < itemBoxes.length; w++) if (itemBoxes[w].checked) on++;
                    cb.checked = (on === itemBoxes.length && itemBoxes.length > 0);
                    cb.indeterminate = (on > 0 && on < itemBoxes.length);
                    picked[entry.sub] = on > 0;
                    syncGroup();
                    if (onChange) onChange(picked, pickedIds);
                  });
                  itemBoxes.push(icb);
                  one.appendChild(icb);

                  var nm = document.createElement('span');
                  nm.className = 'qs-pick__itn';
                  nm.textContent = (window.__levaRowItem
                    ? window.__levaRowItem(r3)
                    : String(r3[3] || r3[0]));
                  one.appendChild(nm);

                  var code = document.createElement('span');
                  code.className = 'qs-pick__itc';
                  code.textContent = r3[0];
                  one.appendChild(code);

                  kidsBox.appendChild(one);
                })(row3);
              }

              l.addEventListener('click', function (ev) {
                if (ev.target && ev.target.tagName === 'INPUT') return;
                ev.preventDefault();
                var p = this.parentNode;
                if (p) p.classList.toggle('is-open');
              });

              var pair = document.createElement('div');
              pair.className = 'qs-pick__pair';
              pair.appendChild(l);
              pair.appendChild(kidsBox);
              body.appendChild(pair);
              return;
            }

            body.appendChild(l);
          })(byCat[cat][si]);
        }

        var on0 = 0;
        for (var q0 = 0; q0 < kids.length; q0++) if (kids[q0].checked) on0++;
        all.checked = (kids.length > 0 && on0 === kids.length);
        all.indeterminate = (on0 > 0 && on0 < kids.length);

        all.addEventListener('change', function () {
          for (var q = 0; q < kids.length; q++) {
            kids[q].checked = all.checked;
            kids[q].indeterminate = false;
            picked[byCat[cat][q].sub] = all.checked;
            var rows3 = byCat[cat][q].all || [];
            for (var r = 0; r < rows3.length; r++) {
              if (pickedIds && rows3[r] && rows3[r][0]) pickedIds[rows3[r][0]] = all.checked;
            }
          }
          all.indeterminate = false;
          if (onChange) onChange(picked, pickedIds);
        });

        // the lines inside are rebuilt above; reflect them once at the start
        for (var gz = 0; gz < kids.length; gz++) {
          var subRows = byCat[cat][gz].all || [];
          var onZ = 0;
          for (var rz = 0; rz < subRows.length; rz++) {
            if (pickedIds && pickedIds[subRows[rz][0]]) onZ++;
          }
          if (subRows.length && pickedIds) {
            kids[gz].checked = (onZ === subRows.length);
            kids[gz].indeterminate = (onZ > 0 && onZ < subRows.length);
          }
        }

        group.appendChild(body);
        pickWrap.appendChild(group);
      })(catOrder[ci]);
    }

    return pickWrap;
  }

  function buildQuoteFields(box) {
    var head = document.createElement('div');
    head.className = 'qs-head';

    var h = document.createElement('div');
    h.className = 'qs-head__t';
    h.textContent = T.rq.qHead;
    head.appendChild(h);

    /* A price with no name on it is a number from an address. The sender
       gives their name and phone with the enquiry, so the answer says the
       same two things back -- prefilled from the profile when there is
       one, and remembered on the offer either way. */
    function qsField(labelText, value, type) {
      var l = document.createElement('label');
      l.className = 'qs-field';
      l.textContent = labelText;
      var i = document.createElement('input');
      i.type = type || 'text';
      i.value = value || '';
      l.appendChild(i);
      head.appendChild(l);
      return i;
    }

    var vName = qsField((T.rq && T.rq.myName) || 'Name', rqMeVal('name'));
    var vPhone = qsField(T.rq.myPhone, rqMeVal('phone'), 'tel');
    vName.addEventListener('change', function () { rqMeSet('name', vName.value); });
    vPhone.addEventListener('change', function () { rqMeSet('phone', vPhone.value); });

    /* Grouped under their categories, because a trade is a handful of
       neighbouring subcategories and nobody wants to tick eight boxes to
       say "the carpentry". Everything starts on, since a vendor who
       priced it presumably means to offer it. */
    var offered = qsOffered();
    var picked = {};
    var recount = function () {};

    /* What the vendor already declared for this product decides what comes
       up ticked; without a declaration, everything priced is offered. */
    if (window.__levaSavedTrades && window.__levaSavedTrades.length) {
      var declared = {};
      for (var dz = 0; dz < window.__levaSavedTrades.length; dz++) {
        declared[String(window.__levaSavedTrades[dz]).toLowerCase()] = true;
      }
      for (var oz = 0; oz < offered.length; oz++) {
        picked[offered[oz].sub] = !!declared[offered[oz].sub.toLowerCase()];
      }
    }

    qt.pickedIds = {};
    var pickWrap = buildPickTree(offered, picked, function () { recount(); }, qt.pickedIds);

    head.appendChild(pickWrap);
    qt.picked = picked;
    qt.offered = offered;

    // a slider, like the travel radius on the vendor profile
    /* The vendor slider is a bare label with the value in <b> and a plain
       range inside, sitting in .leva-prof-vendor inside .leva-prof-drawer.
       This is that markup, character for character, so the two cannot
       look different -- no classes of my own, nothing to drift. */
    var vendorBox = document.createElement('div');
    vendorBox.className = 'leva-prof-drawer';
    var vendorIn = document.createElement('div');
    vendorIn.className = 'leva-prof-vendor';
    vendorBox.appendChild(vendorIn);

    var coefWrap = document.createElement('label');
    var coefLab = document.createTextNode(T.rq.qCoef + ' ');
    var coefOut = document.createElement('b');
    coefWrap.appendChild(coefLab);
    coefWrap.appendChild(coefOut);

    var coef = document.createElement('input');
    coef.type = 'range';
    coef.min = '0.7';
    coef.max = '2';
    coef.step = '0.05';
    var startK = Number(prefs().coef);
    coef.value = String(isFinite(startK) && startK >= 0.7 && startK <= 2 ? startK : 1);
    coefWrap.appendChild(coef);

    vendorIn.appendChild(coefWrap);

    var matOut = document.createElement('div');
    matOut.className = 'qs-sub qs-sub--mat';
    vendorIn.appendChild(matOut);

    /* Two rates travel with an offer: what the materials cost and what an
       hour of work costs. They move independently, so each has its own
       slider; time and head count are facts of the build and never move. */
    var rateWrap = document.createElement('label');
    rateWrap.appendChild(document.createTextNode(T.rq.qCoefRate + ' '));
    var rateOut = document.createElement('b');
    rateWrap.appendChild(rateOut);

    var rate = document.createElement('input');
    rate.type = 'range';
    rate.min = '0.7';
    rate.max = '2';
    rate.step = '0.05';
    var startR = Number(prefs().rate);
    rate.value = String(isFinite(startR) && startR >= 0.7 && startR <= 2 ? startR : 1);
    rateWrap.appendChild(rate);
    vendorIn.appendChild(rateWrap);

    var exeOut = document.createElement('div');
    exeOut.className = 'qs-sub qs-sub--exe';
    vendorIn.appendChild(exeOut);

    head.appendChild(vendorBox);

    var out = document.createElement('div');
    out.className = 'qs-out';
    head.appendChild(out);

    /* THE QUOTE AS A CARD (prof-v282, Marek 2026-10-27: the AI reel's UI
       "presne takto" in LEVA, step 3). What goes out, the way the AI reel
       shows it: who, the biggest priced lines with their unit prices, the
       labour (hours and the hour's price), how many more lines, the total
       counted up. It replaces the bare total above; every figure is the
       sheet's own (qsPickedTotals / qsCardLines), so card = what is sent. */
    out.style.display = 'none';
    var card = document.createElement('div');
    card.className = 'qs-card';
    card.innerHTML = '<div class="qs-card__kick"></div><div class="qs-card__who"></div><div class="qs-card__rows"></div>'
      + '<div class="qs-card__more"></div><div class="qs-card__tot"><span></span><b></b></div>';
    head.appendChild(card);
    var cardShown = 0;
    function cardCount(el, to) {
      var from = cardShown, t0 = 0;
      cardShown = to;
      if (!window.requestAnimationFrame || Math.abs(to - from) < 1) { el.textContent = qsMoney(to); return; }
      function frame(ts) {
        if (!t0) t0 = ts;
        var f = Math.min(1, (ts - t0) / 500), e = 1 - Math.pow(1 - f, 3);
        el.textContent = qsMoney(from + (to - from) * e);
        if (f < 1) window.requestAnimationFrame(frame);
      }
      window.requestAnimationFrame(frame);
    }
    function paintCard(k, sums, matSum, exeSum) {
      if (sums.material === null && sums.execution === null) { card.hidden = true; return; }
      card.hidden = false;
      card.querySelector('.qs-card__kick').textContent = T.rq.qHead || 'Your quote';
      var place = '';
      try { place = shortPlace(qt.doc && qt.doc.place) || ''; } catch (eP) {}
      card.querySelector('.qs-card__who').textContent = [String(vName.value || '').trim(), place].filter(Boolean).join(' \u00b7 ');
      var box = card.querySelector('.qs-card__rows');
      box.innerHTML = '';
      var lines = qsCardLines(k), show = Math.min(4, lines.length);
      function row(name, qty, field) {
        var r = document.createElement('div');
        r.className = 'qs-card__r';
        var n = document.createElement('span'); n.className = 'qs-card__n'; n.textContent = name;
        var q = document.createElement('span'); q.className = 'qs-card__q'; q.textContent = qty;
        var f = document.createElement('span'); f.className = 'qs-card__f'; f.textContent = field;
        r.appendChild(n); r.appendChild(q); r.appendChild(f);
        box.appendChild(r);
      }
      for (var i = 0; i < show; i++) {
        var L = lines[i];
        row(window.__levaRowItem ? window.__levaRowItem(L.row) : String(L.row[3] || L.row[0]),
            Math.round(L.units * 100) / 100 + (L.unitName ? (' ' + L.unitName) : ''),
            qsMoney(L.unitPrice, L.unitPrice < 100));
      }
      var hrs = sums.hours;
      if (exeSum > 0 && hrs > 0) {
        var hu = T.rq.hoursUnit || 'h';
        row(T.rq.execution || 'Execution', Math.round(hrs).toLocaleString() + ' ' + hu, qsMoney(exeSum / hrs) + '/' + hu);
      }
      card.querySelector('.qs-card__more').textContent = lines.length > show ? ('+ ' + (lines.length - show)) : '';
      card.querySelector('.qs-card__tot span').textContent = T.rq.total || 'Total';
      cardCount(card.querySelector('.qs-card__tot b'), matSum + exeSum);
    }

    /* Two coefficients cannot be shown on one number: materials move with
       one, execution with the other. Both are read from the budget as it
       stands and added up, so the figure below the sliders is what the
       other side will see. */
    function readNum(sel) {
      var el = document.querySelector(sel);
      if (!el) return null;
      var raw = (el.textContent || '').replace(/[^0-9.,]/g, '');
      if (!raw) return null;
      var dot = raw.lastIndexOf('.');
      var com = raw.lastIndexOf(',');
      var dec = Math.max(dot, com);
      var n = (dec !== -1 && dot !== com && (raw.length - dec - 1) <= 2)
        ? parseFloat(raw.slice(0, dec).replace(/[.,]/g, '') + '.' + raw.slice(dec + 1))
        : parseFloat(raw.replace(/[.,]/g, ''));
      return isFinite(n) ? n : null;
    }

    function preview() {
      var k = Number(coef.value);
      if (!isFinite(k) || k <= 0) k = 1;
      coefOut.textContent = k.toFixed(2).replace(/0$/, '');

      var r = Number(rate.value);
      if (!isFinite(r) || r <= 0) r = 1;
      rateOut.textContent = r.toFixed(2).replace(/0$/, '');

      var picked2 = qsPickedTotals();
      var mat = picked2.material;
      var exe = picked2.execution;
      if (mat === null && exe === null) {
        out.textContent = '';
        matOut.textContent = '';
        exeOut.innerHTML = '';
        paintCard(k, picked2, 0, 0);
        return;
      }
      var matSum = (mat || 0) * k;
      var exeSum = (exe || 0) * r;
      matOut.textContent = mat === null ? '' : Math.round(matSum).toLocaleString();

      /* Hours belong beside the money they buy, and they carry no
         coefficient -- the rate moves, the work does not. */
      exeOut.innerHTML = '';
      if (exe !== null) {
        exeOut.appendChild(document.createTextNode(Math.round(exeSum).toLocaleString()));
        var hrs = picked2.hours;
        if (hrs !== null) {
          var sep = document.createElement('span');
          sep.className = 'qs-sub__sep';
          sep.textContent = '/';
          exeOut.appendChild(sep);
          var hEl = document.createElement('span');
          hEl.className = 'qs-sub__h';
          hEl.textContent = Math.round(hrs).toLocaleString() + ' h';
          exeOut.appendChild(hEl);
        }
      }
      out.textContent = Math.round(matSum + exeSum).toLocaleString();
      paintCard(k, picked2, matSum, exeSum);
    }
    vName.addEventListener('input', function () { preview(); });

    /* Ticking a trade off has to move the number under the slider at once,
       or the sheet promises one thing and sends another -- the same gap as
       the empty sandbox, in a new place. */
    recount = preview;

    coef.addEventListener('input', preview);
    rate.addEventListener('input', preview);
    preview();

    var validWrap = document.createElement('label');
    validWrap.className = 'qs-field';
    validWrap.textContent = T.rq.qValid;
    var valid = document.createElement('select');
    var opts = [[30, T.rq.qD30], [60, T.rq.qD60], [90, T.rq.qD90]];
    for (var i = 0; i < opts.length; i++) {
      var opt = document.createElement('option');
      opt.value = String(opts[i][0]);
      opt.textContent = opts[i][1];
      valid.appendChild(opt);
    }
    valid.value = String(prefs().days || 30);
    validWrap.appendChild(valid);
    head.appendChild(validWrap);

    var send = document.createElement('button');
    send.type = 'button';
    send.className = 'rq-send rq-send--card';
    send.textContent = T.rq.quoteSend;

    var msg = document.createElement('div');
    msg.className = 'rq-msg';

    send.addEventListener('click', function () {
      var k = Number(coef.value);
      var r = Number(rate.value);
      qt.coef = (isFinite(k) && k > 0) ? k : 1;
      qt.rateCoef = (isFinite(r) && r > 0) ? r : 1;
      qt.validDays = Number(valid.value) || 30;
      qt.vendorName = vName.value.trim();
      qt.vendorPhone = vPhone.value.trim();
      savePrefs(qt.coef, qt.validDays, qt.rateCoef);
      send.disabled = true;
      /* bic-v186: what the card shows, for the AI drawer's copy of it */
      var sentCard = null;
      try {
        var sc = qsPickedTotals(), scl = qsCardLines(qt.coef), scL = [];
        for (var si = 0; si < scl.length && si < 4; si++) {
          scL.push({ name: window.__levaRowItem ? window.__levaRowItem(scl[si].row) : String(scl[si].row[3] || scl[si].row[0]),
                     qty: Math.round(scl[si].units * 100) / 100, unit: scl[si].unitName, price: scl[si].unitPrice });
        }
        var scM = (sc.material || 0) * qt.coef, scE = (sc.execution || 0) * qt.rateCoef;
        sentCard = { id: qt.id || '', to: (qt.doc && (qt.doc.fromName || qt.doc.fromEmail)) || '', place: shortPlace(qt.doc && qt.doc.place) || '',
                     vendor: qt.vendorName || '', lines: scL, more: Math.max(0, scl.length - scL.length),
                     material: scM, execution: scE, hours: sc.hours || 0, total: scM + scE, unsolicited: !!qt.unsolicited };
      } catch (eS) { sentCard = null; }

      sendQuote(function (err) {
        send.disabled = false;
        if (err) {
          msg.textContent = String(err.message || err);
          return;
        }
        if (sentCard) { try { window.dispatchEvent(new CustomEvent('leva:quote-sent', { detail: sentCard })); } catch (eV2) {} }
        msg.textContent = qt.unsolicited
          ? ((T.rq && T.rq.offerSent) || 'Offer sent.')
          : T.rq.quoteSent;
        msg.classList.add('rq-msg--done');
        card.classList.add('qs-card--sent');
        // the offer is out; there is nothing left to press
        if (send.parentNode) send.parentNode.removeChild(send);
        // the banner above has nothing left to refuse
        var slot = box.closest ? box.closest('.rq-slot') : null;
        if (slot) {
          var bn = slot.querySelector('.rq-bn');
          var bin = slot.querySelector('.rq-act--bin');
          if (bin && bin.parentNode) bin.parentNode.removeChild(bin);
          if (bn && !bn.querySelector('.rq-act--ok')) {
            var okIc = rowIcon('ok', T.rq.quoteSent, function () {});
            okIc.classList.add('rq-bn__act');
            okIc.style.cursor = 'default';
            bn.appendChild(okIc);
          }
        }
      });
    });

    head.appendChild(send);
    head.appendChild(msg);
    termsLine(head, (T.rq && T.rq.termsQuote) || 'By sending this quote you agree to our');

    box.appendChild(head);
  }

  // the sheet remembers how this vendor works
  function prefs() {
    try {
      return JSON.parse(localStorage.getItem('leva_quote_prefs') || '{}') || {};
    } catch (e) { return {}; }
  }

  function savePrefs(coef, days, rate) {
    try {
      localStorage.setItem('leva_quote_prefs',
        JSON.stringify({ coef: coef, days: days, rate: rate }));
    } catch (e) {}
  }

  /* ============================================================
     W3  OFFERS FROM A VENDOR
     A vendor prices a project of their own and sends the link. The
     customer opens it, sees the model and the prices, and decides. The
     bar belongs to them, and taking the prices is the ordinary import.
     ============================================================ */
  function offerId() {
    return 'of' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  }

  function sendOffer() {
    if (!window.db) return;
    if (!window.customerId) { askToRegister(); return; }

    var to = window.prompt(T.rq.sendTo, '');
    if (!to) return;
    var list = String(to).split(/[,;\s]+/);
    var mails = [];
    for (var i = 0; i < list.length; i++) {
      var one = list[i].trim();
      if (one && one.indexOf('@') > 0) mails.push(one.toLowerCase());
    }
    if (!mails.length) return;

    var id = offerId();
    var url = projectUrl(id, 'leva_offer');
    var snap = collectQuote();
    var payload = {
      status: 'sent',
      createdAt: new Date(),
      fromEmail: String(window.customerEmail || '').toLowerCase(),
      fromCustomerId: String(window.customerId),
      // the enquiry identity, not the one on the public card
      fromName: rqMeVal('name'),
      toEmails: mails,
      projectUrl: url,
      productHandle: (window.shareProductContext && window.shareProductContext.handle) || '',
      configId: (function () {
        try { return new URL(window.location.href).searchParams.get('cfg') || ''; }
        catch (e) { return ''; }
      })(),
      materials: snap.materials,
      execution: snap.execution
    };

    window.db.collection('offers').doc(id).set(payload).then(function () {
      var body = ''
        + (payload.fromName ? (payload.fromName + '\n\n') : '')
        + (payload.note ? (payload.note + '\n\n') : '')
        + url + '\n';
      window.location.href = 'mailto:' + encodeURIComponent(mails.join(','))
        + '?subject=' + encodeURIComponent(T.rq.offerSubject)
        + '&body=' + encodeURIComponent(body);
    }).catch(function (e) { console.error('offer save failed', e); });
  }

  function showOfferBar(id, o) {
    rqStyle();
    var old = document.querySelector('.rq-bar');
    if (old) old.parentNode.removeChild(old);

    var bar = document.createElement('div');
    bar.className = 'rq-bar';

    var txt = document.createElement('div');
    txt.className = 'rq-bar__txt';
    txt.textContent = T.rq.offerPrompt;
    var who = document.createElement('span');
    who.className = 'rq-bar__who';
    who.textContent = o.fromEmail || '';
    txt.appendChild(who);
    bar.appendChild(txt);

    var no = document.createElement('button');
    no.type = 'button';
    no.className = 'rq-bar__b rq-bar__b--no';
    no.appendChild(tick('no'));
    no.addEventListener('click', function () {
      if (bar.parentNode) bar.parentNode.removeChild(bar);
    });
    bar.appendChild(no);

    // taking the prices is the same import a shared budget uses
    var yes = document.createElement('button');
    yes.type = 'button';
    yes.className = 'rq-bar__b rq-bar__b--yes';
    yes.title = T.rq.offerTake;
    yes.appendChild(tick('yes'));
    yes.addEventListener('click', function () {
      vd.data = {
        materials: o.materials || {},
        execution: o.execution || {},
        hourlyRatesByCategory: o.hourlyRatesByCategory || {}
      };
      vd.token = id;
      vd.owner = String(o.fromCustomerId || '');
      vd.name = o.fromEmail || '';
      if (vd.open) closeVendor();
      var d = prepVendor();
      if (!d) return;
      raise(d);
      paintWho(d, null);
      d.querySelector('[data-vd-msg]').textContent = '';
      d.classList.add('active');
      document.body.classList.add('open-cc');
      showVendorBudget(vd.data);
      if (bar.parentNode) bar.parentNode.removeChild(bar);
      /* Once the prices are theirs, the project is theirs to change: the
         offer marker leaves the address so nothing re-opens this bar, and
         every edit prices itself against the rates just taken. */
      try {
        var u2 = new URL(window.location.href);
        u2.searchParams.delete('leva_offer');
        window.history.replaceState(null, '', u2.toString());
      } catch (e) {}
    });
    bar.appendChild(yes);

    document.body.appendChild(bar);
  }

  function checkOfferParam() {
    var id = '';
    try {
      id = new URL(window.location.href).searchParams.get('leva_offer') || '';
    } catch (e) {}
    if (!id || !window.db) return;

    window.db.collection('offers').doc(id).get().then(function (doc) {
      if (!doc.exists) return;
      showOfferBar(id, doc.data() || {});
    }).catch(function () {});
  }

  function checkQuoteParam() {
    var id = '';
    try {
      id = new URL(window.location.href).searchParams.get('leva_quote') || '';
    } catch (e) {}
    if (!id || !window.db) return;

    window.db.collection('quotes').doc(id).get().then(function (doc) {
      if (!doc.exists) return;
      withMyAnswer(id, doc.data() || {}, function (q) {
      /* bic-v188: a shared request this supplier answered or declined is done for him */
      if (isGroupFor(q) && groupDeclined(q)) return;
      if (q.status && q.status !== 'pending') return;
      qt.id = id;
      qt.doc = q;
      emptyBudget();
      showQuoteBar(id, q);
      /* bic-v186: the AI drawer shows the request as a card with PRICE IT */
      try { window.dispatchEvent(new CustomEvent('leva:quote-request', { detail: { id: id } })); } catch (eV) {}
      });
    }).catch(function () {});
  }

  /* ============================================================
     UNREAD MARKS ON THE FLOATING BAR
     Nothing is counted up anywhere. Each icon asks its own
     collections for what belongs to this product, throws away
     everything older than the mark this customer carries in
     public_data.seen, and shows what is left. Opening a drawer
     moves that mark to now, which is what makes the number go.
     ============================================================ */
  var seenMap = null;
  var seenLoaded = false;

  function badgeHandle() {
    return (window.shareProductContext && window.shareProductContext.handle) || '';
  }

  function seenRef() {
    if (!window.db || !window.customerId) return null;
    return window.db.collection('public_data').doc(String(window.customerId));
  }

  function toMillis(v) {
    if (!v) return 0;
    if (typeof v === 'number') return v;
    if (v.seconds) return v.seconds * 1000;
    if (v.toDate) { try { return v.toDate().getTime(); } catch (e) { return 0; } }
    var t = Date.parse(v);
    return isFinite(t) ? t : 0;
  }

  function loadSeen(cb) {
    if (seenLoaded) { cb(seenMap || {}); return; }
    var ref = seenRef();
    if (!ref) { seenLoaded = true; seenMap = {}; cb(seenMap); return; }
    ref.get().then(function (doc) {
      var d = doc.exists ? (doc.data() || {}) : {};
      seenMap = d.seen || {};
      seenLoaded = true;
      cb(seenMap);
    }).catch(function () {
      seenLoaded = true;
      seenMap = {};
      cb(seenMap);
    });
  }

  function seenAt(kind) {
    var h = badgeHandle();
    if (!h || !seenMap) return 0;
    return toMillis(seenMap[kind + ':' + h]);
  }

  /* PER CARD, NOT PER DRAWER. One mark for the whole quotes drawer meant
     that opening it declared everything inside read -- so the counts on
     the tabs were zero by the time they were drawn, and an answer nobody
     had looked at stopped being news simply because the list containing
     it had been on screen. A card is read when it is opened. */
  function rowSeenAt(id) {
    if (!seenMap || !id) return 0;
    return toMillis(seenMap['row:' + id]);
  }

  function markRowSeen(id) {
    if (!id) return;
    var ref = seenRef();
    if (!ref) return;
    if (!seenMap) seenMap = {};
    var key = 'row:' + id;
    if (seenMap[key]) return;
    seenMap[key] = Date.now();
    var patch = { seen: {} };
    patch.seen[key] = new Date();
    ref.set(patch, { merge: true }).catch(function () {});
  }

  /* Reading is not answering. The mark moves, so news stops being news --
     but anything still waiting on this person survives it, and the count
     is worked out again rather than simply zeroed. */
  function markSeen(kind) {
    var h = badgeHandle();
    if (!h) return;
    var ref = seenRef();
    if (!ref) return;
    var key = kind + ':' + h;
    if (!seenMap) seenMap = {};
    seenMap[key] = Date.now();
    var patch = { seen: {} };
    patch.seen[key] = new Date();
    ref.set(patch, { merge: true }).catch(function () {});
    paintBadges();
  }

  function showBadge(kind, n) {
    if (typeof window.LevaFloatBadge === 'function') window.LevaFloatBadge(kind, n);
  }

  /* Shared budgets for this product, the same pair of reads the list
     itself does. My own budget never counts as news to me. */
  function countShared() {
    var h = badgeHandle();
    if (!h || !window.db) return;
    var coll = window.db.collection('budget_details');
    var mine = String(window.customerId || '');
    Promise.all([
      coll.where('isPublic', '==', true).where('type', '==', 'product').where('productHandle', '==', h).get(),
      coll.where('isPublic', '==', false).where('type', '==', 'product').where('productHandle', '==', h).get()
    ]).then(function (results) {
      var seenIds = {};
      var n = 0;
      results.forEach(function (snap) {
        snap.forEach(function (doc) {
          if (seenIds[doc.id]) return;
          seenIds[doc.id] = true;
          var d = doc.data() || {};
          if (d.shareVisibility === 'unpublished') return;
          if (mine && String(d.customerId || '') === mine) return;
          /* HOW MANY THERE ARE, NOT HOW MANY ARE NEW. The date test made
             the badge a notification -- it emptied as soon as the drawer
             had been opened once, so the icon said nothing about the fact
             that eleven budgets are sitting there to be looked at. */
          n++;
        });
      });
      showBadge('shared', n);
    }).catch(function () {});
  }

  /* The quotes drawer holds three lists, so its mark counts all three:
     an answer to a quote I sent, an offer addressed to me, and a
     request still waiting on my word. */
  function countQuotes(since) {
    var h = badgeHandle();
    var me = myMail();
    if (!h || !me || !window.db) return;
    var total = 0;
    var left = 3;

    function done() {
      left--;
      if (left === 0) showBadge('quotes', total);
    }

    /* The same collection carries both directions of the trade: an answer
       coming back to whoever asked, and an enquiry arriving at whoever was
       asked. Only the first was counted, so a vendor's own drawer never lit
       up for the one thing they need to see. */
    quotesForMe(function (rows) {
      rows.forEach(function (doc) {
        var q = doc.q;
        if (q.status === 'discarded') return;
        if (!forThisProduct(q)) return;

        // an answer to something I sent
        if (String(q.fromEmail || '').toLowerCase() === me) {
          if (q.answeredAt && toMillis(q.answeredAt) > rowSeenAt(doc.id)) total++;
          return;
        }

        // an enquiry sent to me, still waiting for my price
        var mine = String(q.vendorEmail || '').toLowerCase() === me;
        if (!mine) {
          var vs = q.vendorEmails || [];
          for (var i = 0; i < vs.length; i++) {
            if (String(vs[i] || '').toLowerCase() === me) { mine = true; break; }
          }
        }
        if (!mine) return;

        /* ASKING AGAIN IS ASKING. A second enquiry on the same record sets
           the status back to pending but leaves answeredAt where it was, so
           testing for that field marked an actualisation as dealt with and
           the vendor was never told. What decides is whether the answer is
           older than the question.
           No date test against the seen mark either: work owed is owed
           whether it arrived this morning or last week, and a badge that
           clears on opening the drawer hides the very thing it is for. */
        if (q.status === 'declined' || q.status === 'discarded') return;
        var askedAt = toMillis(q.createdAt);
        var saidAt = toMillis(q.answeredAt);
        if (saidAt && askedAt && saidAt >= askedAt) return;
        if (saidAt && !askedAt) return;
        total++;
      });
      done();
    });

    offersForMe(function (rows) {
      rows.forEach(function (doc) {
        var o = doc.q;
        if (!forThisProduct(o)) return;
        var to = o.toEmails || [];
        var hit = false;
        for (var i = 0; i < to.length; i++) {
          if (String(to[i] || '').toLowerCase() === me) hit = true;
        }
        if (!hit) return;
        if (toMillis(o.createdAt) <= since) return;
        total++;
      });
      done();
    });

    qOne('requests', 'vendorEmail', '==', me).then(function (rows) {
      rows.forEach(function (doc) {
        var r = doc.q;

        // undecided is undecided, however long it has been sitting there
        if (!r.status || r.status === 'pending') { total++; return; }

        // and a grant with a week left is a decision waiting to be made
        if (r.status !== 'approved') return;
        var until = toMillis(r.grantUntil);
        if (!until || until <= Date.now()) return;
        if ((until - Date.now()) > 7 * 86400000) return;
        total++;
      });
      done();
    }).catch(done);
  }

  function paintBadges() {
    if (!badgeHandle() || !window.db) return;
    loadSeen(function () {
      countShared();
      countQuotes(seenAt('quotes'));
    });
  }

  function openBudget() {
    close();
    closeQuotes();
    closeShareDrawer();
    if (typeof window.openBudgetMainDrawer === 'function') window.openBudgetMainDrawer();
  }

  window.LevaBudgetIcons = {
    version: VERSION,
    budget: function () { openBudget(); },
    share: function () { shareProfile(); },
    shared: function () { open(); },
    quotes: function () { openQuotes(); }
  };

  /* THE ASSISTANT HANDS OVER A FINISHED REQUEST. It knows which items have
     no price and can write the note; what it cannot do is fill a form that
     only exists after a tap. So it passes the address and the text, and this
     opens the drawer on the request tab and unfolds the form with both
     already in place. Everything else is the sender's own details, which the
     form remembers from the last request. */
  /* bic-v186 THE REQUEST FROM THE AI DRAWER IS A TRACKED REQUEST (Marek
     2026-10-27 14:37: v reel kdyz chci poslat poptavku, tak uvidim text a
     pak az send tlacitko, takze hned vidim co posilam -- vsechno z reel, i
     pro poptavajiciho i pro dodavatele). The drawer's card used to open a
     mail with the project link only: nothing was recorded, so an answer
     could never come back to be compared. sendTracked writes the same
     quotes record as the request form (buildRequestForm) and opens the same
     mail (sendRequestMail) with the record's link. The sender's name, phone
     and place come from the form's own memory (rqMe); what is missing is
     reported back, the drawer asks for it in its card. */
  function aiSender(opts) {
    opts = opts || {};
    return {
      name: String(opts.name || rqMeVal('name') || '').trim(),
      phone: String(opts.phone || rqMeVal('phone') || '').trim(),
      place: String(opts.place || rqMeVal('place') || '').trim(),
      email: String(opts.email || window.customerEmail || rqMeVal('email') || '').trim()
    };
  }
  function aiSubject(place) {
    var subject = (T.rq && T.rq.subject) || 'Price request';
    var name = projectName(), town = townOf(place);
    if (name) subject += ': ' + name;
    if (town) subject += ' - ' + town;
    return subject;
  }

  /* bic-v189: what is offered, set as the sheet sets it (buildQuoteFields)
     when the sheet was never opened -- the trades he declared, else every
     priced one */
  function aiQuoteReady() {
    if (!qt.id || !qt.doc) return false;
    /* set here while the sheet never set it (the budget rows may arrive
       after the first look, so it is set again until the sheet takes over) */
    if (!qt.offered || qt.offered === qt.aiOffered) {
      var offered = qsOffered(), picked = {}, declared = null, i;
      if (window.__levaSavedTrades && window.__levaSavedTrades.length) {
        declared = {};
        for (i = 0; i < window.__levaSavedTrades.length; i++) declared[String(window.__levaSavedTrades[i]).toLowerCase()] = true;
      }
      for (i = 0; i < offered.length; i++) picked[offered[i].sub] = declared ? !!declared[offered[i].sub.toLowerCase()] : true;
      qt.offered = offered;
      qt.aiOffered = offered;
      qt.picked = picked;
      qt.pickedIds = null;
    }
    return true;
  }

  window.LevaQuotes = {
    version: VERSION,
    me: function () { return aiSender({}); },
    setMe: function (key, value) { if (key === 'name' || key === 'phone' || key === 'place' || key === 'email') rqMeSet(key, value); },
    labels: function () {
      var r = T.rq || {};
      return { name: r.myName, phone: r.myPhone, place: r.place, email: r.myEmail, sendTo: r.sendTo,
               needName: r.needName, needPhone: r.needPhone, needPlace: r.needPlace, needEmail: r.needEmail,
               sent: r.sent, quotePrompt: r.quotePrompt, quoteSend: r.quoteSend, quoteSent: r.quoteSent,
               qHead: r.qHead, total: r.total, hoursUnit: r.hoursUnit, execution: r.execution,
               qCoef: r.qCoef, qCoefRate: r.qCoefRate, offerSent: r.offerSent };
    },
    preview: function (opts) {
      var me = aiSender(opts);
      return { subject: aiSubject(me.place), me: me };
    },
    sendTracked: function (opts, cb) {
      cb = cb || function () {};
      opts = opts || {};
      var to = [];
      var list = [].concat(opts.to || []);
      for (var i = 0; i < list.length; i++) {
        var one = String(list[i] || '').trim().toLowerCase();
        if (one && one.indexOf('@') > 0 && to.indexOf(one) < 0) to.push(one);
      }
      var me = aiSender(opts), missing = [];
      if (!to.length) missing.push('to');
      if (!me.name) missing.push('name');
      if (!me.email) missing.push('email');
      if (!me.phone) missing.push('phone');
      if (!me.place) missing.push('place');
      if (missing.length || !window.db) { cb({ ok: false, missing: missing, why: window.db ? '' : 'no database on this page' }); return; }
      var id = existingQuoteId(to[0]) || quoteId();
      var url = projectUrl(id, 'leva_quote');
      var payload = {
        status: 'pending',
        createdAt: new Date(),
        fromCustomerId: window.customerId ? String(window.customerId) : '',
        fromName: me.name,
        fromEmail: me.email,
        vendorEmail: to[0],
        vendorEmails: to,
        vendorId: '',
        phone: me.phone,
        place: me.place,
        note: String(opts.note || '').trim(),
        projectUrl: url,
        budgetToken: '',
        productHandle: (window.shareProductContext && window.shareProductContext.handle) || '',
        configId: (function () {
          try { return new URL(window.location.href).searchParams.get('cfg') || ''; }
          catch (e) { return ''; }
        })(),
        variantId: (window.currentVariantId ? String(window.currentVariantId) : ''),
        via: 'ai'
      };
      window.db.collection('quotes').doc(id).set(payload, { merge: true }).then(function () {
        quoteByEmail[to[0]] = id;
        cb({ ok: true, id: id, url: url });
        if (to.length < 2) { sendRequestMail(to.join(','), url, payload, 'quotes'); return; }
        /* bic-v187: several suppliers -- one mail, the sender in To, the
           suppliers in Bcc, one link; each answer is kept apart (writeQuote) */
        var body = ''
          + (payload.note ? (payload.note + '\n\n') : '')
          + (payload.fromName ? (payload.fromName + '\n') : '')
          + 'Phone: ' + (payload.phone || '') + '\n'
          + 'Place: ' + (payload.place || '') + '\n'
          + 'Email: ' + (payload.fromEmail || '') + '\n'
          + '\n' + url + '\n';
        window.location.href = 'mailto:' + encodeURIComponent(me.email)
          + '?bcc=' + encodeURIComponent(to.join(','))
          + '&subject=' + encodeURIComponent(aiSubject(me.place))
          + '&body=' + encodeURIComponent(body);
      }).catch(function (e) {
        cb({ ok: false, missing: [], why: String((e && e.message) || e) });
      });
    },
    /* the supplier's side: the request this ?leva_quote page was opened for */
    current: function () {
      if (!qt.id || !qt.doc || qt.unsolicited) return null;
      var q = qt.doc;
      return { id: qt.id, fromName: q.fromName || q.fromEmail || '', place: shortPlace(q.place) || q.place || '',
               note: q.note || '', status: q.status || '' };
    },
    priceIt: function () {
      if (!qt.id || !qt.doc) return false;
      openQuoteSheet(qt.id, qt.doc);
      return true;
    },
    /* bic-v189 THE OFFER IN A FEW CLICKS, FROM THE AI DRAWER (the reel's
       supplier step): the request priced from his own budget at once, two
       coefficients, send. Same arithmetic, same record as the sheet. */
    quotePreview: function (k, r) {
      if (!aiQuoteReady()) return null;
      k = (isFinite(k) && k > 0) ? k : 1;
      r = (isFinite(r) && r > 0) ? r : 1;
      var t = qsPickedTotals(), lines = qsCardLines(k), L = [];
      for (var i = 0; i < lines.length && L.length < 3; i++) {
        /* the name with its pi kept: the drawer puts the catalogue's size note there (ai cardName) */
        var lc = langCol(), rw = lines[i].row;
        L.push({ id: String(rw[0] || ''), name: String((lc && rw[lc + 40]) || rw[3] || rw[0] || '').trim(),
                 qty: Math.round(lines[i].units * 100) / 100, unit: lines[i].unitName, price: lines[i].unitPrice });
      }
      var mat = (t.material || 0) * k, exe = (t.execution || 0) * r, hrs = t.hours || 0, p = prefs();
      return { lines: L, more: Math.max(0, lines.length - L.length), material: mat, execution: exe, hours: hrs,
               rate: hrs > 0 ? exe / hrs : 0, total: mat + exe, priced: lines.length,
               hasPrices: ((t.material || 0) + (t.execution || 0)) > 0,
               start: { coef: Number(p.coef) || 1, rate: Number(p.rate) || 1 } };
    },
    sendQuote: function (o, cb) {
      cb = cb || function () {};
      if (!aiQuoteReady()) { cb(new Error('no request on this page')); return; }
      /* an offer with nothing of his in it is not sent from the drawer */
      var t0 = qsPickedTotals();
      if (!(((t0.material || 0) + (t0.execution || 0)) > 0)) { cb(new Error('nothing priced')); return; }
      o = o || {};
      var k = Number(o.coef), r = Number(o.rateCoef);
      qt.coef = (isFinite(k) && k > 0) ? k : 1;
      qt.rateCoef = (isFinite(r) && r > 0) ? r : 1;
      qt.validDays = Number(prefs().days) || 30;
      if (o.name) rqMeSet('name', o.name);
      if (o.phone) rqMeSet('phone', o.phone);
      qt.vendorName = String(o.name || rqMeVal('name') || '').trim();
      qt.vendorPhone = String(o.phone || rqMeVal('phone') || '').trim();
      savePrefs(qt.coef, qt.validDays, qt.rateCoef);
      sendQuote(function (err) { cb(err || null); });
    },
    open: function () { openQuotes(); },
    /* FOR THE BUDGET TOUR (bic-v183, btour-v3, Marek: sharing budget a
       quotes nefunguje, je porad otevreny budget drawer): the drawer shown
       over the open budget drawer -- painted on the requests tab, nothing
       closed under it and nothing marked as seen (openQuotes clears the
       envelope's news, which a tour must not do) -- and taken away again */
    peek: function () {
      var d = document.getElementById('Leva-Quotes-Drawer');
      if (!d) return false;
      raise(d);
      qTab = 'requests';
      try { paintQuotes(d); } catch (e) {}
      d.classList.add('active');
      return true;
    },
    unpeek: function () {
      var d = document.getElementById('Leva-Quotes-Drawer');
      if (d) d.classList.remove('active');
    },
    prefill: function (opts) {
      opts = opts || {};
      try {
        if (opts.to) window.__levaQuoteVendorEmail = String(opts.to);
        if (opts.note) window.__levaQuoteNote = String(opts.note);
      } catch (e) {}

      qTab = 'requests';
      openQuotes();

      var d = document.getElementById('Leva-Quotes-Drawer');
      if (!d) return false;

      /* The form is built by the button, not by the drawer, so the tap has
         to be made rather than imitated. */
      var tries = 0;
      (function unfold() {
        var btn = d.querySelector('.rq-open .rq-send');
        if (btn) { btn.click(); return; }
        if (++tries > 20) return;
        setTimeout(unfold, 80);
      })();
      return true;
    }
  };

  checkRequestParam();
  checkQuoteParam();
  checkOfferParam();

  // a restored page keeps whoever was signed in when it was stored
  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted) window.location.reload();
  });

  mount();
  var timer = null;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(mount, 200);
  }).observe(document.body, { childList: true, subtree: true });
  console.log(VERSION + ' ready');
})();